{
  "_meta": {
    "locale": "en",
    "status": "complete",
    "note": "Reference catalog. Every key must exist here."
  },
  "app": {
    "name": "AVRASTRO",
    "tagline": "Advisor OS",
    "workspace": "Workspace",
    "update_ready": "A new version of AVRASTRO is ready. Press «Reload» to use it.",
    "update_reload": "Reload"
  },
  "nav": {
    "today": "Now",
    "people": "People",
    "cases": "Cases",
    "agenda": "Agenda",
    "reviews": "Reviews",
    "prospects": "Prospecting",
    "insights": "Insights",
    "data": "Data & safety",
    "settings": "Settings",
    "lens": "Lens",
    "comparator": "Comparator",
    "service": "Service & claims",
    "pipeline": "Pipeline",
    "decisions": "Decisions",
    "referrals": "Referrals",
    "needs": "Needs analysis",
    "quotes": "Quotations",
    "proposals": "Proposals",
    "business": "Business center",
    "quality": "Data quality",
    "compliance": "Compliance",
    "templates": "Templates",
    "day": "My day",
    "renewals": "Renewals",
    "retention": "Retention",
    "vault": "Documents",
    "campaigns": "Campaigns",
    "protection": "Protection",
    "tax": "Tax Center",
    "production": "Production",
    "assistant": "Ask AVRASTRO",
    "automations": "Automations",
    "fields": "Custom fields",
    "sync": "Sync",
    "security": "Security",
    "account": "Account",
    "team": "Team",
    "branding": "Branding",
    "radar": "Opportunities",
    "analytics": "Growth analytics",
    "inbox": "Website inbox",
    "portal": "Client portal",
    "groups": "Group plans",
    "drafts": "AI drafts",
    "register": "Client list",
    "setup": "Setup wizard",
    "help": "Help",
    "lessons": "Lessons",
    "salefiles": "Sale files",
    "calls": "Prospecting calls",
    "callstats": "My improvement",
    "gaps": "Protection-gap map",
    "auditpack": "Audit pack",
    "performance": "Monthly performance",
    "studio": "AI Studio",
    "taxfolder": "My tax folder"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "new": "New",
    "back": "Back",
    "open": "Open",
    "confirm": "Confirm",
    "search": "Search",
    "filter": "Filter",
    "all": "All",
    "none": "None",
    "yes": "Yes",
    "no": "No",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "yesterday": "Yesterday",
    "loading": "Loading…",
    "saved": "Saved",
    "error": "Something went wrong",
    "optional": "optional",
    "more": "More",
    "less": "Less",
    "details": "Details",
    "done": "Done",
    "reopen": "Reopen",
    "export": "Export",
    "import": "Import",
    "print": "Print",
    "download": "Download",
    "copy": "Copy",
    "copied": "Copied",
    "call": "Call",
    "email": "Email",
    "whatsapp": "WhatsApp",
    "sms": "SMS",
    "not_set": "Not set",
    "unknown": "Unknown",
    "empty": "Nothing here yet",
    "name": "Name",
    "phone": "Phone",
    "notes": "Notes",
    "date": "Date",
    "time": "Time",
    "status": "Status",
    "priority": "Priority",
    "type": "Type",
    "person": "Person",
    "all_people": "All people",
    "select_person": "Select a person…",
    "required": "Required",
    "continue": "Continue",
    "undo": "Undo",
    "view_all": "View all",
    "items": "{count, plural, one {# item} other {# items}}",
    "days": "{count, plural, one {# day} other {# days}}",
    "unsaved": "Unsaved changes",
    "keyboard_hint": "Press {key}",
    "nothing_to_undo": "Nothing to undo",
    "active": "Active",
    "inactive": "inactive",
    "next": "Next",
    "deleted": "Deleted",
    "remove": "Remove"
  },
  "enum": {
    "stage": {
      "lead": "Lead",
      "prospect": "Prospect",
      "client": "Client",
      "former": "Former client",
      "dependent": "Dependent"
    },
    "branch": {
      "life": "Life & health",
      "general": "General"
    },
    "policyStatus": {
      "offer": "Offer",
      "pending": "Pending",
      "active": "Active",
      "renewed": "Renewed",
      "lapsed": "Lapsed",
      "cancelled": "Cancelled",
      "matured": "Matured"
    },
    "frequency": {
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "semiannual": "Semi-annual",
      "annual": "Annual",
      "single": "Single premium"
    },
    "caseStage": {
      "draft": "Draft",
      "submitted": "Submitted",
      "documents": "Documents",
      "underwriting": "Underwriting",
      "decision": "Decision",
      "issued": "Issued",
      "declined": "Declined",
      "postponed": "Postponed",
      "withdrawn": "Withdrawn"
    },
    "requirement": {
      "identity": "Identity / passport",
      "address": "Proof of address",
      "bank": "Bank / SEPA mandate",
      "questionnaire": "Questionnaire",
      "financial": "Financial evidence",
      "medical": "Medical / tests",
      "signature": "Signatures",
      "other": "Additional documents"
    },
    "taskKind": {
      "task": "Task",
      "call": "Call",
      "followup": "Follow-up",
      "appointment": "Appointment",
      "review": "Review",
      "document": "Document reminder",
      "renewal": "Renewal",
      "application": "Application",
      "other": "Other"
    },
    "taskStatus": {
      "open": "Open",
      "done": "Done",
      "cancelled": "Cancelled"
    },
    "priority": {
      "low": "Low",
      "normal": "Normal",
      "high": "High",
      "urgent": "Urgent"
    },
    "location": {
      "office": "At the office",
      "client": "At the client",
      "online": "Online",
      "phone": "By phone",
      "custom": "Other place"
    },
    "reviewOutcome": {
      "completed": "Completed",
      "open": "Open",
      "needs_followup": "Needs follow-up",
      "no_change": "No change needed",
      "declined": "Client declined"
    },
    "prospectStatus": {
      "new": "New",
      "called": "Called",
      "no_answer": "No answer",
      "callback": "Call back",
      "interested": "Interested",
      "appointment": "Appointment",
      "not_interested": "Not interested",
      "wrong_number": "Wrong number",
      "converted": "Converted"
    },
    "outcome": {
      "positive": "Positive",
      "neutral": "Neutral",
      "negative": "Negative"
    },
    "occupationRisk": {
      "low": "Low-risk occupation",
      "medium": "Medium-risk occupation",
      "high": "High-risk occupation"
    },
    "severity": {
      "critical": "Critical",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "reviewState": {
      "not_applicable": "No active policies",
      "never": "Never reviewed",
      "overdue": "Review overdue",
      "due_soon": "Review due soon",
      "ok": "Reviewed"
    },
    "serviceStatus": {
      "open": "Open",
      "in_progress": "In progress",
      "waiting": "Waiting",
      "closed": "Closed"
    },
    "householdRole": {
      "primary": "Primary",
      "spouse": "Spouse / partner",
      "child": "Child",
      "dependent": "Dependent",
      "other": "Other"
    },
    "timeline": {
      "created": "Created",
      "note": "Note",
      "call": "Call",
      "message": "Message",
      "email": "Email",
      "meeting": "Meeting",
      "appointment": "Appointment",
      "task": "Task",
      "policy": "Policy",
      "case": "Case",
      "review": "Review",
      "document": "Document",
      "service": "Service",
      "proposal": "Proposal",
      "comparison": "Comparison",
      "import": "Import",
      "system": "System",
      "legacy": "Legacy record"
    },
    "riskAttitude": {
      "conservative": "Conservative",
      "balanced": "Balanced",
      "growth": "Growth",
      "unknown": "Not assessed"
    },
    "quoteStatus": {
      "draft": "Draft",
      "sent": "Sent",
      "accepted": "Accepted",
      "declined": "Declined",
      "expired": "Expired"
    },
    "opportunityStage": {
      "lead": "Lead",
      "qualified": "Qualified",
      "proposal": "Proposal",
      "decision": "Decision",
      "won": "Won",
      "lost": "Lost",
      "deferred": "Deferred"
    },
    "referralStatus": {
      "new": "New",
      "contacted": "Contacted",
      "meeting": "Meeting",
      "converted": "Converted",
      "declined": "Declined"
    },
    "commChannel": {
      "phone": "Phone",
      "email": "E-mail",
      "sms": "SMS",
      "whatsapp": "WhatsApp",
      "meeting": "Meeting",
      "letter": "Letter",
      "social": "Social",
      "other": "Other"
    },
    "commDirection": {
      "out": "Outgoing",
      "in": "Incoming"
    },
    "claimStatus": {
      "open": "Open",
      "submitted": "Submitted",
      "pending_documents": "Documents pending",
      "approved": "Approved",
      "paid": "Paid",
      "declined": "Declined",
      "closed": "Closed"
    },
    "policyCategory": {
      "life": "Life",
      "medical": "Medical",
      "savings": "Savings",
      "pension": "Pension",
      "education": "Education",
      "accident": "Accident",
      "critical_illness": "Critical illness",
      "disability": "Disability",
      "credit_life": "Credit life",
      "motor": "Motor",
      "home": "Home",
      "travel": "Travel",
      "liability": "Liability",
      "business": "Business",
      "group": "Group",
      "other": "Other"
    },
    "partyRole": {
      "owner": "Policyholder",
      "insured": "Insured",
      "beneficiary": "Beneficiary",
      "payer": "Payer",
      "advisor": "Advisor"
    },
    "benefit": {
      "death": "Death",
      "critical_illness": "Critical illness",
      "disability": "Disability",
      "waiver": "Premium waiver",
      "income": "Income benefit",
      "medical": "Medical",
      "hospital": "Hospital",
      "accident": "Accident",
      "savings": "Savings",
      "maturity": "Maturity",
      "mortgage": "Mortgage",
      "other": "Other"
    },
    "lifeEvent": {
      "marriage": "Marriage",
      "new_child": "New child",
      "new_job": "New job",
      "salary_increase": "Salary increase",
      "home_purchase": "Home purchase",
      "mortgage": "New mortgage",
      "new_loan": "New loan",
      "business_start": "Started a business",
      "retirement_planning": "Retirement planning",
      "divorce": "Divorce",
      "new_property": "New property",
      "other": "Other life event"
    },
    "docCategory": {
      "identity": "Identity",
      "policies": "Policies",
      "applications": "Applications",
      "tax": "Tax",
      "income": "Income",
      "medical": "Medical",
      "loans": "Loans",
      "claims": "Claims",
      "quotations": "Quotations",
      "signed": "Signed",
      "other": "Other"
    }
  },
  "today": {
    "greeting": "{part, select, morning {Good morning} afternoon {Good afternoon} other {Good evening}}{name, select, none {} other {, {name}}}",
    "summary": "{attention, plural, =0 {Nothing needs you urgently.} one {# relationship needs your attention.} other {# relationships need your attention.}} {agenda, plural, =0 {Your agenda is clear.} one {# item on today's agenda.} other {# items on today's agenda.}}",
    "attention_title": "Attention field",
    "attention_hint": "Ranked by urgency, with the reason and the next move.",
    "attention_empty": "Your book is in order. Use the time to call someone you haven't spoken to in a while.",
    "agenda_title": "Today",
    "agenda_empty": "No appointments or tasks for today.",
    "overdue_title": "Overdue",
    "cases_title": "Cases in motion",
    "cases_empty": "No active applications.",
    "moments_title": "Moments",
    "moments_empty": "No birthdays or name days in the next days.",
    "stat_people": "People",
    "stat_clients": "Clients",
    "stat_portfolio": "Annual portfolio",
    "stat_open_cases": "Active cases",
    "stat_reviews_due": "Reviews due",
    "stat_overdue": "Overdue actions",
    "show_more": "Show {count} more",
    "focus_mode": "Focus",
    "waiting_title": "Decisions & waiting",
    "waiting_client": "Waiting for {name}"
  },
  "attention": {
    "reason": {
      "task_overdue": "{title} was due {days, plural, one {# day ago} other {# days ago}}",
      "task_today": "{title} is due today{time, select, none {} other { at {time}}}",
      "appointment_today": "Appointment today at {time}: {title}",
      "appointment_tomorrow": "Appointment tomorrow at {time} — prepare the meeting pack",
      "case_stalled": "{product} has not moved for {days} days ({stage})",
      "case_missing": "{product}: {count, plural, one {# requirement is} other {# requirements are}} still missing",
      "case_no_next": "{product} ({stage}) has no next action scheduled",
      "case_target": "{product} target issue date is {date}",
      "review_overdue": "Annual review overdue by {days} days",
      "review_never": "Holds {policies, plural, one {# active policy} other {# active policies}} and was never reviewed",
      "review_due_soon": "Annual review due on {date}",
      "renewal_soon": "{product} renews on {date}",
      "birthday": "{when, select, today {Birthday today} tomorrow {Birthday tomorrow} other {Birthday on {date}}} — turns {age}",
      "nameday": "{when, select, today {Name day today} tomorrow {Name day tomorrow} other {Name day on {date}}} ({feast})",
      "child_milestone": "{child} turns {age} on {date} — education / protection review",
      "protection_gap": "Has {children, plural, one {# dependent child} other {# dependent children}} and no active life protection",
      "no_next_step": "Open {kind, select, offer {offer} case {application} other {opportunity}} without a scheduled next step",
      "silence": "No contact for {days} days with an active client",
      "prospect_followup": "Follow-up with prospect {name} ({list}) was due {date}",
      "data_quality": "Missing phone and email — cannot be contacted",
      "hot": "Warm: {signal}{more, plural, =0 {} one { + # more signal} other { + # more signals}}",
      "promise_overdue": "You promised “{title}” — {days, plural, one {# day late} other {# days late}}",
      "waiting_client": "Waiting for the client: “{title}” — {days, plural, one {# day} other {# days}} past the date",
      "quote_expiring": "{product} quotation {when, select, past {expired on {date}} other {expires on {date}}}",
      "decision_pending": "Decision pending on “{title}” for {days} days — no follow-up scheduled",
      "needs_missing": "{children, plural, one {# child depends} other {# children depend}} on this client — no needs analysis yet",
      "claim_followup": "{type} claim ({status}) needs a follow-up — {days, plural, =0 {updated today} one {last update # day ago} other {last update # days ago}}",
      "service_open": "Service request “{title}” open for {days} days",
      "referral_thanks": "Referred {name} — say thank you",
      "policy_lapsed": "{product} lapsed {days, plural, =0 {today} one {# day ago} other {# days ago}} — a call can often reinstate it",
      "payment_late_verified": "{product}: insurer confirms a late payment",
      "payment_late_note": "{product}: you noted a possible late payment (not confirmed by the insurer)",
      "life_event": "Life event: {event} ({date}) — protection may need a review",
      "loan_maturity": "{label} ends on {date}",
      "mortgage_gap": "Mortgage balance {balance, number, currency} but only {cover, number, currency} of life cover assigned to it",
      "education_milestone": "{child} turns {age} on {date} — a good moment to talk about education plans",
      "extraction_review": "{count, plural, one {# value read from a document is} other {# values read from a document are}} waiting for your review",
      "sync_conflict": "A {table} record was changed on two devices — choose which version to keep",
      "insured_due": "{what} for {label} on {date}",
      "premium_overdue": "{product}: premium due {date} not collected yet ({days, plural, one {# day} other {# days}})",
      "premium_lapse_risk": "{product}: premium overdue for {days, plural, one {# day} other {# days}} — risk of lapse",
      "kyc_due": "KYC/AML review due on {date}",
      "kyc_overdue": "KYC/AML review was due on {date} — update the file"
    },
    "action": {
      "complete_task": "Complete",
      "call": "Call",
      "open_case": "Open case",
      "schedule_next": "Schedule next action",
      "request_documents": "Chase documents",
      "start_review": "Start review",
      "schedule_review": "Book review",
      "send_wishes": "Send wishes",
      "prepare_meeting": "Prepare meeting",
      "discuss_protection": "Plan protection talk",
      "reconnect": "Reconnect",
      "call_prospect": "Call prospect",
      "complete_profile": "Complete profile",
      "open": "Open",
      "keep_promise": "Keep the promise",
      "chase_client": "Remind the client",
      "follow_quote": "Follow up the quote",
      "start_needs": "Start needs analysis",
      "open_service": "Open service",
      "thank": "Say thank you",
      "resolve_conflict": "Resolve",
      "review_extraction": "Review values",
      "open_insured": "Open insured items",
      "open_kyc": "Open KYC"
    },
    "why": "Why",
    "evidence": "Based on",
    "dismiss": "Snooze until tomorrow",
    "snoozed": "Snoozed until tomorrow"
  },
  "brief": {
    "title": "Relationship brief",
    "who": "Who",
    "why": "Why now",
    "done": "What we've done",
    "missing": "What's missing",
    "next": "Next best action",
    "last_contact": "Last contact {date} · {what}",
    "never_contacted": "No recorded contact yet",
    "nothing_missing": "Nothing missing — relationship is in good shape",
    "no_reason": "No urgent reason — keep the relationship warm",
    "since": "Relationship since {date}",
    "age": "{age} years",
    "children": "{count, plural, one {# child} other {# children}}",
    "open_items": "{count, plural, =0 {no open actions} one {# open action} other {# open actions}}"
  },
  "people": {
    "title": "People",
    "subtitle": "Clients, prospects and their households",
    "search": "Search name, phone, email, occupation…",
    "new": "New person",
    "count": "{count, plural, one {# person} other {# people}}",
    "empty": "No people match these filters.",
    "filter_stage": "Stage",
    "filter_attention": "Needs attention",
    "filter_review": "Review due",
    "filter_hot": "Hot",
    "filter_policies": "With policies",
    "sort_attention": "By attention",
    "sort_name": "By name",
    "sort_recent": "Recently updated",
    "archived": "Archived",
    "register": "Client list",
    "register_hint": "Print or export all clients with since when and where they came from",
    "filter_source": "Source"
  },
  "person": {
    "display_name": "Full name",
    "first_name": "First name",
    "last_name": "Last name",
    "stage": "Stage",
    "phone": "Mobile phone",
    "email": "Email",
    "birth_date": "Date of birth",
    "name_day": "Name day (MM-DD, optional override)",
    "occupation": "Occupation",
    "employer": "Employer",
    "address": "Address",
    "city": "City",
    "region": "Region / district",
    "source": "Source",
    "referred_by": "Referred by",
    "gender": "Gender",
    "marital_status": "Marital status",
    "notes": "Important notes",
    "hot": "Hot opportunity",
    "new_title": "New person",
    "edit_title": "Edit person",
    "archive": "Archive",
    "archive_confirm": "Archive {name}? The history is kept and can be restored.",
    "created": "{name} added",
    "updated": "Changes saved",
    "duplicate_warning": "Possible duplicate: {name} has the same phone or email.",
    "client_since": "Client since",
    "client_since_hint": "The day they became your client.",
    "client_since_hint_derived": "Empty: {date} is used ({basis}).",
    "source_other": "Other source…",
    "source_own": "Your own source",
    "source_own_ph": "e.g. Gym, parents’ association",
    "referred_by_hint": "Pick an existing person or type a name",
    "since_basis": {
      "recorded": "recorded",
      "first_policy": "first policy",
      "added": "added to AVRASTRO"
    },
    "client_since_label": "Client since {date}",
    "source_label": "Source: {source}",
    "referred_by_label": "referred by {name}"
  },
  "focus": {
    "tabs": {
      "overview": "Overview",
      "policies": "Policies",
      "cases": "Cases",
      "actions": "Actions",
      "notes": "Notes",
      "reviews": "Reviews",
      "household": "Household",
      "documents": "Documents & service",
      "records": "Records",
      "comparisons": "Comparisons",
      "advisory": "Advisory",
      "conversations": "Conversations",
      "service": "Service",
      "growth": "Growth",
      "protection": "Protection",
      "insured": "Insured items",
      "kyc": "KYC / AML",
      "risk": "Risk profile"
    },
    "more": {
      "contact": "Contact",
      "advice": "Advice and sales",
      "service": "Service",
      "docs": "Documents and tax"
    },
    "quick": {
      "note": "Note",
      "followup": "Follow-up",
      "appointment": "Appointment",
      "case": "Application",
      "policy": "Policy",
      "review": "Review"
    },
    "timeline": "Timeline",
    "timeline_empty": "No history yet.",
    "attention": "Needs attention",
    "contact": "Contact"
  },
  "pulse": {
    "policies": "Active policies",
    "portfolio": "Annual portfolio",
    "open_actions": "Open actions",
    "review": "Review",
    "cases": "Active cases",
    "next_move": "Next move",
    "none": "—"
  },
  "policy": {
    "title": "Policies",
    "new": "New policy",
    "edit": "Edit policy",
    "product": "Product / plan",
    "carrier": "Insurer",
    "number": "Policy number",
    "branch": "Branch",
    "status": "Status",
    "start": "Start date",
    "renewal": "Renewal / anniversary",
    "end": "End / maturity",
    "premium_annual": "Annual premium",
    "premium_monthly": "Monthly equivalent",
    "frequency": "Payment frequency",
    "method": "Payment method",
    "sum_assured": "Sum insured / benefit",
    "insured": "Insured person",
    "beneficiaries": "Beneficiaries",
    "current_premium": "Current premium",
    "adjustments": "{count, plural, one {# premium adjustment} other {# premium adjustments}}",
    "empty": "No policies recorded.",
    "premium_suspicious": "Check this premium — possible decimal-comma error from the old CRM",
    "next_anniversary": "Next anniversary {date}",
    "total": "Total annual premium",
    "owner": "Policy owner",
    "service_health": "Service",
    "health_ok": "All clear",
    "health_open": "Open items",
    "open_items": "{count, plural, =0 {nothing open} one {# open item} other {# open items}}",
    "in_days": "{days, plural, =0 {today} one {in # day} other {in # days}}",
    "premium_history": "Premium history",
    "initial": "Initial premium",
    "premium": "Premium",
    "instalment": "Instalment",
    "instalment_for": "Instalment ({freq})",
    "single_premium": "Single premium",
    "single_hint": "Paid once — not annualised and not counted as recurring premium.",
    "annual_eq_hint": "= {annual} a year · {monthly} a month",
    "eq_annual": "annual",
    "eq_monthly": "monthly",
    "equivalent_hint": "Equivalents are calculated from the instalment and payment frequency; the instalment is what the client actually pays.",
    "quoted": "as quoted",
    "premium_locked": "Use “Change premium” so every change is dated and kept in history.",
    "change_premium": "Change premium",
    "change_status": "Change status",
    "status_from": "New status (now: {status})",
    "status_saved": "Status updated",
    "cancel_reverses": "Cancelled within {days, plural, one {# day} other {# days}} of issue: the new-business credit will be reversed in production.",
    "reactivation_note": "Reactivating credits the premium again as a reactivation, not as new business.",
    "adjust_mode": "How do you want to enter it?",
    "adjust_new": "New amount",
    "adjust_delta": "Change (+ or −)",
    "adjust_current": "currently {amount}",
    "effective_date": "Effective from",
    "adjust_future": "Takes effect on {date}. Until then the current premium stays in use.",
    "adjust_backdated": "Backdated: production is credited according to your settings and flagged as backdated.",
    "adjust_production": "Production: {amount} (only the difference is credited)",
    "adjust_reason": "Reason",
    "adjust_reason_ph": "e.g. indexation, added cover, client request",
    "increase_saved": "Premium increase recorded",
    "decrease_saved": "Premium decrease recorded",
    "pending_change": "from {date}: {amount}",
    "future": "upcoming",
    "original": "original premium",
    "reverse": "Reverse",
    "reverse_hint": "A reversal cancels this change and its production credit. Nothing is deleted — both entries stay in history.",
    "reversed": "Change reversed",
    "timeline": "Policy history",
    "remaining": "Remaining",
    "months": "{count, plural, one {# month} other {# months}}",
    "months_left": "{count, plural, one {# month left} other {# months left}}",
    "category": "Category",
    "category_auto": "Automatic ({category})",
    "currency": "Currency",
    "more_details": "More details",
    "parties": "People on this policy",
    "party_add": "Add person",
    "party_other": "Someone else (name only)",
    "benefits": "Benefits",
    "benefit_add": "Add benefit",
    "benefits_count": "{count, plural, one {# benefit} other {# benefits}}",
    "no_benefits": "no benefits recorded",
    "all_insured": "all insured",
    "amount": "Amount",
    "guaranteed": "guaranteed",
    "projected": "projected",
    "tags": "Needs covered",
    "tags_hint": "suggestions are highlighted",
    "tags_apply": "Apply suggestions",
    "color": "Colour",
    "color_hint": "overrides the category or insurer colour",
    "color_auto": "Automatic",
    "replaces": "Replaces policy",
    "payment_note": "Payment status",
    "payment_hint": "e.g. bank returned the direct debit",
    "payment_verified": "Confirmed by the insurer",
    "payment": {
      "late": "Late",
      "ok": "Up to date"
    },
    "payment_late_verified": "Late payment (confirmed)",
    "payment_late_note": "Possible late payment (your note)",
    "color_source": {
      "manual": "chosen colour",
      "category": "category colour",
      "insurer": "insurer colour"
    },
    "from_pdf": "Policy from PDF"
  },
  "case": {
    "title": "Cases & applications",
    "subtitle": "Application journey from draft to issued policy",
    "new": "New application",
    "product": "Product / plan",
    "insurer": "Insurer",
    "number": "Application number",
    "stage": "Stage",
    "premium": "Annual premium",
    "sum_assured": "Sum assured",
    "target": "Target issue date",
    "next_action": "Next action",
    "next_action_date": "Next action date",
    "next_action_time": "Time",
    "requirements": "Requirements",
    "missing": "{count, plural, =0 {Checklist complete} one {# missing} other {# missing}}",
    "age": "{days}d",
    "stalled": "Stalled",
    "history": "Journey history",
    "move_to": "Move to {stage}",
    "advance": "Advance",
    "terminal": "Close as…",
    "issued_policy": "Policy created from this case",
    "empty": "No applications yet.",
    "add_requirement": "Add requirement",
    "journey": "Journey",
    "all_stages": "All stages",
    "active": "Active",
    "closed": "Closed",
    "event": {
      "created": "Case created"
    },
    "created": "Application created",
    "stage_changed": "Moved to {stage}",
    "category": "Product category",
    "category_ph": "e.g. life, health, savings",
    "reopened": "Application reopened",
    "reopened_on": "Reopened {date}"
  },
  "task": {
    "new_followup": "New follow-up",
    "new_appointment": "New appointment",
    "new_task": "New task",
    "edit": "Edit",
    "title": "Title",
    "kind": "Type",
    "due_date": "Date",
    "due_time": "Time",
    "duration": "Duration (minutes)",
    "location_type": "Location",
    "location": "Address / link",
    "complete": "Complete",
    "complete_title": "Complete: {title}",
    "outcome": "Outcome",
    "result_note": "What happened?",
    "overdue": "Overdue",
    "no_date": "No date",
    "reopen": "Reopen",
    "office_autofill": "Office address from your profile is used automatically.",
    "created": "Added to agenda",
    "completed": "Completed",
    "delete_confirm": "Delete this task?",
    "prospect": "Prospect: {name}",
    "edit_appointment": "Change appointment",
    "edit_task": "Change task",
    "updated": "Changes saved",
    "video_moved": "The video call moved to the new time — the client’s link stays the same. Send them the new message.",
    "video_keeps_link": "AVRASTRO Video call · if you change the date or time, the room moves with it (the client’s link stays the same)."
  },
  "appointment": {
    "calendar_file": "Calendar file (.ics)",
    "google": "Add to Google Calendar",
    "drafts": "Message drafts",
    "draft_note": "Drafts are opened in your app — nothing is sent automatically.",
    "maps": "Open map"
  },
  "note": {
    "new": "New note / next action",
    "title": "Title",
    "body": "Note",
    "placeholder": "Write what you need to remember, what you promised, what happens next…",
    "remind": "Add to agenda on",
    "saved": "Note saved",
    "empty": "No notes yet.",
    "pinned": "Pinned",
    "action_type": "Action type",
    "action": {
      "note": "Note",
      "call": "Call",
      "followup": "Follow-up",
      "appointment": "Appointment",
      "waiting": "Waiting for reply",
      "document": "Documents",
      "review": "Review",
      "service": "Service",
      "application": "Application"
    }
  },
  "review": {
    "title": "Review center",
    "subtitle": "Annual reviews for every active relationship",
    "due_now": "Overdue",
    "never": "Never reviewed",
    "due_soon": "Due in the next 30 days",
    "ok": "Up to date",
    "complete": "Record review",
    "date": "Review date",
    "outcome": "Outcome",
    "next_date": "Next review",
    "notes": "What changed? Family, income, health, goals…",
    "followup": "Follow-up date (optional)",
    "saved": "Review recorded",
    "last": "Last review {date}",
    "due": "Due {date}",
    "followup_title": "Review follow-up",
    "empty": "No reviews in this group.",
    "history": "Review history",
    "since_last": "Changes since the last review ({date})",
    "no_changes": "No recorded changes since the last review.",
    "change": {
      "life_event": "Life event",
      "policy_new": "New policy",
      "premium_change": "Premium change",
      "income": "Income",
      "liability": "Loan",
      "child": "Child added",
      "needs_revision": "Needs analysis revised",
      "claim": "Claim"
    },
    "questions": "Review questions",
    "questions_note": "Answers are kept as evidence with the review; a change in the client’s life or a “no” to a check creates a follow-up task.",
    "answer_note": "Note (optional)",
    "a": {
      "yes": "Yes",
      "no": "No",
      "na": "n/a"
    },
    "q": {
      "life_changes": "Any changes in family, home or work?",
      "income_change": "Has income changed noticeably?",
      "new_debts": "New loans or mortgage?",
      "health_changes": "Health changes that may affect cover?",
      "dependants_changed": "New dependants (children, parents)?",
      "goals_changed": "Changed goals (savings, education, retirement)?",
      "beneficiaries_ok": "Are the beneficiaries still right?",
      "cover_adequate": "Is the cover still adequate?",
      "satisfied": "Satisfied with the service?",
      "referral_asked": "Asked about friends or family who could benefit?"
    },
    "action": {
      "life_changes": "Review protection after life changes",
      "income_change": "Recheck income protection and savings",
      "new_debts": "Check credit life / mortgage protection",
      "health_changes": "Check health-related cover and disclosures",
      "dependants_changed": "Update family and protection needs",
      "goals_changed": "Update the needs analysis for new goals",
      "beneficiaries_ok": "Update beneficiaries with the insurer",
      "cover_adequate": "Prepare a proposal to close the cover gap",
      "satisfied": "Call back about service satisfaction"
    },
    "evidence": "Evidence: {answered}/{total} questions answered",
    "portfolio_then": "portfolio then {amount}",
    "actions_count": "{count} for action"
  },
  "household": {
    "title": "Household",
    "children": "Children & dependents",
    "add_child": "Add child",
    "child_name": "Child's name",
    "age": "{age} y",
    "empty": "No household members recorded.",
    "linked": "Linked people",
    "coverage": "Family coverage"
  },
  "documents": {
    "title": "Documents",
    "service": "Service & claims",
    "empty": "No documents recorded.",
    "service_empty": "No service cases.",
    "note": "Files remain in your document vault; AVRASTRO keeps the metadata and links.",
    "new": "New document",
    "name": "Document",
    "reference": "Reference",
    "link": "Link",
    "link_hint": "Where the file lives (drive, e-mail, insurer portal)",
    "delete_confirm": "Remove “{title}” from the register?",
    "type": {
      "identity": "Identity / passport",
      "address": "Proof of address",
      "bank": "Bank / SEPA",
      "medical": "Medical",
      "financial": "Financial evidence",
      "policy": "Policy document",
      "application": "Application form",
      "claim": "Claim document",
      "proposal": "Proposal",
      "quotation": "Quotation",
      "other": "Other"
    },
    "title_label": "Title"
  },
  "records": {
    "title": "Preserved records",
    "subtitle": "Data from earlier AVRASTRO modules, kept intact until its new module ships.",
    "empty": "No preserved records.",
    "kind": {
      "meeting": "Meeting",
      "needs_analysis": "Needs analysis",
      "tax_profile": "Tax profile",
      "risk_profile": "Risk profile",
      "quote": "Quotation",
      "proposal": "Proposal",
      "comparison": "Policy comparison",
      "communication": "Communication",
      "feedback": "Feedback",
      "outcome": "Outcome",
      "opportunity": "Opportunity",
      "referral": "Referral",
      "consent": "Consent",
      "weekly_fund": "Weekly fund update",
      "pending_decision": "Pending decision",
      "promise": "Commitment",
      "sync_inbox": "Tablet sync item",
      "group_plan": "Group plan",
      "profile_brief": "Profile brief",
      "other": "Other"
    }
  },
  "prospects": {
    "title": "Prospecting",
    "subtitle": "Lists, calling sessions and conversion",
    "lists": "Lists",
    "new_list": "New list",
    "list_name": "List name",
    "import": "Import contacts",
    "import_hint": "Paste rows from Excel or CSV. Columns: Name, Phone, Email, Occupation, Company, Area, Source, Notes (header row optional).",
    "preview": "{unique} new · {dupes} duplicates · {clients} already clients",
    "legend_unique": "New",
    "legend_dupe": "Duplicate",
    "legend_client": "Already a client",
    "add_rows": "Add {count} contacts",
    "call_sheet": "Print call sheet",
    "convert": "Convert to person",
    "converted": "Converted",
    "empty_list": "This list is empty.",
    "no_lists": "Create your first list to start calling.",
    "calling": "Calling session",
    "next": "Next contact",
    "followup_on": "Follow-up on",
    "stats": "{called} of {total} called · {interested} interested",
    "density": "Density",
    "compact": "Compact",
    "normal": "Normal",
    "detailed": "Detailed",
    "handwritten": "Notes",
    "import_file": "Choose CSV or Excel file",
    "first_row_header": "First row is a header",
    "ignore": "— ignore —",
    "map_column": "Column {n}",
    "field": {
      "name": "Name",
      "phone": "Phone",
      "email": "E-mail",
      "profession": "Profession",
      "company": "Company",
      "area": "Area",
      "source": "Source",
      "notes": "Notes"
    }
  },
  "agenda": {
    "day_sheet": "Daily sheet",
    "day_sheet_hint": "The two A4 pages of the daily plan, filled in with the day's appointments, calls and follow-ups from the CRM",
    "title": "Agenda",
    "subtitle": "Appointments, follow-ups and tasks",
    "week": "Week",
    "list": "List",
    "prev": "Previous",
    "next": "Next",
    "this_week": "This week",
    "overdue": "Overdue",
    "no_items": "Free",
    "unscheduled": "Without date",
    "print": "Print agenda",
    "mode": {
      "day": "Day",
      "week": "Week",
      "month": "Month"
    },
    "day_summary": "The day at a glance",
    "markers": "Moments & dates"
  },
  "goals": {
    "title": "Today’s goals",
    "subtitle": "Worked out on this device from your working hours, agenda, tasks, call lists and recorded activity — no AI, nothing invented.",
    "recompute": "Recompute",
    "recompute_hint": "Compute again from the agenda as it is now — your own numbers and skips are kept",
    "recomputed": "Goals recomputed — your own numbers were kept",
    "prefs": "Goal settings",
    "plan_day": "Plan the day",
    "not_computed": "No goals for this day yet.",
    "compute": "Compute goals",
    "free_line": "{free} of {work} working hours free ({from}–{to})",
    "none": "Nothing to suggest for this day: no free time, no numbers to call and nothing overdue.",
    "counted": "Progress counts only what is recorded — calls logged, tasks completed, messages, appointments booked — each once.",
    "none_day_off": "{date} is not a working day in Settings → Office hours, so there are no goals.",
    "compute_anyway": "Set goals anyway",
    "skipped": "Skipped today",
    "progress": "{done} of {target}",
    "adjusted": "Your number (suggested: {n})",
    "decrease": "Lower the goal",
    "increase": "Raise the goal",
    "target_for": "Goal for «{goal}»",
    "resume": "Back on",
    "skip": "Skip today",
    "market": "Market note",
    "market_remove": "Remove",
    "market_add": "Add a market note (with its source)",
    "market_hint": "Only what you add yourself, with where it comes from — the CRM never writes market news.",
    "market_text": "What happened",
    "market_source": "Source (e.g. ECB press release)",
    "market_url": "Link (optional)",
    "saved": "Saved",
    "prefs_saved": "Goal settings saved — they apply from the next computation",
    "pref_goal": "Goal",
    "pref_on": "Suggest",
    "pref_min": "Minimum",
    "pref_max": "Maximum",
    "pref_util": "Share of free time to plan for goals",
    "prefs_note": "Switched-off goals are not suggested at all. Minimum and maximum apply to the suggestion; you can still change the number for a day.",
    "type": {
      "prospecting_calls": "Prospecting calls",
      "customer_contacts": "Existing-client contacts",
      "appointments": "Appointments to book",
      "overdue_followups": "Overdue follow-ups to clear",
      "renewals": "Renewals to contact"
    },
    "why": {
      "overdue": "Overdue follow-ups: {count}",
      "time_limited": "Only {hours} h free today, so not all of them",
      "renewals": "Clients with a renewal in the next {days} days, not contacted in the last 2 weeks: {count}",
      "contacts_due": "Client calls and follow-ups due today: {count}",
      "contacts_time": "About {minutes} minutes of your free time for clients",
      "light_day": "A light day: {hours} h free",
      "full_day": "A full day: only {hours} h free",
      "performance_low": "In the last 4 weeks you reached {rate}% of this goal — set a little lower",
      "performance_high": "In the last 4 weeks you reached {rate}% of this goal — set a little higher",
      "calls_time": "{hours} h left for calls → {count} calls at your usual pace ({pace} an hour)",
      "calls_time_default": "{hours} h left for calls → {count} calls at {pace} an hour (a starting pace until you have logged enough calls)",
      "queue": "Numbers ready to call in your lists: {count} ({fresh} never called)",
      "queue_limited": "Limited to the {count} numbers in your lists",
      "week_meetings": "Week goal: {goal} meetings, {booked} booked so far → {need} more over {days} working days",
      "expected_from_calls": "At your rate ({rate}% of calls) today’s calls should bring about {count}",
      "pref_min": "Your minimum: {value}",
      "pref_max": "Your maximum: {value}"
    },
    "relationship": "Relationship meetings (coffee / referral): {planned} planned · {done} held",
    "relationship_hint": "counted on their own — not as appointments",
    "title_for": "Goals · {date}"
  },
  "planner": {
    "title": "Day plan",
    "hint": "Quick add: type → time → length → Enter (press «n» to go there) · click a free slot for a block · drag a block to move it, its lower edge to change its length · keyboard: ↑ ↓ move, Shift + ↑ ↓ length, Enter open, Delete cancel, Ctrl + Enter done. Appointments are never moved from here.",
    "conflicts": "Overlaps: {count} — shown, not changed",
    "outside": "Outside the hours shown: {count}",
    "add": "Block",
    "add_at": "Add a block at {time}",
    "free": "free",
    "suggestion": "suggestion",
    "committed": "Appointment — change it in its own form",
    "overlap": "Overlaps another item",
    "accept": "Accept",
    "dismiss": "Not today",
    "complete": "Done",
    "edit": "Edit",
    "open": "Open",
    "cancel": "Cancel block",
    "unplanned": "Without a time",
    "plan_task": "Plan",
    "legend_own": "Your blocks and tasks",
    "hours_from": "Planner starts at",
    "hours_to": "Planner ends at",
    "minutes": "{n} min",
    "form_title": "Block in your plan",
    "form_new": "New block in your plan",
    "field": {
      "title": "What",
      "kind": "Type",
      "start": "From",
      "end": "To",
      "notes": "Notes",
      "person": "With whom (optional)"
    },
    "goal_block": "{goal} · {count}",
    "source": {
      "appointment": "Appointment"
    },
    "kind": {
      "focus": "Focus time",
      "personal": "Personal programme",
      "task": "Task",
      "goal": "Goal",
      "admin": "Admin",
      "travel": "Travel",
      "break": "Break"
    },
    "moved": "Moved",
    "done": "Marked done",
    "cancelled": "Block cancelled",
    "accepted": "Added to your plan",
    "dismissed": "Hidden for today",
    "planned": "Planned",
    "no_free": "No free 30 minutes left in your working hours",
    "saved": "Saved to your plan",
    "confirm_conflict": "This overlaps an appointment. The appointment stays exactly where it is. Keep both at the same time?",
    "type": {
      "client_appointment": "Client appointment (insurance)",
      "coffee": "Coffee / getting to know",
      "referral_meeting": "Referral meeting",
      "calls": "Calls (prospecting)",
      "followup": "Follow-up",
      "admin": "Email & admin",
      "prep": "Appointment preparation",
      "learning": "Learning / study",
      "team": "Team / office meeting",
      "travel": "Travel",
      "break": "Break",
      "personal": "Personal",
      "other": "Other",
      "focus": "Focus time",
      "task": "Task",
      "goal": "Goal"
    },
    "planning_for": "You are planning",
    "rel": {
      "today": "Today",
      "tomorrow": "Tomorrow",
      "after": "Day after",
      "past": "Past"
    },
    "pick_date": "Pick a date",
    "templates": "Day templates",
    "copy_from": "Copy from…",
    "move": "Move to another date",
    "move_none": "No blocks of yours to move",
    "print": "Print",
    "accept_all": "Add all suggestions ({count})",
    "accepted_all": "The suggestions are in your plan",
    "done_social": "Done — on the person's timeline (not as an appointment)",
    "duration": "Length",
    "qa_add": "Add",
    "qa_appointment": "New appointment…",
    "social_hint": "Getting to know someone or a referral, no sale: counted apart from insurance appointments. With a person, it goes on their timeline as the last contact once done.",
    "appointment_hint": "An insurance appointment becomes a real CRM appointment (client, place, reminders) and counts as an appointment.",
    "move_intro": "All your own blocks and accepted suggestions of {date} move, at the same times.",
    "move_what": "Moving: {count} blocks → {date}",
    "move_go": "Move ({count})",
    "move_staying": "Staying where they are ({count}) — CRM appointments and tasks are never moved from here:",
    "move_over": "On the new date {count} blocks fall on an appointment: you will be asked before they are kept (the appointments do not change).",
    "move_overlap": "Overlaps with other blocks of the new day: {count} — they will be shown.",
    "move_undo": "After the move, «Undo» in the message brings everything back at once.",
    "moved_day": "{count} blocks moved to {date}",
    "copy": {
      "yesterday": "From yesterday",
      "lastWeek": "From the same day last week"
    },
    "copy_counts": "Adds {add} · leaves out {skipped} (over something already planned)",
    "copy_go": "Copy",
    "copied": "{count} blocks copied",
    "copy_intro": "Your blocks (not tasks) are copied to {date}; anything over something already planned is left out.",
    "templates_intro": "A template fills {date} with ready blocks (the built-in ones follow your office start); nothing goes over an appointment or another block.",
    "template_own": "mine",
    "template_apply": "Apply",
    "template_applied": "«{name}»: {count} blocks in your plan",
    "template_delete": "Delete template",
    "template_delete_confirm": "Delete the template «{name}»? Plans made with it stay.",
    "template_deleted": "Template deleted",
    "template_save_label": "Save this day as a template ({count} blocks)",
    "template_name_ph": "e.g. My Tuesday",
    "template_save": "Save",
    "template_saved": "Template saved",
    "tpl": {
      "office": "Office day",
      "appointments": "Appointments day",
      "calls": "Calls day"
    },
    "print_kind": {
      "plan": "Plan",
      "blank": "Blank sheet",
      "sheet": "Daily sheet (2 pages)"
    },
    "print_hint": {
      "plan": "The filled plan as a list: time, type, what, notes — never overlapping; with the CRM's due calls / follow-ups and space for notes.",
      "blank": "Empty hours to write by hand, with the date, your name and goal boxes.",
      "sheet": "The paper daily sheet: appointments by hour, calls, follow-ups, new contacts."
    },
    "print_go": "Print",
    "print_due": "With the CRM's calls / follow-ups",
    "print_notes": "Space for notes",
    "print_goals": "Goal boxes"
  },
  "insights": {
    "title": "Insights",
    "subtitle": "Portfolio, production and pipeline — calculated from your data",
    "mix": "Portfolio by branch",
    "carriers": "Top insurers",
    "pipeline": "Pipeline by stage",
    "activity": "Last 30 days",
    "calls": "Calls",
    "meetings": "Meetings",
    "cases_issued": "Cases issued",
    "new_clients": "New clients"
  },
  "data": {
    "title": "Data & safety",
    "subtitle": "Import, backup, restore and diagnostics — every change is previewed and reversible",
    "import_title": "Import from VÉRO CRM (v1–v910)",
    "import_desc": "Bring clients, policies, tasks, notes, applications, reviews, prospects and documents from the historical VÉRO HTML CRM. Nothing is written until you confirm.",
    "choose_file": "Choose backup file",
    "or_paste": "…or paste JSON",
    "password": "Backup password (for .ICRM files)",
    "analyze": "Analyze",
    "analyzing": "Analyzing…",
    "detected": "Detected: {source}",
    "preview": "Import preview",
    "warnings": "{count, plural, =0 {No warnings} one {# warning} other {# warnings}}",
    "mode": "Import mode",
    "mode_merge": "Merge into this workspace (re-import safe)",
    "mode_replace": "Replace this workspace",
    "commit": "Import now",
    "committing": "Importing…",
    "done": "Import completed and verified",
    "safety": "A safety snapshot was taken first: {label}",
    "verify_ok": "Verification passed: {count} records",
    "verify_fail": "Verification failed — changes rolled back",
    "backup_title": "Backup",
    "backup_desc": "A backup contains every record, a manifest and SHA-256 checksums.",
    "export_plain": "Export backup (.vero.json)",
    "export_secure": "Export encrypted backup",
    "secure_password": "Encryption password (min. 10 characters)",
    "restore_title": "Restore",
    "restore_desc": "Restores are validated, previewed and applied in one transaction. A snapshot is taken before.",
    "diff": "Changes",
    "added": "Added",
    "removed": "Removed",
    "changed": "Changed",
    "unchanged": "Unchanged",
    "table": "Data",
    "snapshots": "Safety snapshots",
    "snapshots_empty": "No snapshots yet.",
    "rollback": "Restore this snapshot",
    "rollback_confirm": "Replace the current workspace with snapshot “{label}”? A new snapshot of the current state is taken first.",
    "diagnostics": "Diagnostics",
    "schema": "Schema version {version}",
    "integrity": "Integrity check",
    "integrity_ok": "No issues found",
    "integrity_issues": "{count, plural, one {# issue} other {# issues}}",
    "storage": "Storage: {engine}",
    "translations": "Translations",
    "exporter_title": "Old browser data",
    "exporter_desc": "If your data only lives inside the old CRM's browser storage, open the VÉRO Legacy Exporter in the same browser to save it as a file first. It only reads, never changes anything.",
    "stats": {
      "persons": "People",
      "policies": "Policies",
      "tasks": "Tasks & appointments",
      "notes": "Notes",
      "cases": "Applications",
      "reviews": "Reviews",
      "prospects": "Prospects",
      "prospect_lists": "Prospect lists",
      "documents": "Documents",
      "timeline": "Timeline events",
      "legacy_records": "Preserved records",
      "service_cases": "Service cases",
      "households": "Households"
    },
    "files_corrupt": "{count, plural, one {# document file failed its checksum and was not restored} other {# document files failed their checksum and were not restored}}"
  },
  "settings": {
    "title": "Settings",
    "language": "Language",
    "language_hint": "Interface language. Your data is never translated.",
    "region": "Market / region",
    "region_hint": "Controls currency, name days and default checklists — independent of language.",
    "theme": "Appearance",
    "theme_dark": "Night",
    "theme_light": "Day",
    "theme_auto": "System",
    "advisor": "Advisor profile",
    "advisor_name": "Your name",
    "company": "Company / agency",
    "phone": "Phone",
    "email": "Email",
    "website": "Website",
    "office_address": "Office address",
    "office_maps": "Google Maps link (optional)",
    "signature": "Message signature",
    "partial_translation": "Partial translation — untranslated text falls back to English.",
    "saved": "Settings saved",
    "about": "About AVRASTRO OS",
    "license": "Licence no.",
    "accessibility": "Accessibility",
    "ui": {
      "contrast": "High contrast",
      "motion": "Reduce motion",
      "compact": "Compact density"
    },
    "rules": "Smart alerts",
    "rules_hint": "Turn a rule off or fix its severity. Defaults are explained on every card.",
    "rule_now": "{count} now",
    "rule_auto": "Automatic",
    "rule_off": "Off",
    "business_rules": "Business rules",
    "business_rules_note": "Changes apply to new entries only; past production is never rewritten. Cancellation window: {days} days.",
    "fiscal_start": "Financial year starts",
    "cancel_window": "Cancellation window (days)",
    "cancel_window_hint": "cancellations within this period reverse new business",
    "backdated_label": "Backdated changes",
    "backdated": {
      "credit_today": "Credit on the day recorded",
      "credit_effective": "Credit on the effective date"
    },
    "commission_enabled": "Track commission",
    "no_contact_days": "“No contact” after (days)",
    "emergency_months": "Emergency fund (months of expenses)",
    "attribution_days": "Campaign attribution window (days)",
    "require_consent": "Campaigns require marketing consent",
    "color_precedence": "Policy colour comes from",
    "insurer_colors": "Insurer colours",
    "rebuild_cost": "Indicative rebuild cost per m²",
    "rebuild_cost_hint": "Used only for the indicative property check (default 1,500 EUR)",
    "gi_days": "General renewal follow-ups (days before expiry)",
    "gi_days_hint": "Comma separated, e.g. 45, 30, 15",
    "lapse_risk_days": "Risk of lapse after (days overdue)",
    "lapse_risk_days_hint": "An overdue premium open longer than this shows “risk of lapse” (default 15)"
  },
  "region": {
    "CY": "Cyprus",
    "GR": "Greece",
    "GB": "United Kingdom",
    "DE": "Germany",
    "RO": "Romania",
    "AE": "United Arab Emirates",
    "IL": "Israel",
    "INTL": "International"
  },
  "lens": {
    "placeholder": "Search people, prospects, cases — or type a command",
    "people": "People",
    "prospects": "Prospects",
    "cases": "Cases",
    "commands": "Actions",
    "go": "Go to",
    "no_results": "No results for “{q}”",
    "hint": "↑↓ to move · Enter to open · Esc to close",
    "cmd": {
      "new_person": "New person",
      "new_note": "New note",
      "new_followup": "New follow-up",
      "new_appointment": "New appointment",
      "new_case": "New application",
      "import": "Import data",
      "backup": "Export backup",
      "toggle_theme": "Switch day/night",
      "new_comparison": "New policy comparison",
      "start_flow": "Start Flow — clear my book",
      "new_needs": "New needs analysis",
      "new_quote": "New quotation",
      "log_contact": "Log a conversation",
      "new_service": "New service request",
      "new_claim": "New claim",
      "new_opportunity": "New opportunity",
      "new_proposal": "New proposal",
      "data_quality": "Check data quality",
      "start_my_day": "Start my day",
      "add_policy": "Add policy",
      "add_lead": "Add lead",
      "new_campaign": "New campaign",
      "upload_document": "Upload document",
      "ask": "Ask AVRASTRO",
      "sync": "Sync now",
      "tax_center": "Tax Center"
    },
    "ai_hint": "search or type an action",
    "policies": "Policies",
    "quotes": "Quotations",
    "documents": "Documents",
    "children": "Children",
    "companies": "Companies",
    "tasks": "Tasks",
    "notes": "Notes"
  },
  "timeline": {
    "person_created": "Relationship created",
    "person_archived": "Archived",
    "note_added": "Note added",
    "review_completed": "Annual review recorded",
    "policy_issued_from_case": "Issued from application",
    "imported": "Imported from VÉRO {version}",
    "needs_finalized": "Needs analysis finalised",
    "quote_added": "Quotation added",
    "opportunity_opened": "Opportunity opened",
    "referral_given": "Gave a referral",
    "referral_thanked": "Thanked for a referral",
    "referral_converted": "Referral converted",
    "meeting_held": "Meeting held",
    "claim_opened": "Claim opened",
    "consent_granted": "Consent granted",
    "consent_withdrawn": "Consent withdrawn",
    "merged": "Merged duplicate record",
    "proposal_issued": "Proposal issued",
    "search": "Search the timeline",
    "premium_increase": "Premium increased",
    "premium_decrease": "Premium decreased",
    "premium_reversal": "Premium change reversed",
    "payment_late": "Late payment noted",
    "payment_ok": "Payment up to date",
    "tax_snapshot": "Tax calculation saved",
    "extraction_applied": "Values from a document applied",
    "policy_offer": "Policy set to offer",
    "policy_pending": "Policy pending",
    "policy_active": "Policy active",
    "policy_renewed": "Policy renewed",
    "policy_lapsed": "Policy lapsed",
    "policy_cancelled": "Policy cancelled",
    "policy_matured": "Policy matured",
    "renewal_renewed": "Renewal recorded",
    "renewal_lapsed": "Not renewed",
    "renewal_declined": "Renewal declined by client",
    "referral_attempt": "Contacted a person they introduced",
    "payslip_analysed": "Payslip analysed (tax estimate)",
    "insured_item_added": "Insured item added",
    "insured_item_sold": "Insured item sold",
    "insured_item_archived": "Insured item archived",
    "gi_renewal_requested_quotes": "Renewal: quotes requested",
    "gi_renewal_compared": "Renewal: quotes compared",
    "gi_renewal_sent_to_client": "Renewal: sent to the client",
    "gi_renewal_approved": "Renewal: approved by the client",
    "gi_renewal_renewed": "Renewal: renewed",
    "gi_renewal_lost": "Renewal: lost",
    "premium_overdue": "Overdue premium recorded",
    "premium_paid": "Overdue premium paid",
    "premium_lapsed": "Overdue premium not paid — lapsed",
    "nps_prepared": "Feedback survey prepared",
    "nps_answered": "Feedback received",
    "kyc_created": "KYC/AML file opened",
    "kyc_updated": "KYC/AML file checked",
    "client_report": "Reported by the client through the portal",
    "esign_signed": "Document signed electronically",
    "sale_file_created": "Sale file (IDD) opened",
    "sale_file_complete": "Sale file (IDD) complete",
    "sale_file_reopened": "Sale file (IDD) needs completing again",
    "do_not_call_on": "Marked “Do not call”",
    "do_not_call_off": "“Do not call” removed",
    "risk_profile_imported": "Risk profile from avrastro.com",
    "risk_profile_saved": "New risk profile",
    "family_added": "Relative added",
    "summary_meeting": "Personal meeting summary",
    "summary_transparency": "Transparency summary",
    "summary_shared": "Summary in the client’s portal",
    "policy_deleted": "Policy deleted (entered in error)",
    "policy_restored": "Deleted policy restored",
    "policy_entered_in_error": "Policy marked as entered in error"
  },
  "template": {
    "appointment_confirm": "Hello {first}, this confirms our meeting on {date} at {time}{location, select, none {} other {, {location}}}. {signature}",
    "appointment_subject": "Our meeting on {date}",
    "birthday": "Happy birthday, {first}! Wishing you health and a wonderful year. {signature}",
    "nameday": "Happy name day, {first}! Wishing you all the best. {signature}",
    "review_invite": "Hello {first}, it's time for our annual review of your cover — would you have 30 minutes this week? {signature}"
  },
  "errors": {
    "person": {
      "not_found": "Person not found",
      "name_required": "Please enter a name",
      "client_since_invalid": "The client-since date is not a valid date",
      "client_since_future": "The client-since date cannot be in the future"
    },
    "task": {
      "title_required": "Please enter a title",
      "appointment_needs_datetime": "Appointments need a date and a time",
      "not_found": "Task not found",
      "not_open": "This task is no longer open.",
      "same_date": "Choose a different date."
    },
    "case": {
      "product_required": "Please enter the product",
      "not_found": "Case not found",
      "not_closed": "The application is still open.",
      "reopen_issued": "An issued application cannot be reopened — work on the policy instead."
    },
    "policy": {
      "product_required": "Please enter the product name",
      "invalid_transition": "This status change is not allowed from the current status.",
      "negative_premium": "The premium cannot be negative.",
      "not_found": "Policy not found.",
      "same_status": "The policy already has this status.",
      "deleted": "This policy was deleted. Restore it first to change it.",
      "already_deleted": "This policy is already deleted.",
      "not_deleted": "This policy is not deleted.",
      "delete_reason_required": "Please give a reason (at least 3 characters).",
      "stepup_required": "Confirm with your password and authenticator code first.",
      "restore_window_passed": "The restore period has passed."
    },
    "note": {
      "empty": "The note is empty",
      "not_found": "Note not found"
    },
    "prospect": {
      "not_found": "Prospect not found",
      "already_converted": "Already converted"
    },
    "prospect_list": {
      "name_required": "Please name the list",
      "not_found": "List not found"
    },
    "requirement": {
      "not_found": "Requirement not found",
      "status_invalid": "Unknown document status.",
      "waiting_invalid": "Unknown party."
    },
    "import": {
      "invalid_json": "This file is not valid JSON or an AVRASTRO backup.",
      "password_required": "This backup is encrypted — enter its password.",
      "bad_password": "Wrong password or damaged file.",
      "unsupported": "Unsupported file: no AVRASTRO data found.",
      "checksum": "Checksum mismatch — the file was changed or damaged."
    },
    "storage": {
      "failed": "Could not save. Your change was not applied.",
      "quota": "Storage is full. Export a backup and free space.",
      "blocked": "Another AVRASTRO window is updating the database. Close it and try again.",
      "newer_schema": "This data was saved by a newer version of AVRASTRO. Please update the app.",
      "verify_failed": "The data could not be verified, so nothing was changed."
    },
    "comparison": {
      "not_found": "Comparison not found",
      "locked": "This comparison is decided and locked",
      "no_plans": "Add at least one plan"
    },
    "undo": {
      "conflict": "Can't undo — the record changed since"
    },
    "screen": {
      "title": "This screen hit a problem",
      "body": "Your data is safe. The error was logged in Diagnostics (Data & safety).",
      "retry": "Try again"
    },
    "needs": {
      "locked": "This needs analysis is final. Open a new revision to change it.",
      "not_found": "Needs analysis not found"
    },
    "quote": {
      "product_required": "Enter the product",
      "not_found": "Quotation not found"
    },
    "opportunity": {
      "title_required": "Give the opportunity a title",
      "not_found": "Opportunity not found"
    },
    "referral": {
      "name_required": "Enter the referred person's name",
      "not_found": "Referral not found",
      "already_converted": "Already converted",
      "outcome_invalid": "Unknown outcome."
    },
    "communication": {
      "no_party": "Choose who the conversation was with"
    },
    "meeting": {
      "not_found": "Meeting not found"
    },
    "claim": {
      "type_required": "Enter the claim type"
    },
    "service": {
      "title_required": "Describe the request"
    },
    "document": {
      "title_required": "Give the document a name",
      "not_found": "Document not found"
    },
    "consent": {
      "purpose_required": "Choose a purpose"
    },
    "template": {
      "invalid": "The template needs a text"
    },
    "merge": {
      "same": "Choose two different people"
    },
    "adjustment": {
      "already_reversed": "This change has already been reversed.",
      "amount_invalid": "Enter a valid amount.",
      "date_required": "Choose the date the change takes effect.",
      "is_reversal": "A reversal cannot itself be reversed — record a new change instead.",
      "negative": "The premium cannot become negative.",
      "no_change": "The new premium is the same as the current one.",
      "not_found": "This premium change no longer exists.",
      "reason_required": "Please give a reason.",
      "single_premium_instalment": "A single-premium policy has no instalments — change the one-off amount instead."
    },
    "automation": {
      "action_not_allowed": "Automations can only create tasks.",
      "due_invalid": "Due days must be between 0 and 365.",
      "name_required": "Give the rule a name.",
      "not_found": "This rule no longer exists."
    },
    "campaign": {
      "already_launched": "This campaign has already started.",
      "closed": "This campaign is closed and can no longer be changed.",
      "not_found": "Campaign not found.",
      "not_prepared": "Check and freeze the audience first.",
      "segment_required": "Choose a segment for the audience.",
      "title_required": "Give the campaign a title.",
      "objective_invalid": "Unknown campaign objective."
    },
    "commission": {
      "not_found": "Commission line not found.",
      "rate_invalid": "The rate must be between 0 and 100%.",
      "mapping": "Choose the policy number, amount and period columns.",
      "nothing_to_accept": "There is nothing on the statement to accept for this line.",
      "already_accepted": "This statement line was already accepted.",
      "already_paid": "The expected commission is already recorded as paid."
    },
    "crypto": {
      "already_enabled": "Encryption is already on.",
      "not_enabled": "Encryption is not switched on.",
      "passphrase_too_short": "Use at least 10 characters.",
      "wrong_passphrase": "That passphrase or recovery key is not correct."
    },
    "custom": {
      "entity_invalid": "Custom fields are not available for this record type.",
      "in_use": "This field already holds values, so its key and type cannot change.",
      "key_exists": "A field with this key already exists.",
      "key_invalid": "Use lower-case letters, digits and _ only, starting with a letter.",
      "label_required": "Give the field a label.",
      "not_date": "Enter a valid date.",
      "not_number": "Enter a number.",
      "not_option": "Choose one of the listed options.",
      "options_required": "A choice field needs at least one option.",
      "required": "This field is required.",
      "unknown_field": "Unknown custom field."
    },
    "extraction": {
      "closed": "This review is already closed.",
      "invalid_amount": "One of the accepted amounts is not a valid number.",
      "invalid_rate": "The interest rate must be between 0 and 100%.",
      "no_person": "Link the document to a person first.",
      "not_found": "Review not found.",
      "nothing_accepted": "Accept or correct at least one value first.",
      "policy_required": "Choose the policy these values belong to."
    },
    "financial": {
      "not_found": "This item no longer exists.",
      "rate_invalid": "The rate must be between 0 and 100%.",
      "type_required": "Choose a type."
    },
    "production": {
      "duplicate_key": "The production ledger contains a duplicate entry."
    },
    "record": {
      "not_found": "Record not found."
    },
    "renewal": {
      "negative": "The renewal premium cannot be negative.",
      "not_found": "Renewal not found."
    },
    "tax": {
      "already_approved": "These rules are already approved.",
      "band_rate_invalid": "Each band rate must be between 0% and 100%.",
      "bands_required": "Add at least one tax band.",
      "ruleset_not_found": "Tax rules not found.",
      "snapshot_not_found": "Saved calculation not found.",
      "source_required": "Name the official source of these rules.",
      "year_invalid": "Enter a valid tax year."
    },
    "workspace": {
      "read_only": "This device is read-only until you sign in to sync again.",
      "read_only_licence": "Your subscription has ended, so AVRASTRO is read-only. Your data is safe — renew in Account to make changes.",
      "read_only_plan": "This part of AVRASTRO is not included in your current plan, so its records are read-only. Nothing has been deleted."
    },
    "branding": {
      "scope_invalid": "Unknown branding profile.",
      "not_found": "The branding profile no longer exists.",
      "image_invalid": "Only PNG, JPEG or WebP images up to about 500 KB can be stored.",
      "email_invalid": "Check the e-mail address.",
      "website_invalid": "Check the website address.",
      "accent_invalid": "Use a colour like #9A7427.",
      "mode_invalid": "Unknown branding mode.",
      "signature_not_owner": "This signature image belongs to another user and can only be changed or used by them."
    },
    "checklist": {
      "name_required": "Give the checklist a name.",
      "items_required": "Add at least one item.",
      "not_found": "The checklist no longer exists."
    },
    "group": {
      "not_found": "Group plan not found",
      "employer_required": "Please enter the employer",
      "category": "Unknown category",
      "status": "Unknown status",
      "employer_share": "The employer share must be between 0 and 100%",
      "member_name_required": "Please enter the member's name",
      "member_not_found": "Member not found",
      "class": "Unknown class",
      "leave_before_join": "The leave date is before the join date",
      "census_empty": "The file has no rows",
      "renewal_date_required": "Add the renewal date first",
      "renewal_task_exists": "A follow-up for this renewal already exists"
    },
    "intake": {
      "revoked": "The client withdrew this share",
      "no_contact": "There is no name, e-mail or phone to create a record",
      "bad_time": "The appointment time is not valid",
      "kind": "Unknown item type"
    },
    "payslip": {
      "no_gross": "Enter the gross pay first."
    },
    "insured": {
      "not_found": "This insured item no longer exists.",
      "person_fixed": "An insured item stays with its client.",
      "kind": "Unknown item type.",
      "status": "Unknown item status.",
      "year": "The year does not look right.",
      "year_built": "The year built does not look right.",
      "amount": "Amounts and areas must be numbers of zero or more.",
      "ncd": "No-claims years must be a whole number from 0 to 60.",
      "employees": "Employees must be a whole number of zero or more.",
      "date": "A due date is not a valid date.",
      "policy": "A linked policy must belong to the same client.",
      "label_required": "Please enter a name, registration, address or activity."
    },
    "gi_renewal": {
      "not_general": "This is not a general-insurance policy.",
      "stage": "Unknown renewal stage.",
      "no_date": "The policy has no renewal or start date.",
      "closed": "This renewal is already decided.",
      "same_stage": "The renewal is already at this stage."
    },
    "premium": {
      "not_found": "This overdue premium no longer exists.",
      "closed": "This item is already closed (paid or lapsed).",
      "policy_fixed": "An overdue premium stays with its policy.",
      "amount": "The amount must be a number greater than zero.",
      "due_date": "Please enter a valid due date.",
      "future": "The due date cannot be in the future.",
      "duplicate": "An open overdue premium with this due date is already recorded for this policy.",
      "status": "Unknown status.",
      "mapping": "Choose the policy number, amount and due date columns."
    },
    "schedule": {
      "product_required": "Please enter the product or class of insurance.",
      "premium": "Please enter the premium (a number of zero or more).",
      "sum": "The sum insured must be a number of zero or more.",
      "date": "A date is not valid.",
      "dates": "The end date is before the start date.",
      "frequency": "Unknown payment frequency.",
      "duplicate": "A policy with this number already exists."
    },
    "nps": {
      "archived": "This person is archived.",
      "ref": "The meeting or claim was not found for this client.",
      "meeting_not_held": "Record the meeting outcome first.",
      "claim_not_closed": "The claim is not closed yet.",
      "duplicate": "A survey was already prepared for this.",
      "token": "The survey link is not valid.",
      "not_found": "The survey was not found.",
      "closed": "This survey is already answered or withdrawn.",
      "score": "The score must be a whole number from 0 to 10.",
      "not_promoter": "Only a 9 or 10 leads to a review request."
    },
    "kyc": {
      "document": "Choose an identity document from this client's vault.",
      "pep": "Answer the politically exposed person question.",
      "risk": "Choose a risk level.",
      "share": "A beneficiary's share must be between 0 and 100%.",
      "share_total": "The beneficiaries' shares add up to more than 100%.",
      "id_number": "Identity, passport, tax or bank numbers do not belong in these fields — keep them on the document in the vault.",
      "date": "That date is not valid.",
      "future": "The check date cannot be in the future."
    },
    "creport": {
      "kind": "Unknown report type.",
      "id": "The report reference is not valid.",
      "accepted": "This report was already accepted.",
      "policy": "That policy does not belong to this client."
    },
    "voice": {
      "consent_required": "No consent from the client to record this meeting.",
      "nothing_kept": "Nothing is ticked to save.",
      "meeting_not_found": "The meeting was not found.",
      "dictation_confirm": "Confirm that you are recording only your own voice."
    },
    "whatsapp": {
      "use": "Unknown WhatsApp message type."
    },
    "setup": {
      "step": "Unknown setup step.",
      "lines_required": "Choose at least one class: life or general.",
      "capacity": "Choose a capacity from the list.",
      "reg_no": "The register number is too long.",
      "time": "That time is not valid.",
      "hours_order": "The closing time must be after the opening time.",
      "https": "The link must start with https:// — nothing changed.",
      "minutes": "The length must be between 10 and 240 minutes."
    },
    "client_import": {
      "stage": "Choose clients or prospects.",
      "empty": "There is nobody new to import.",
      "too_many": "Up to 5,000 rows at a time — split the file."
    },
    "sale_file": {
      "not_found": "The sale file was not found.",
      "person": "The file belongs to another person.",
      "line": "Choose the kind of sale.",
      "advice": "Choose whether advice was given.",
      "channel": "Choose how the sale was made.",
      "policy": "The policy does not belong to this client.",
      "policy_has_file": "This policy already has a sale file.",
      "needs": "The needs analysis does not belong to this client.",
      "case": "The application does not belong to this client.",
      "date": "The sale date is not valid.",
      "future": "The sale date cannot be in the future.",
      "check_date": "A disclosure date is not valid or is in the future.",
      "document": "Choose a document from this client's documents.",
      "risk_profile": "The risk profile does not belong to this client."
    },
    "next_action": {
      "task_exists": "The task for this action already exists."
    },
    "lesson": {
      "slug": "Unknown lesson.",
      "quiz": "The quiz result is not valid."
    },
    "call": {
      "outcome": "Choose the outcome of the call.",
      "no_target": "The call is not linked to anyone.",
      "do_not_call": "This number is marked “Do not call”.",
      "day": "The call date is not valid.",
      "future": "A call cannot be in the future.",
      "hour": "The call hour is not valid.",
      "callback_date": "Set when you will call back.",
      "callback_past": "The date cannot be before the call.",
      "meeting_time": "Set the date and time of the meeting.",
      "lawful_basis": "Choose a lawful basis from the list."
    },
    "risk": {
      "incomplete": "Answer every question.",
      "override_reason": "Write why you choose another profile than the indicative one.",
      "source": "Unknown profile source.",
      "date": "The date is not valid.",
      "future": "The date cannot be in the future.",
      "duplicate": "This result has already been imported.",
      "level": "No risk profile was found.",
      "task_exists": "A review task already exists."
    },
    "family": {
      "not_found": "The relative was not found.",
      "relation": "Choose a relation.",
      "self": "A person cannot be their own relative.",
      "name_required": "Write a name or choose a person.",
      "date": "The date is not valid.",
      "birth_future": "The date of birth cannot be in the future.",
      "pays": "Choose who pays.",
      "duplicate": "This person is already on the family map."
    },
    "summary": {
      "kind": "Unknown kind of summary.",
      "lang": "Choose Greek, English or Russian.",
      "not_found": "The summary was not found.",
      "shared": "The summary has already been shared; create a new one.",
      "meeting": "The meeting does not belong to this client.",
      "title": "Write a title.",
      "empty": "The summary is empty."
    },
    "radar": {
      "task_exists": "A task for this already exists."
    },
    "recommendation": {
      "approval_required": "Tick «I approve» first — a suggested campaign is created only with your approval.",
      "unknown_theme": "This campaign theme no longer exists.",
      "channel": "Choose a channel for the campaign.",
      "already_running": "A campaign with this theme is already in progress."
    },
    "market_note": {
      "title_required": "Give the note a title.",
      "source_required": "A market note needs its source (publication, organisation or website).",
      "date_invalid": "Give the publication date (today or earlier).",
      "url_invalid": "The link must start with http:// or https://.",
      "theme_required": "Choose at least one campaign theme the note is relevant to."
    },
    "day_report": {
      "day": "A report can be saved for today or an earlier day.",
      "rating": "The self-rating is a whole number from 1 to 5.",
      "metric": "Unknown figure in the report.",
      "value": "Your own entries are whole numbers from 0 to 9999.",
      "goals": "Goals met cannot be more than the goals set (at most 99)."
    },
    "catalog": {
      "name_required": "Please enter a name.",
      "name_too_long": "The name is too long (120 characters at most).",
      "duplicate": "This name is already in the list.",
      "not_found": "This catalogue entry no longer exists.",
      "mismatch": "Insurer, category and plan do not belong together.",
      "in_use": "Policies or entries below it use it — deactivate it instead.",
      "move_insurer": "An entry cannot move to another insurer.",
      "category": "Unknown policy type.",
      "branch": "Unknown line of business.",
      "dates": "«Sold until» is before «sold from»."
    },
    "plan": {
      "time": "Enter a start and an end time.",
      "end_before_start": "The end must be after the start.",
      "too_short": "A block lasts at least 5 minutes.",
      "too_long": "A block lasts at most 12 hours.",
      "day": "Not a valid day.",
      "kind": "Unknown block type.",
      "title_required": "Give the block a title.",
      "overlaps_appointment": "This time overlaps an appointment — nothing was changed.",
      "appointment_fixed": "Appointments are not moved from the planner — open the appointment instead.",
      "not_found": "Block not found.",
      "block_closed": "This block is already done or cancelled.",
      "task_planned": "This task is already planned for that day.",
      "after_midnight": "The block would end after midnight.",
      "same_day": "Choose a date other than the one you are planning.",
      "nothing_to_move": "There are no blocks of yours on that day.",
      "nothing_to_copy": "Nothing to copy (or everything falls on something already planned).",
      "template_nothing": "The template does not fit: all its blocks fall on something already planned.",
      "template_name": "Give the template a name.",
      "template_empty": "The day has no blocks for a template.",
      "template_limit": "Up to 20 templates of your own.",
      "template_not_found": "Template not found.",
      "no_suggestions": "There are no suggestions."
    },
    "goals": {
      "day": "Not a valid day.",
      "not_found": "There are no goals for this day yet.",
      "type": "Unknown goal.",
      "target": "Enter a number from 0 up to the limit of this goal.",
      "market_text": "Write the market note.",
      "market_source": "Add where the market note comes from.",
      "market_url": "The link must start with http:// or https://."
    },
    "taxf": {
      "year_invalid": "Invalid tax year.",
      "year_not_found": "The year’s folder was not found.",
      "email_invalid": "Please check the e-mail address.",
      "category_unknown": "Unknown category.",
      "category_label_required": "Please name the category.",
      "date_invalid": "Invalid date.",
      "amount_invalid": "Invalid amount.",
      "expected_not_found": "The expected document was not found.",
      "document_not_in_folder": "The file does not belong to this folder.",
      "item_not_found": "The document was not found.",
      "item_other_year": "The document belongs to another year.",
      "title_required": "Please enter a title."
    }
  },
  "boot": {
    "volatile": "Storage is unavailable in this window — changes are kept only until you close it. Export a backup to keep them.",
    "opening": "Opening workspace…",
    "failed": "The workspace could not be opened.",
    "recover": "Open recovery tools"
  },
  "demo": {
    "banner": "Demo workspace with fictional people. Import your own data from Data & safety.",
    "load": "Load demo data",
    "clear": "Start empty"
  },
  "briefing": {
    "title": "Daily briefing",
    "meetings": "{count, plural, one {One meeting today} other {# meetings today}} — {count, plural, one {it is} other {next}} at {time} with {name} ({title}).",
    "no_meetings": "No meetings today{count, plural, =0 {.} one { — a good day for # important call.} other { — a good day for # important calls.}}",
    "overdue": "{count, plural, one {One action is overdue} other {# actions are overdue}}; the oldest is “{title}” with {name}.",
    "cases": "{count, plural, one {One application has stalled} other {# applications have stalled}}: {product} for {name} has been in {stage} for {days} days{missing, plural, =0 {.} one { with # document missing.} other { with # documents missing.}}",
    "cases_moving": "{count, plural, one {Your active application is moving.} other {All # active applications are moving.}}",
    "birthday": "{name} celebrates a birthday today — turning {age}.",
    "nameday": "{name} celebrates a name day today ({feast}).",
    "reviews": "{count, plural, one {One client is due for an annual review} other {# clients are due for an annual review}}; the largest portfolio is {name} ({amount, number, currency}).",
    "gaps": "{count, plural, one {One family has children and no life cover} other {# families have children and no life cover}} — start with {name}.",
    "start_flow": "Start Flow",
    "generated": "Written by AVRASTRO from your data · {time}",
    "promises": "{count, plural, one {You have one promise due} other {You have # promises due}} — “{title}” for {name}.",
    "decisions": "{count, plural, one {One client is deciding} other {# clients are deciding}}; {name} has been weighing “{title}” for {days} days.",
    "waiting": "{count, plural, one {You are waiting on one client reply.} other {You are waiting on # client replies.}}"
  },
  "flow": {
    "title": "Flow",
    "subtitle": "One relationship at a time. AVRASTRO keeps the order; you make the calls.",
    "progress": "{done} of {total} cleared",
    "start": "Start Flow",
    "resume": "Continue Flow",
    "done_title": "Your book is clear",
    "done_body": "{count, plural, one {You cleared # item.} other {You cleared # items.}} Everything else is scheduled.",
    "skip": "Skip",
    "snooze": "Tomorrow",
    "note": "Log note",
    "exit": "Exit Flow",
    "context": "Context",
    "last_contact": "Last contact",
    "portfolio": "Portfolio",
    "open_cases": "Open cases",
    "keys": "Keys",
    "logged": "Logged — next relationship",
    "empty": "Nothing needs you right now.",
    "days_ago": "{days, plural, =0 {today} one {# day ago} other {# days ago}}",
    "keys_log": "log the conversation",
    "keys_move": "suggested move",
    "outcome": {
      "positive": "Spoke — positive",
      "neutral": "Spoke — neutral",
      "negative": "No answer / not now"
    },
    "outcome_q": "How did it go?",
    "outcome_title": {
      "positive": "Call — positive: {reason}",
      "neutral": "Call — neutral: {reason}",
      "negative": "Call — no answer: {reason}"
    }
  },
  "capture": {
    "title": "Capture",
    "placeholder": "Type naturally: “ραντεβού με Άννα αύριο 10:30” or “call George Friday 3pm”",
    "understood": "AVRASTRO understood",
    "create": "Create {kind}",
    "no_person": "No person linked",
    "choose_person": "Did you mean",
    "hint": "Enter to create · Tab to choose a person",
    "kind_note": "Note",
    "kind_case": "Application",
    "created": "{kind} created",
    "needs_time": "Needs a time — opens the form"
  },
  "coverage": {
    "title": "Coverage radar",
    "subtitle": "Protection held vs. what this life stage needs",
    "area": {
      "life": "Life",
      "health": "Health",
      "income": "Income",
      "savings": "Savings & pension",
      "education": "Education",
      "property": "Property"
    },
    "need": {
      "0": "Not needed",
      "1": "Good to have",
      "2": "Important",
      "3": "Essential"
    },
    "held": {
      "0": "No cover",
      "0.5": "Offered",
      "1": "Covered"
    },
    "reason": {
      "dependents": "Dependent children rely on this income",
      "partner": "A partner relies on this income",
      "debts": "Covers debts and final expenses",
      "none": "Not relevant at this life stage",
      "health": "Everyone needs medical cover",
      "income": "Working age — income is the biggest asset",
      "retiring": "Close to retirement",
      "retirement": "Retirement savings horizon",
      "children_education": "Children's education ahead",
      "property": "Home and belongings",
      "needs_analysis": "From the needs analysis"
    },
    "gaps": "{count, plural, =0 {No gaps} one {# gap} other {# gaps}}",
    "score": "Coverage {score}%",
    "opportunities": "Coverage opportunities",
    "opportunities_hint": "Clients with an essential or important need and no active cover",
    "held_series": "Held",
    "need_series": "Needed"
  },
  "health": {
    "title": "Relationship health",
    "book": "Book health",
    "book_hint": "Premium-weighted across {count} clients",
    "band": {
      "strong": "Strong",
      "steady": "Steady",
      "watch": "Watch",
      "at_risk": "At risk"
    },
    "factor": {
      "coverage": "Coverage",
      "engagement": "Engagement",
      "review": "Review",
      "open_items": "Open items",
      "profile": "Profile"
    },
    "detail": {
      "coverage": "{gaps, plural, =0 {All needed areas covered} one {# coverage gap} other {# coverage gaps}}",
      "engagement": "Last contact {days, plural, =0 {today} one {# day ago} other {# days ago}}",
      "never": "No contact recorded",
      "open": "{overdue} overdue · {stalled} stalled · {missing} missing documents",
      "profile": "{filled} of {total} key details"
    },
    "why": "How this score is built",
    "book_empty": "Book health appears once you have clients with policies.",
    "column": "Health"
  },
  "constellation": {
    "title": "Constellation",
    "subtitle": "Your book as a living map — closer to the centre means it needs you sooner. Size is portfolio.",
    "legend_now": "Needs you now",
    "legend_soon": "Soon",
    "legend_calm": "Calm",
    "hint": "Hover to see why · click to open",
    "size": "Size = annual portfolio",
    "you": "You"
  },
  "prep": {
    "title": "Meeting prep",
    "open": "Meeting prep",
    "talking": "Talking points",
    "family": "Family",
    "holdings": "Holdings",
    "open_items": "Open items",
    "since": "Client since {date}",
    "point_gap": "Discuss {area}: {reason}",
    "point_review": "Annual review: {state}",
    "point_case": "Update on {product} ({stage})",
    "point_moment": "Mention: {what}",
    "point_renewal": "{product} renews on {date}",
    "none": "No open points — use the time to deepen the relationship.",
    "point_promise": "We promised: {text}",
    "point_waiting": "They promised: {text}",
    "point_decision": "Pending decision: {title} ({days} days)"
  },
  "undo": {
    "action": "Undo",
    "done": "Undone",
    "conflict": "Can't undo — the record changed since"
  },
  "comparator": {
    "title": "Policy comparator",
    "subtitle": "Compare up to three plans side by side — protection, cost and projected value, never mixed up",
    "new": "New comparison",
    "for": "For",
    "plan": "Plan {label}",
    "add_plan": "Add plan",
    "remove_plan": "Remove",
    "insurer": "Insurer",
    "product": "Product",
    "kind": "Type",
    "kinds": {
      "protection": "Protection",
      "savings": "Savings",
      "combined": "Protection + savings"
    },
    "monthly": "Monthly premium",
    "indexation": "Premium indexation %/yr",
    "term": "Term (years)",
    "cover": "Sum insured / benefit",
    "savings_share": "Savings share of premium %",
    "delay": "Months without allocation",
    "y1": "Year-1 charge %",
    "y2": "Year-2 charge %",
    "fee": "Annual fee %",
    "return": "Assumed return %",
    "guaranteed": "Guaranteed at maturity",
    "quotation": "Quotation no.",
    "results": "Results",
    "total_paid": "Total premium cost",
    "saved": "Comparison saved",
    "projected": "Projected value",
    "guaranteed_value": "Guaranteed value",
    "protection_cost": "Cost of protection & charges",
    "net_cost": "Net cost after projected value",
    "per1000": "Yearly premium per 1 000 cover",
    "breakeven": "Projected value exceeds premiums in",
    "breakeven_year": "year {year}",
    "never": "never",
    "charges_impact": "Lost to delays, charges & fees",
    "best": "Best",
    "chart": "Projected value vs. premiums paid",
    "chart_paid": "Premiums paid",
    "year": "Year {year}",
    "warn": {
      "no_cover": "No sum insured entered",
      "no_term": "No term entered",
      "long_delay": "12+ months without allocation",
      "high_charges": "Early charges consume most of the first two years",
      "fees_exceed_return": "Fees exceed the assumed return — the fund shrinks in real terms"
    },
    "decide": "Record decision",
    "decision": "Decision",
    "decisions": {
      "A": "Plan A",
      "B": "Plan B",
      "C": "Plan C",
      "later": "Will decide later",
      "none": "None of them"
    },
    "decided": "Decided {date}: {decision}",
    "locked": "This comparison is decided and locked. Open a copy to change it.",
    "copy": "Open as new draft",
    "empty": "No comparisons yet",
    "history": "Comparisons",
    "legacy": "Imported from the old CRM",
    "followup": "Follow-up date",
    "draft": "Draft",
    "chart_hint": "Solid: projected value · dashed: premiums paid. Hover for any year.",
    "copied": "New draft opened from the decided comparison",
    "decided_toast": "Decision recorded and locked",
    "disclaimer": "Projections use the assumed return and fees you entered; they are illustrations, not guarantees. Always attach the insurer's official quotation.",
    "followup_hint": "A follow-up will be added to the agenda (default in 7 days).",
    "lock_note": "Recording the decision freezes the plans, the results and the verdict as they are now. You can always open a copy.",
    "name": "Comparison name",
    "need_person": "Choose the client this comparison is for",
    "no_term": "Enter a term to see the projection",
    "plans": "plans",
    "section_cost": "Cost",
    "section_protection": "Protection",
    "section_savings": "Savings & value",
    "no_data": "Enter a monthly premium to see the projection"
  },
  "insights_v2": {
    "cohorts": "Portfolio by start year",
    "activity": "Activity — last 12 weeks",
    "funnel": "Pipeline",
    "health_dist": "Relationship health",
    "opportunities": "Coverage opportunities",
    "less": "Less",
    "more": "More",
    "weekday": "{count} completed",
    "at_risk": "Needs care first",
    "funnel_hint": "Applications that reached each stage (issued = converted).",
    "policies": "{count, plural, one {# policy} other {# policies}}"
  },
  "space": {
    "label": "Spaces",
    "today": "Today",
    "people": "People",
    "growth": "Growth",
    "advisory": "Advisory",
    "cases": "Cases",
    "intelligence": "Intelligence",
    "system": "System"
  },
  "dates": {
    "plus3": "+3 days",
    "plus7": "+1 week",
    "day": "Day",
    "month": "Month",
    "year": "Year",
    "ph_day": "DD",
    "ph_month": "MM",
    "ph_year": "YYYY",
    "clear": "Clear date",
    "year_hint": "↑ ↓ change the year · PgUp / PgDn by 10 years",
    "err_incomplete": "Enter the full date: day, month and year (4 digits).",
    "err_day": "The day must be from 1 to 31.",
    "err_month": "The month must be from 1 to 12.",
    "err_year": "Enter a year from {min} to {max}.",
    "err_no_such_day": "This date does not exist: that month has {days} days.",
    "err_feb29": "{year} is not a leap year: February has 28 days.",
    "err_before": "The date must be on or after {date}.",
    "err_after": "The date must be on or before {date}."
  },
  "rule": {
    "task_overdue": "Overdue actions",
    "promise_overdue": "Promises to clients",
    "waiting_client": "Waiting for the client",
    "appointment_today": "Meetings today",
    "case_stalled": "Stalled applications",
    "case_missing": "Missing application documents",
    "case_no_next": "Applications without a next action",
    "decision_pending": "Pending decisions",
    "quote_expiring": "Quotations expiring",
    "claim_followup": "Claims to follow",
    "service_open": "Open service requests",
    "review_overdue": "Reviews overdue",
    "review_never": "Never reviewed",
    "review_due_soon": "Reviews due soon",
    "renewal_soon": "Policy anniversaries",
    "protection_gap": "Protection gaps",
    "needs_missing": "Needs analysis missing",
    "no_next_step": "Offers without next step",
    "silence": "Long silence",
    "hot": "Warm opportunities",
    "prospect_followup": "Prospect follow-ups",
    "referral_thanks": "Referral thank-yous",
    "birthday": "Birthdays",
    "nameday": "Name days",
    "child_milestone": "Children's milestones",
    "data_quality": "Missing contact details",
    "policy_lapsed": "Lapsed policies",
    "payment_late": "Late payments",
    "life_event": "Life events",
    "loan_maturity": "Loans ending",
    "education_milestone": "Education milestones",
    "mortgage_gap": "Mortgage protection gaps",
    "extraction_review": "Document values to review",
    "sync_conflict": "Sync conflicts",
    "insured_due": "MOT and road tax due",
    "premium_overdue": "Overdue premiums",
    "kyc_review": "KYC/AML review due"
  },
  "hot": {
    "marked": "marked hot by you",
    "recent_interest": "{count, plural, one {reached out recently} other {reached out # times recently}}",
    "many_interactions": "{count} interactions this month",
    "active_quote": "has an open quotation",
    "pending_comparison": "is deciding on a comparison",
    "open_opportunity": "has an open opportunity",
    "application_started": "started an application",
    "referrer": "has referred people to you",
    "coverage_gap": "gap in {area}"
  },
  "journey": {
    "title": "Advisory journey",
    "profile": "Profile",
    "needs": "Needs",
    "proposal": "Proposal",
    "comparison": "Comparison",
    "decision": "Decision",
    "application": "Application",
    "policy": "Policy"
  },
  "needs": {
    "title": "Needs analysis",
    "subtitle": "First profile, needs, risk and tax in one versioned record",
    "new": "New needs analysis",
    "analysis": "Needs analysis",
    "start": "Start",
    "none": "None yet",
    "none_person": "No needs analysis for {name} yet.",
    "last": "Latest",
    "filter": {
      "all": "All",
      "missing": "Missing",
      "draft": "Draft",
      "final": "Final"
    },
    "status": {
      "draft": "Draft",
      "final": "Final"
    },
    "suggest": "Suggest",
    "suggested": "Suggestions filled in — review them",
    "saved": "Needs analysis saved",
    "finalize": "Finalise",
    "finalized": "Needs analysis finalised",
    "finalized_at": "finalised {date}",
    "revise": "New revision",
    "revised": "New revision opened",
    "locked": "Final and locked — open a new revision to change it.",
    "need_person": "Choose the client first",
    "profile": "First profile",
    "risk": "Risk profile",
    "risk_attitude": "Risk attitude",
    "vulnerability": "Vulnerability",
    "no_vulnerability": "No vulnerability indicators from the profile.",
    "level": {
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "areas": "Needs",
    "areas_hint": "Priority, target, existing cover and the gap — with your reasoning and the next action",
    "area": "Area",
    "priority": "Priority",
    "target": "Target",
    "existing": "Existing",
    "gap": "Gap",
    "reasoning": "Reasoning",
    "action": "Proposed action",
    "p": {
      "0": "—",
      "1": "Nice",
      "2": "Important",
      "3": "Essential"
    },
    "create_actions": "Create follow-ups for important needs with an action",
    "from_household": "{count} from household",
    "health_hint": "High-level only — no medical details",
    "area_label": {
      "life": "Life protection",
      "income": "Income protection (monthly)",
      "critical_illness": "Critical illness",
      "health": "Medical",
      "accident": "Personal accident",
      "mortgage": "Mortgage / loans",
      "retirement": "Retirement",
      "savings": "Savings",
      "education": "Education",
      "property": "Property",
      "business": "Business"
    },
    "basis": {
      "life_dependants": "Dependants rely on this income — about {years} years of income plus debts, minus savings",
      "life_debts": "Covers debts and final expenses",
      "mortgage": "Outstanding mortgage",
      "income": "About {pct}% of monthly income if unable to work",
      "critical_illness": "About {years} years of income",
      "health": "Everyone needs medical cover",
      "accident": "About one year of income",
      "retirement": "Retirement at {age}",
      "savings": "Emergency and goals",
      "education": "{children, plural, =0 {No children yet} one {One child's education} other {# children's education}}",
      "property": "Home and belongings",
      "business": "Business continuity"
    },
    "f": {
      "annualIncome": "Annual income",
      "partnerIncome": "Partner income",
      "monthlyExpenses": "Monthly expenses",
      "mortgage": "Mortgage balance",
      "liabilities": "Other debts",
      "savings": "Savings",
      "dependants": "Dependants",
      "retirementAge": "Retirement age",
      "smoker": "Smoker",
      "employment": "Employment",
      "employer": "Employer",
      "businessOwner": "Business owner",
      "goals": "Goals",
      "concerns": "Concerns",
      "existingCoverNotes": "Existing cover (other providers)",
      "healthNotes": "Health context"
    }
  },
  "risk": {
    "single_income": "Family of {dependants} relies mainly on one income",
    "debt_exposure": "Debts are {ratio}× annual income",
    "low_buffer": "Savings cover {months} months of expenses",
    "smoker": "Smoker — affects pricing and health risk",
    "business_owner": "Business owner — income tied to the business",
    "title": "Risk profile & suitability",
    "level": {
      "conservative": "Conservative",
      "cautious": "Cautious",
      "balanced": "Balanced",
      "growth": "Growth",
      "dynamic": "Dynamic"
    },
    "explain": {
      "conservative": "Keeping the capital comes first; little tolerance for ups and downs.",
      "cautious": "Mostly stability, with a little room for growth.",
      "balanced": "A balance between stability and growth; accepts moderate ups and downs.",
      "growth": "Aims at growth over time; accepts significant ups and downs.",
      "dynamic": "Maximum emphasis on growth; accepts large ups and downs over a long horizon."
    },
    "source": {
      "website": "from avrastro.com",
      "manual": "advisor’s questionnaire"
    },
    "import": "Import from avrastro.com",
    "questionnaire": "Risk questionnaire",
    "date": "Date",
    "source_label": "Source · version",
    "score": "Score",
    "goal": "Goal",
    "goal_ph": "e.g. retirement, a child’s studies",
    "goal_date": "When the money is needed",
    "goal_date_hint": "Used for the alert when the profile no longer fits the time left.",
    "time_to_goal": "Time to goal",
    "years": "{count, plural, one {# year} other {# years}}",
    "none": "No risk profile yet. Fill in the questionnaire or import the result the client shared from avrastro.com.",
    "none_short": "No risk profile",
    "history": "{count, plural, one {# version} other {# versions}}",
    "answers": "{count, plural, one {# answer} other {# answers}}",
    "disclaimer": "An aid for the advisor’s suitability assessment (IDD article 30); it is not a recommendation and names no product. Suitability is assessed by the advisor.",
    "create_task": "Review task",
    "task_created": "Task created",
    "task_title": "Review the risk profile: {name}",
    "new_version": "New version",
    "mismatch": {
      "horizon_short": "The “{level}” profile no longer fits {years} years to the goal (it fits up to “{fits}”).",
      "near_retirement": "Retirement is near ({years} years) with a “{level}” profile (it fits up to “{fits}”).",
      "goal_passed": "The goal date has passed — a new profile is worth doing.",
      "stale": "The profile is old — worth a review."
    },
    "questionnaire_intro": "Eight questions on time horizon, objective, reaction to a fall, ability to bear losses, knowledge, experience, income stability and reserves. The result is indicative; you decide.",
    "q": {
      "horizon": "When will you need most of this money?",
      "objective": "What is the main objective?",
      "reaction": "If the value fell 15% within a year, what would you do?",
      "loss_capacity": "What share of your savings could you lose without changing your plans?",
      "knowledge": "How would you describe your knowledge of investments?",
      "experience": "Have you held investment funds, shares or insurance-based investment products?",
      "income": "How stable is your income?",
      "reserves": "Do you have reserves for 3–6 months of expenses?"
    },
    "opt": {
      "horizon": {
        "o1": "In less than 3 years",
        "o2": "In 3–7 years",
        "o3": "In 7–15 years",
        "o4": "In more than 15 years"
      },
      "objective": {
        "o1": "Not to lose capital",
        "o2": "A steady income",
        "o3": "Balanced growth",
        "o4": "Growth over the long term"
      },
      "reaction": {
        "o1": "Withdraw everything",
        "o2": "Withdraw part",
        "o3": "Wait",
        "o4": "Add money"
      },
      "loss_capacity": {
        "o1": "None",
        "o2": "Up to 10%",
        "o3": "10–25%",
        "o4": "More than 25%"
      },
      "knowledge": {
        "o1": "None",
        "o2": "Basic",
        "o3": "Good",
        "o4": "Professional"
      },
      "experience": {
        "o1": "Never",
        "o2": "Once",
        "o3": "For a few years",
        "o4": "Regularly"
      },
      "income": {
        "o1": "Uncertain",
        "o2": "Variable",
        "o3": "Stable",
        "o4": "Very stable, with reserves"
      },
      "reserves": {
        "o1": "No",
        "o2": "Partly",
        "o3": "Yes",
        "o4": "More than that"
      }
    },
    "indicative": "Indicative profile: {level} ({score}/{max})",
    "capped": {
      "horizon": "Capped at “Cautious” because of a short time horizon.",
      "loss_capacity": "Capped at “Cautious”: no ability to bear losses.",
      "knowledge": "Capped at “Balanced”: no knowledge and no experience."
    },
    "override": "Profile recorded",
    "override_hint": "You may choose another profile than the indicative one; then write the reason.",
    "keep_indicative": "The indicative one",
    "override_reason": "Reason",
    "save": "Save as a new version",
    "saved": "Risk profile saved",
    "import_hint": "When the client shares the risk questionnaire result from avrastro.com, it is imported on its own when you accept the share in the Inbox. Here you can paste the result (JSON) by hand too.",
    "import_save": "Import",
    "import_unreadable": "No profile or score was found in this text.",
    "from_score": "The profile comes from the score (the result did not name it).",
    "in_sale_file": "Risk profile for suitability",
    "pick": "Choose a version",
    "use_latest": "The latest",
    "sale_file_hint": "Filled in on the client card → “Risk profile”."
  },
  "tax": {
    "title": "Tax estimate",
    "no_ruleset": "No tax rules are available for region {region} yet.",
    "provident": "Provident fund / year",
    "pension": "Pension fund / year",
    "medical": "Medical fund / year",
    "housing": "Housing interest or rent",
    "household_income": "Household income",
    "si_actual": "Social insurance (actual)",
    "si_hint": "Leave empty to estimate",
    "cap": "Relief limit (1/5 of income)",
    "used": "Used",
    "capacity": "Remaining capacity",
    "life_relief": "Life premium relief",
    "saving": "Estimated tax saving",
    "marginal": "Marginal rate",
    "capacity_hint": "Up to {amount} of additional life or pension contributions would still qualify — about {saving} less tax per year.",
    "enter_income": "Enter the annual income to see the estimate.",
    "disclaimer": "Estimate using ruleset {id} (checked {date}). Not tax advice — confirm with the client's tax adviser.",
    "note": {
      "si_estimated": "Social insurance estimated from the standard rate.",
      "life_no_sum_insured": "A life policy has no sum insured recorded — relief assumed at the full premium.",
      "cap_reached": "Contributions already exceed the relief limit.",
      "household_income_assumed": "Household income not entered — the child allowance limit was assumed to be met.",
      "housing_over_threshold": "Household income is above the limit — no housing interest/rent relief.",
      "provident_limited": "Pension and provident fund contributions are limited to 10% of pay."
    }
  },
  "quotes": {
    "title": "Quotations",
    "subtitle": "Every quote stays visible until it is accepted, declined or expires",
    "new": "New quotation",
    "edit": "Edit quotation",
    "saved": "Quotation saved",
    "empty": "No quotations yet.",
    "insurer": "Insurer",
    "product": "Product",
    "number": "Quote no.",
    "premium": "Premium",
    "expiry": "Valid until",
    "url": "Link to the PDF",
    "followup": "Follow-up on",
    "valid_until": "valid until {date}"
  },
  "proposal": {
    "title": "Proposals",
    "subtitle": "Client-facing proposals built from needs, quotations and comparisons",
    "new": "New proposal",
    "studio": "Proposal studio",
    "name": "Proposal title",
    "default_title": "Protection & savings proposal",
    "empty": "No proposals issued yet.",
    "recommendations": "Recommendations",
    "no_needs": "No needs analysis yet — recommendations will be empty until you complete one.",
    "close_gap": "Close the {area} gap",
    "rationale": "Rationale",
    "rationale_hint": "Why this recommendation fits the client",
    "assumptions": "Assumptions",
    "default_assumptions": "Projections use the assumed returns and charges shown in the comparison. Premiums and benefits follow the insurer's official quotation.",
    "preview": "Preview",
    "issue": "Issue & print",
    "issued": "Proposal issued",
    "prepared_for": "Prepared for {name} · {date}",
    "signatures": "Client signature · Advisor signature",
    "version_note": "Issuing creates a numbered version dated {date} in the client's documents and timeline.",
    "section": {
      "situation": "Situation",
      "needs": "Needs",
      "recommendations": "Recommendations",
      "quotes": "Quotations",
      "comparison": "Comparison",
      "tax": "Tax",
      "next_steps": "Next steps"
    }
  },
  "print": {
    "pdf_hint": "For a PDF: in the print dialog choose «Save as PDF» (Mac: the «PDF» button at the bottom left · Windows: the «Microsoft Print to PDF» printer).",
    "notes_space": "Extra space for handwritten notes",
    "paper_letter": "US Letter",
    "paper_a4": "A4",
    "paper": "Paper size",
    "orientation_landscape": "Landscape",
    "orientation_portrait": "Portrait",
    "orientation": "Orientation",
    "studio": "Print studio",
    "studio_hint": "Choose the sections to include — one print service, your branding.",
    "sections": "Sections",
    "section": {
      "identity": "Identity",
      "policies": "Policies",
      "coverage": "Coverage",
      "needs": "Needs",
      "comparisons": "Comparisons",
      "applications": "Applications",
      "meetings": "Meetings",
      "notes": "Notes",
      "review": "Review",
      "next_actions": "Next actions",
      "protection": "Protection map",
      "finances": "Income, loans & goals",
      "tax": "Tax",
      "renewals": "Renewals",
      "life_events": "Life events",
      "review_changes": "Changes since last review"
    },
    "report": {
      "client_review": "Client review",
      "needs_analysis": "Needs analysis",
      "insurance_summary": "Insurance summary",
      "family_protection": "Family protection",
      "tax_planning": "Tax planning",
      "renewal_summary": "Renewal summary",
      "meeting_summary": "Meeting summary",
      "proposal_summary": "Proposal summary"
    },
    "prepared_for": "Prepared for",
    "page": "Page",
    "of": "of",
    "confidential": "Confidential — prepared for the client named above.",
    "client_report": "Client report",
    "confidential_short": "Confidential",
    "plan_title": "Day plan",
    "plan_more": "more — see «Plan»",
    "plan_in_crm": "in the CRM",
    "plan_due": "CRM calls and follow-ups (no time)",
    "plan_notes": "Notes",
    "blank_title": "Day plan"
  },
  "pipeline": {
    "title": "Pipeline",
    "subtitle": "{open} open · {won} won this year · {value}",
    "new": "New opportunity",
    "opportunity": "Opportunity",
    "stage": "Stage",
    "expected": "Expected annual premium",
    "target_close": "Target close",
    "next_action_date": "Next action on",
    "advance": "Advance",
    "moved": "Moved to {stage}",
    "won": "Won 🎉",
    "close_by": "close by {date}",
    "why_hot": "Why it's warm",
    "no_signals": "No warm signals right now.",
    "empty": "No opportunities.",
    "show_closed": "Show closed",
    "hide_closed": "Hide closed"
  },
  "decisions": {
    "title": "Pending decisions",
    "subtitle": "Comparisons, quotations and opportunities waiting for the client's answer",
    "none": "Nothing is waiting for a decision.",
    "kind": {
      "comparison": "Comparison",
      "quotation": "Quotation",
      "opportunity": "Opportunity"
    },
    "waiting_days": "{days, plural, =0 {today} one {# day} other {# days}}",
    "no_deadline": "No deadline",
    "no_followup": "No follow-up",
    "reason": "Why it's pending",
    "objections": "Objections"
  },
  "referrals": {
    "title": "Referrals",
    "subtitle": "{total} referrals · {converted} converted",
    "new": "New referral",
    "saved": "Referral saved",
    "empty": "No referrals yet.",
    "referrer": "Referred by",
    "name": "Referred person",
    "by": "by {name}",
    "convert": "Create person",
    "converted": "Referral converted to a person",
    "thank": "Thank",
    "thanked": "thanked",
    "top": "Top referrers",
    "given": "Referrals given",
    "referred_by": "Referred by",
    "relationship": "Relationship to the referrer",
    "rel": {
      "family": "Family",
      "friend": "Friend",
      "colleague": "Colleague",
      "neighbour": "Neighbour",
      "business": "Business contact",
      "other": "Other"
    },
    "log_attempt": "Log contact",
    "attempt_saved": "Contact logged",
    "attempts": "{count, plural, one {# attempt} other {# attempts}}",
    "meeting_on": "meeting {date}",
    "next_on": "next {date}",
    "channel": "Channel",
    "outcome": "Outcome",
    "out": {
      "reached": "Talked",
      "no_answer": "No answer",
      "callback": "Call back later",
      "meeting": "Meeting booked",
      "not_interested": "Not interested"
    },
    "appointment": "Meeting",
    "next_step": "Next attempt",
    "next_step_hint": "Empty: in two days for no answer / call back",
    "funnel": "{given} given · {met} met · {won} won",
    "to_thank": "thank {count}",
    "to_thank_hint": "Introductions not thanked yet"
  },
  "service": {
    "title": "Service center",
    "subtitle": "Requests and claims after issue — status, next action and time open",
    "new": "New request",
    "request": "Request",
    "next": "Next action",
    "idle": "Open for",
    "open_only": "Open only",
    "placeholder": "e.g. beneficiary change",
    "tab": {
      "requests": "Requests",
      "claims": "Claims"
    },
    "type": {
      "beneficiary": "Beneficiary change",
      "payment": "Payment / premium question",
      "address": "Address change",
      "certificate": "Certificate request",
      "reinstatement": "Reinstatement",
      "cancellation": "Cancellation",
      "cover_change": "Cover change",
      "complaint": "Complaint"
    }
  },
  "claims": {
    "new": "New claim",
    "saved": "Claim saved",
    "empty": "No claims.",
    "type": "Claim type",
    "event_date": "Event date",
    "reference": "Claim reference",
    "claimed": "Claimed",
    "paid": "Paid",
    "note": "AVRASTRO helps you service the claim; the insurer decides it.",
    "kind": {
      "hospital": "Hospitalisation",
      "outpatient": "Outpatient",
      "accident": "Accident",
      "critical_illness": "Critical illness",
      "death": "Death",
      "disability": "Disability",
      "property": "Property",
      "motor": "Motor"
    }
  },
  "comms": {
    "title": "Communications",
    "log": "Log conversation",
    "logged": "Conversation logged",
    "empty": "No conversations logged yet.",
    "channel": "Channel",
    "direction": "Direction",
    "subject": "Subject",
    "summary": "Summary",
    "followup": "Follow-up"
  },
  "meetings": {
    "title": "Meetings",
    "new": "New meeting",
    "edit": "Edit meeting",
    "saved": "Meeting saved",
    "empty": "No meetings recorded.",
    "untitled": "Meeting",
    "purpose": "Purpose",
    "attendees": "Attendees",
    "agenda": "Agenda",
    "held": "Held",
    "record_outcome": "Record outcome",
    "assistant": "Post-meeting assistant",
    "notes": "Meeting notes",
    "notes_hint": "Write freely, in Greek or English — one point per line works best",
    "analyse": "Find promises & next steps",
    "analyse_hint": "AVRASTRO will read your notes and propose who promised what and by when. You review everything before it is saved.",
    "commitments": "Commitments",
    "no_commitments": "No commitments found — add them yourself if needed.",
    "add_commitment": "Add commitment",
    "keep": "Keep",
    "by": {
      "advisor": "I promised",
      "client": "Client promised"
    },
    "decisions": "Decisions",
    "objections": "Objections",
    "opportunities": "Opportunities",
    "review_note": "Dated commitments become follow-ups; client promises are tracked as “waiting for client”.",
    "save_outcome": "Save outcome",
    "completed": "Meeting recorded — follow-ups created",
    "promises": "Promises",
    "no_promises": "No open promises."
  },
  "business": {
    "title": "Business center",
    "subtitle": "Targets, production, activity and service — kept separate",
    "set_targets": "Set targets",
    "targets_saved": "Targets saved",
    "no_target": "No target set",
    "metric": {
      "annualPremium": "New annual premium",
      "policies": "New policies",
      "newClients": "New clients",
      "meetings": "Meetings",
      "calls": "Calls",
      "reviews": "Reviews",
      "referrals": "Referrals"
    },
    "of_target": "of {target} · {pct}%",
    "on_pace": "on pace",
    "behind": "behind pace",
    "pace": "Where you should be today",
    "production_by_month": "Production by month",
    "monthly_target": "Monthly target",
    "pipeline": "Pipeline",
    "open_value": "Open value",
    "conversion": "Conversion",
    "won_lost": "Won / lost",
    "prospects_called": "Prospects called",
    "service": "Service",
    "service_opened": "Requests opened",
    "service_closed": "Requests closed",
    "claims_closed": "Claims closed",
    "claims_paid": "Claims paid out",
    "def": {
      "production": "Production = annual premium of policies starting this year (offers excluded).",
      "activity": "Activity = completed calls and meetings, recorded reviews and referrals received this year.",
      "production_ledger": "Production comes from the ledger: new business, premium increases and decreases, renewals and reversals, each credited once."
    },
    "open_ledger": "Open production ledger",
    "other_currencies": "other currencies: {list}"
  },
  "quality": {
    "title": "Data quality",
    "subtitle": "{count, plural, =0 {No issues found} one {# issue found} other {# issues found}} — each with a reason and a suggested fix",
    "clean": "Your data looks clean.",
    "never_deletes": "Data quality never deletes anything. Merges keep a safety snapshot and can be undone.",
    "kind": {
      "duplicate_person": "Duplicates",
      "duplicate_prospect": "Duplicate prospects",
      "prospect_is_client": "Prospect is a client",
      "missing_contact": "No contact details",
      "invalid_email": "Invalid e-mail",
      "invalid_phone": "Invalid phone",
      "missing_birthdate": "No birth date",
      "broken_reference": "Broken links",
      "client_without_policy": "Client without policy",
      "needs_outdated": "Old needs analysis",
      "shared_contact": "Shared contact details"
    },
    "issue": {
      "duplicate_person": "{a} and {b} look like the same person",
      "duplicate_prospect": "{name} appears in more than one list",
      "prospect_is_client": "Prospect {name} is already your client {client}",
      "missing_contact": "{name} has no phone or e-mail",
      "invalid_email": "{name}: “{value}” is not a valid e-mail",
      "invalid_phone": "{name}: “{value}” is not a valid phone number",
      "missing_birthdate": "{name} has no birth date",
      "broken_reference": "{table}.{field}: {problem}",
      "client_without_policy": "{name} is a client with no active policy",
      "needs_outdated": "{name}'s needs analysis is {days} days old",
      "shared_contact": "{a} and {b} share the same {basis, select, phone {phone number} email {e-mail address} other {contact detail}}"
    },
    "why": {
      "duplicate_person": "Same phone number or same name and birth date.",
      "duplicate_prospect": "The same number was imported twice.",
      "prospect_is_client": "Avoid cold-calling your own clients.",
      "missing_contact": "You cannot reach this person.",
      "invalid_email": "Messages would bounce.",
      "invalid_phone": "Calls and WhatsApp would fail.",
      "missing_birthdate": "Needed for reviews, birthdays and pricing.",
      "broken_reference": "A record points to something that no longer exists.",
      "client_without_policy": "Mark as former client or add the policy.",
      "needs_outdated": "Life changes — review the needs.",
      "shared_contact": "Often family members — check they are different people."
    },
    "fix": {
      "merge": "Merge…",
      "edit": "Edit",
      "open": "Open",
      "review": "Review",
      "compare": "Compare…"
    },
    "merge_title": "Merge duplicate people",
    "keep": "Keep",
    "merge_explain": "Everything linked to {drop} moves to {keep}; {drop} is archived, not deleted.",
    "merge_confirm": "Merge",
    "merged": "Records merged",
    "fills": "Empty fields filled from the duplicate: {list}",
    "merge_safety": "A safety snapshot is taken first; Undo also works.",
    "snapshot_label": "Before merging {name}",
    "table": {
      "household_members": "Household",
      "policies": "Policies",
      "cases": "Applications",
      "tasks": "Tasks",
      "notes": "Notes",
      "reviews": "Reviews",
      "timeline": "Timeline events",
      "documents": "Documents",
      "service_cases": "Service requests",
      "consents": "Consents",
      "legacy_records": "Imported records",
      "comparisons": "Comparisons",
      "needs_analyses": "Needs analyses",
      "quotations": "Quotations",
      "opportunities": "Opportunities",
      "referrals": "Referrals",
      "communications": "Communications",
      "meetings": "Meetings",
      "claims": "Claims",
      "persons": "People",
      "prospects": "Prospects",
      "production_events": "Production",
      "renewals": "Renewals",
      "commission_entries": "Commission",
      "tax_snapshots": "Tax calculations",
      "financial_items": "Income, loans & goals",
      "life_events": "Life events",
      "campaign_activities": "Campaign activity",
      "automation_runs": "Automation runs",
      "extraction_drafts": "Document reviews",
      "insured_items": "Insured items",
      "premium_arrears": "Overdue premiums",
      "nps_surveys": "Client feedback",
      "kyc_files": "KYC/AML files",
      "sale_files": "Sale files (IDD)",
      "call_logs": "Prospecting calls",
      "risk_profiles": "Risk profiles",
      "family_links": "Family map",
      "client_summaries": "Client summaries"
    },
    "field": {
      "primaryPhone": "phone",
      "primaryEmail": "e-mail",
      "birthDate": "birth date",
      "occupation": "occupation",
      "employer": "employer",
      "address": "address",
      "city": "city",
      "maritalStatus": "marital status",
      "gender": "gender",
      "householdId": "household",
      "source": "source",
      "notes": "notes",
      "displayName": "name",
      "firstName": "first name",
      "lastName": "surname",
      "phones": "phones",
      "emails": "e-mails",
      "stage": "stage",
      "clientSince": "client since",
      "referredByPersonId": "referred by",
      "referredByName": "referred by (name)"
    },
    "compare_title": "Compare records",
    "compare_hint": "Nothing changes until you choose. Merging keeps a safety snapshot; keeping them separate is remembered.",
    "shared_explain": "Family members often share a phone or e-mail. If these are different people, keep them separate.",
    "keep_separate": "Keep separate",
    "kept_separate": "Kept separate — this pair will not be flagged again",
    "merge_these": "Merge…",
    "linked": "Linked records",
    "linked_counts": "{policies, plural, one {# policy} other {# policies}} · {tasks, plural, one {# task} other {# tasks}} · {documents, plural, one {# document} other {# documents}}",
    "same_household": "same household",
    "conflicts": "Different values — the kept record wins:",
    "conflict_keeps": "keeps “{keep}” (other: “{drop}”, kept in history)",
    "moves_sensitive": "Also moves {consents, plural, one {# consent record} other {# consent records}} and {documents, plural, one {# document} other {# documents}}."
  },
  "compliance": {
    "title": "Compliance & GDPR",
    "subtitle": "Consents, access, rectification and erasure · {count} people without a recorded marketing consent",
    "pick": "Choose a person to see their consents and data rights.",
    "consents": "Consents",
    "record": "Record consent",
    "purpose": "Purpose",
    "granted": "Granted",
    "withdrawn": "Withdrawn",
    "not_recorded": "Not recorded",
    "history": "History",
    "channel_hint": "Choose a channel only if the client limited consent to it; where the consent came from goes under Source.",
    "rights": "Data subject rights",
    "export": "Export all data (JSON)",
    "exported": "Personal data exported",
    "rectify": "Correct details",
    "erase": "Erase personal data",
    "note": "Erasure anonymises the person and removes notes, conversations and documents; insurance records are retained for regulatory reasons.",
    "erase_title": "Erase personal data · {name}",
    "erase_explain": "The person is anonymised. Policies, applications, claims and consents are kept but no longer identify them.",
    "will_delete": "Will be deleted",
    "will_retain": "Will be retained (anonymised)",
    "erase_word": "ERASE",
    "type_to_confirm": "Type {word} to confirm",
    "erased": "Personal data erased",
    "snapshot_label": "Before erasing {name}",
    "snapshot_kept": "Safety snapshot kept: {label}",
    "lawful_basis": "Lawful basis",
    "source": "Source",
    "source_hint": "e.g. signed form, phone call, website",
    "scope": "Scope",
    "scope_hint": "e.g. newsletters about pensions, WhatsApp only",
    "basis": {
      "consent": "Consent",
      "contract": "Contract",
      "legal_obligation": "Legal obligation",
      "legitimate_interest": "Legitimate interest",
      "vital_interest": "Vital interest"
    },
    "any_channel": "Any channel"
  },
  "consent": {
    "purpose": {
      "marketing": "Marketing",
      "advice": "Advice & service",
      "health_data": "Health data processing",
      "third_party": "Sharing with insurers",
      "newsletter": "Newsletter",
      "client": "Client relationship",
      "data_processing": "Data processing",
      "documents": "Document storage",
      "whatsapp": "WhatsApp messages",
      "voice_recording": "Recording meetings for a summary"
    }
  },
  "templates": {
    "title": "Message templates",
    "subtitle": "One multilingual catalogue for every client message — placeholders fill in from your data",
    "template": "Template",
    "compose": "Message",
    "compose_template": "Message from a template",
    "subject": "Subject",
    "body": "Text",
    "preview": "Preview",
    "custom": "Customised",
    "default": "Default",
    "saved": "Template saved",
    "reset": "Restore default",
    "missing": "No value yet for: {list}",
    "key": {
      "appointment_confirm": "Appointment confirmation",
      "appointment_reminder": "Appointment reminder",
      "missed_call": "Missed call",
      "birthday": "Birthday",
      "nameday": "Name day",
      "review_invite": "Review invitation",
      "renewal": "Renewal",
      "quote_followup": "Quotation follow-up",
      "decision_followup": "Pending decision",
      "missing_documents": "Missing documents",
      "underwriting_update": "Underwriting update",
      "meeting_followup": "After the meeting",
      "referral_thanks": "Referral thank-you",
      "claim_update": "Claim update",
      "campaign": "Free message",
      "followup_general": "General follow-up",
      "premium_reminder": "Overdue premium reminder",
      "nps_invite": "Feedback question (NPS)",
      "google_review": "Google review request",
      "review_request": "Thank you + Google review"
    },
    "print_letter": "Print as letter"
  },
  "decision": {
    "reason": {
      "draft": "The comparison is still a draft",
      "decide_later": "The client said they will decide later"
    }
  },
  "ask": {
    "title": "Ask AVRASTRO",
    "subtitle": "Questions in plain Greek or English, answered on this device from your own records",
    "ask": "Ask",
    "placeholder": "e.g. Which clients have children under 10?",
    "privacy": "Answers are computed locally from the records you can see. Nothing is sent to an AI service.",
    "empty": "Ask about clients, renewals, production or campaigns — every answer lists the records behind it.",
    "lens": "Ask AVRASTRO: “{q}”",
    "voice": "Dictate",
    "voice_note": "Dictation uses your browser’s speech service; nothing is recorded or kept",
    "voice_failed": "Dictation is not available right now",
    "segment_answer": "{segment}: {count, plural, one {# person} other {# people}}{incomplete, plural, =0 {} one { · # with incomplete data} other { · # with incomplete data}}",
    "renewals": "{count, plural, =0 {No renewals} one {# renewal} other {# renewals}} due between {from} and {to}",
    "production": "Production {period}: {total} ({count, plural, one {# event} other {# events}})",
    "draft": "Here is a follow-up draft ready to review before you send it.",
    "campaign_draft": "A campaign can start from this audience: {count, plural, one {# person} other {# people}}. Consent and suppression are checked before anyone is contacted.",
    "start_my_day": "Your day is ready: priorities, calls and follow-ups in one queue.",
    "unknown": "I could not match that question yet. Try one of the examples, or name a client, a period or a segment.",
    "ambiguous": "More than one person matches: {names}. Please be more specific.",
    "which": "Did you mean: {names}?",
    "open_draft": "Open draft",
    "create_campaign": "Create campaign",
    "sources": "Based on {count, plural, =0 {no records} one {# record} other {# records}} you can see",
    "example": {
      "review": "Who is overdue for an annual review?",
      "education": "Parents with children under 10 and no education plan",
      "renewals": "Renewals in the next 30 days",
      "life_medical": "Clients with life cover but no medical plan",
      "draft": "Draft a follow-up for my last meeting",
      "campaign": "Start a campaign for mortgages without credit life",
      "summary": "Summary of Maria",
      "prep": "Prepare my meeting with Andreas",
      "opportunities": "What opportunities do I have?"
    },
    "client_summary": "{name}: {policies} active policies ({annual} a year), {cases} open applications, {tasks} open tasks. Review: {review}. Coverage gaps: {gaps}.",
    "meeting_prep": "Meeting prep for {name} is ready: talking points from the evidence, family, holdings and open items.",
    "opportunities": "{count} top opportunities, each with the reason and the next step.",
    "open_client": "Open client"
  },
  "audit": {
    "title": "Audit log",
    "note": "Every change is recorded with who, when and what. Medical and restricted documents are logged without their content.",
    "synced": "synced",
    "export": "Export CSV",
    "col": {
      "at": "When (UTC)",
      "actor": "Who",
      "action": "Action",
      "summary": "Summary",
      "entity": "Record",
      "changes": "Changes (previous → new)"
    }
  },
  "auto": {
    "title": "Automations",
    "subtitle": "WHEN something happens, THEN create a task — never a message, never a change to client data",
    "install": "Install suggested rules",
    "installed": "Suggested rules installed (switched off — review and enable)",
    "new": "New rule",
    "edit": "Edit rule",
    "empty": "No rules yet. Install the suggested ones or create your own.",
    "enabled": "Rule enabled",
    "disabled": "Rule disabled",
    "enabled_label": "Enabled",
    "history": "Recent runs",
    "last_run": "last run {date}",
    "make_runner": "Run automations on this device",
    "runner_here": "This device runs the daily automations.",
    "runner_other": "Another device runs the daily automations, so tasks are never created twice.",
    "runner_none": "No device is set to run automations daily — you can still run them by hand.",
    "nothing_enabled": "Nothing to do: no enabled rule has a match today.",
    "preview_title": "Test run (nothing is created)",
    "preview_note": "A test run shows exactly which tasks a real run would create.",
    "test": "Test",
    "run": "Run now",
    "ran": "{count, plural, =0 {No new tasks} one {# task created} other {# tasks created}}",
    "safety": "Automations only create tasks. Each match runs once (idempotent), a single run is capped at 200 tasks, and every rule change creates a new version.",
    "when": "WHEN {trigger}",
    "then": "THEN task “{kind}” due in {days, plural, =0 {0 days} one {# day} other {# days}}",
    "when_label": "When",
    "days": "Days",
    "due_in": "Due in (days)",
    "task_kind": "Task type",
    "task_title": "Task title",
    "would_create": "would create {count, plural, =0 {nothing} one {# task} other {# tasks}}{done, plural, =0 {} other { · # already done}}",
    "result": {
      "created": "task created"
    },
    "trigger": {
      "renewal_due": "a renewal is due in {days, plural, =0 {0 days} one {# day} other {# days}}",
      "birthday": "it is a client’s birthday",
      "quote_pending": "a quote has waited {days, plural, one {# day} other {# days}} for a decision",
      "review_overdue": "an annual review is overdue",
      "policy_lapsed": "a policy lapses",
      "life_event": "a life event is recorded",
      "claim_action_due": "a claim needs a follow-up"
    }
  },
  "automation": {
    "default": {
      "renewal": "Prepare renewals 30 days ahead",
      "birthday": "Birthday call",
      "quote": "Follow up quotes after 5 days"
    },
    "task": {
      "renewal": "Prepare renewal terms",
      "birthday": "Call for birthday wishes",
      "quote": "Follow up the pending quote"
    }
  },
  "campaigns": {
    "title": "Campaigns",
    "subtitle": "From a smart segment to a checked audience, a message and a follow-up plan — you stay in control of every contact",
    "new": "New campaign",
    "empty": "No campaigns yet. Start from the library or from a segment.",
    "campaign": "Campaign",
    "audience": "Audience",
    "contacted": "Contacted",
    "issued": "Issued",
    "production": "Production",
    "channel_label": "Channel",
    "created": "Campaign created",
    "prepare": "Check & freeze audience",
    "prepared": "Audience checked and frozen",
    "launch": "Launch (create tasks)",
    "relaunch": "Create missing tasks",
    "launched": "Campaign launched — tasks are in your queue",
    "complete": "Complete campaign",
    "completed": "Campaign completed",
    "audience_preview": "Audience preview",
    "audience_frozen": "Audience frozen on {date}",
    "eligible": "Eligible",
    "excluded_note": "Excluded: {list}",
    "preview_hint": "Only people with consent for this channel and a contact detail are included. Suppressed people are never contacted.",
    "draft": "Draft message",
    "activity_saved": "Activity recorded",
    "message": "Message",
    "kit": "Campaign kit: call script, talking points, sequence",
    "call_script": "Call script",
    "talking_points": "Talking points",
    "sequence": "Sequence",
    "step": "day {day}: {action}",
    "landing": "Landing page text",
    "social": "Social post",
    "use_theme": "Use",
    "from_segment": "Create campaign",
    "never_sends": "AVRASTRO never sends anything by itself: it prepares drafts and tasks, and you choose what to send.",
    "verify_claims": "Check every figure and claim against the insurer’s current material before use.",
    "attribution": "A policy counts for a campaign when it is issued within the attribution window after the first contact (first touch).",
    "conversion": "{pct} conversion",
    "no_conversion": "no conversion yet",
    "tab": {
      "campaigns": "Campaigns",
      "library": "Library",
      "segments": "Segments",
      "newsletter": "Newsletter",
      "suggestions": "Suggestions"
    },
    "status": {
      "draft": "Draft",
      "ready": "Ready",
      "active": "Active",
      "completed": "Completed",
      "archived": "Archived"
    },
    "kpi": {
      "audience": "Audience",
      "contacted": "Contacted",
      "responded": "Responded",
      "appointments": "Appointments",
      "quotes": "Quotes",
      "applications": "Applications",
      "issued": "Issued"
    },
    "channel": {
      "whatsapp": "WhatsApp",
      "email": "E-mail",
      "sms": "SMS",
      "phone": "Phone call"
    },
    "activity": {
      "contacted": "Contacted",
      "responded": "Responded",
      "appointment": "Appointment",
      "quote": "Quote",
      "application": "Application",
      "issued": "Issued",
      "opted_out": "Opted out"
    },
    "objective": "Objective",
    "obj": {
      "appointments": "Book appointments",
      "reviews": "Annual reviews",
      "new_business": "New business",
      "cross_sell": "Complete protection (cross-sell)",
      "reactivation": "Reactivation",
      "referrals": "Referrals",
      "retention": "Retention",
      "information": "Information only"
    },
    "obj_hint": {
      "appointments": "Success = appointments booked.",
      "reviews": "Success = reviews completed.",
      "new_business": "Success = applications and issued premium.",
      "cross_sell": "Success = new cover for existing clients.",
      "reactivation": "Success = lapsed clients active again.",
      "referrals": "Success = introductions received.",
      "retention": "Success = renewals kept.",
      "information": "No sales goal — keep clients informed."
    }
  },
  "campaign": {
    "step": {
      "message": "message",
      "call": "call",
      "followup": "follow-up"
    },
    "task": {
      "message": "Campaign: send the prepared message",
      "call": "Campaign: call",
      "followup": "Campaign: follow up"
    }
  },
  "audience": {
    "reason": {
      "archived": "Archived",
      "suppressed": "Do not contact",
      "consent_withdrawn": "Consent withdrawn",
      "no_consent": "No marketing consent",
      "channel_not_consented": "No consent for this channel",
      "no_contact_detail": "No phone or e-mail"
    }
  },
  "segments": {
    "incomplete": "{count, plural, one {# with incomplete data} other {# with incomplete data}}",
    "incomplete_hint": "These people might belong here, but a missing detail (such as a birth date) keeps them out. Completing the record includes them.",
    "incomplete_short": "Incomplete data",
    "refreshed": "updated {date}",
    "population": "{count, plural, one {# person checked} other {# people checked}}",
    "detail": {
      "age": "age",
      "amount": "amount",
      "balance": "balance",
      "birthDate": "birth date",
      "capacity": "remaining allowance",
      "children": "children",
      "childrenWithoutBirthDate": "children without birth date",
      "currency": "currency",
      "date": "date",
      "days": "days",
      "dueDate": "due",
      "income": "income",
      "needsEvaluated": "needs evaluated",
      "policies": "policies",
      "product": "product",
      "state": "state",
      "status": "status",
      "type": "type",
      "youngest": "youngest child",
      "annual": "Annual premium",
      "stage": "Stage",
      "item": "Item",
      "linkedPolicy": "Linked policy",
      "vehicles": "Vehicles",
      "family": "Family members",
      "employees": "Employees"
    }
  },
  "segment": {
    "parents_children_under_10": "Parents with children under 10",
    "parents_children_0_12": "Parents with children aged 0–12",
    "no_medical_recorded": "No medical cover recorded",
    "mortgage_no_credit_life": "Mortgage without credit life",
    "life_no_savings": "Life cover but no savings plan",
    "over_40_no_retirement": "Over 40 without a retirement plan",
    "reviews_overdue": "Annual reviews overdue",
    "birthdays_this_month": "Birthdays this month",
    "namedays_this_week": "Name days this week",
    "tax_opportunity": "Unused tax allowance for life premiums",
    "lapsed_policies": "Lapsed policies",
    "gi_renewals_30": "General insurance renewals in 30 days",
    "life_no_medical": "Life cover but no medical plan",
    "parents_no_education": "Parents without an education plan",
    "criteria": {
      "parents_children_under_10": "Clients in a household with at least one child younger than 10 (birth date required).",
      "parents_children_0_12": "Clients in a household with at least one child aged 0–12.",
      "no_medical_recorded": "Active clients with no active medical policy on record.",
      "mortgage_no_credit_life": "A mortgage is recorded, but no active credit-life policy.",
      "life_no_savings": "Active life policy, but no savings or investment plan.",
      "over_40_no_retirement": "Aged 40 or more with no active pension or retirement plan.",
      "reviews_overdue": "The annual review is overdue or has never happened.",
      "birthdays_this_month": "Birthday falls in the current month.",
      "namedays_this_week": "Name day falls in the next 7 days.",
      "tax_opportunity": "A saved tax calculation shows remaining allowance for life premiums (approved or provisional rules only).",
      "lapsed_policies": "At least one policy lapsed for non-payment.",
      "gi_renewals_30": "A general-insurance renewal falls in the next 30 days.",
      "life_no_medical": "Active life policy but no active medical policy.",
      "parents_no_education": "Has children, but no education policy or education goal.",
      "property_no_earthquake": "An active property in insured items with no linked active general policy. When a linked policy exists but its wording does not mention earthquake, the client is listed as incomplete (cover detail not recorded). Cover held elsewhere is not known.",
      "family_vehicle_no_life": "An active vehicle, a spouse or children in the household, and no active life or credit-life policy owned or insured.",
      "mortgage_no_protection": "An active property marked as mortgaged, and no active credit-life or life policy.",
      "business_no_liability": "An active business with employees and no linked active liability policy. Businesses without the number of employees are listed as incomplete.",
      "gap_life_cover": "Clients with no life cover recorded.",
      "gap_income_protection": "Clients aged 18–64 with no income protection recorded.",
      "gap_beneficiaries": "Clients with a life policy that names no beneficiary.",
      "gap_health": "Clients with no medical plan recorded.",
      "gap_retirement": "Clients under 65 with no retirement savings recorded."
    },
    "property_no_earthquake": "Property: earthquake cover not on record",
    "family_vehicle_no_life": "Family with a vehicle, no life cover on record",
    "mortgage_no_protection": "Mortgaged home, no loan or life protection on record",
    "business_no_liability": "Business with employees, no liability policy linked",
    "gap_life_cover": "Gap: life cover",
    "gap_income_protection": "Gap: income protection",
    "gap_beneficiaries": "Gap: beneficiaries",
    "gap_health": "Gap: health cover",
    "gap_retirement": "Gap: retirement"
  },
  "commission": {
    "title": "Commission",
    "generate": "Calculate from production",
    "generated": "{count, plural, =0 {No new commission lines} one {# commission line added} other {# commission lines added}}",
    "rules": "Rules",
    "rule": "Commission rule",
    "rule_new": "New rule",
    "rule_hint": "A rule sets the expected rate for an insurer, category and period. The rate is frozen on each line when it is calculated.",
    "kind_label": "Kind",
    "rate": "Rate (%)",
    "any": "any insurer",
    "from": "Valid from",
    "to": "Valid to",
    "source": "Source",
    "source_ph": "e.g. agency agreement 2026",
    "totals": "expected {expected} · paid {paid} · outstanding {outstanding}",
    "none": "no commission lines",
    "mark_paid": "Mark paid",
    "disclaimer": "Expected commission is an estimate from your own rules; the insurer statement is the source of truth.",
    "kind": {
      "new_business": "New business",
      "renewal": "Renewal",
      "trail": "Trail",
      "bonus": "Bonus",
      "campaign_bonus": "Campaign bonus",
      "adjustment": "Adjustment"
    },
    "status": {
      "expected": "Expected",
      "pending": "Pending",
      "paid": "Paid",
      "cancelled": "Cancelled"
    }
  },
  "custom": {
    "title": "Custom fields",
    "subtitle": "Add the details your practice needs, without changing the database",
    "new": "New field",
    "empty": "No custom fields yet.",
    "entity": "Applies to",
    "key": "Key",
    "key_hint": "lower-case letters, digits and _ (cannot change once used)",
    "type_label": "Type",
    "label_en": "Label (English)",
    "label_el": "Label (Greek)",
    "options": "Options",
    "options_hint": "comma-separated",
    "required": "required",
    "values": "{count, plural, =0 {not used} one {# value} other {# values}}",
    "note": "Values are kept with each record, included in backups and exports, and never deleted when a field is switched off.",
    "type": {
      "text": "Text",
      "number": "Number",
      "date": "Date",
      "choice": "Choice",
      "bool": "Yes / no"
    }
  },
  "day": {
    "greeting": {
      "morning": "Good morning{name, select, none {} other {, {name}}}",
      "afternoon": "Good afternoon{name, select, none {} other {, {name}}}",
      "evening": "Good evening{name, select, none {} other {, {name}}}"
    },
    "tab": {
      "morning": "Start my day",
      "queue": "Work queue",
      "evening": "Evening review"
    },
    "start": "Start my day",
    "morning_line": "{count, plural, one {# person needs you today.} other {# people need you today.}} Start with the first card — the rest will wait.",
    "all_clear": "Nothing urgent today. A good day for reviews and new conversations.",
    "tiles_note": "Each tile opens the list behind it. Counts come from the same rules as the attention list.",
    "focus_mode": "Focus mode",
    "record": "Record",
    "recorded": "Outcome recorded and next step scheduled",
    "next_action": "Next step after today’s contact",
    "completed": "Done today",
    "none_completed": "Nothing completed yet today.",
    "pending": "Still open",
    "nothing_pending": "Nothing left open for today. Well done.",
    "move_all": "Move all to next working day",
    "move_to": "Move to {date}",
    "moved": "{count, plural, one {# task moved} other {# tasks moved}} — original dates are kept",
    "moved_one": "Task moved",
    "first_due": "first due {date}",
    "moved_times": "{count, plural, one {moved once} other {moved # times}}",
    "tile": {
      "followups": "Follow-ups",
      "birthdays": "Birthdays",
      "namedays": "Name days",
      "child_birthdays": "Children’s birthdays this month",
      "renewals": "Renewals",
      "reviews": "Reviews",
      "quotes": "Quotes & decisions",
      "lapses": "Lapses & late payments",
      "cases": "Applications",
      "life_events": "Life events"
    }
  },
  "finances": {
    "title": "Income, loans & goals",
    "add": "Add",
    "empty": "No income, loans or goals recorded yet.",
    "kind_label": "Kind",
    "type_label": "Type",
    "label": "Label",
    "amount": "Amount",
    "instalment": "Instalment",
    "unknown_hint": "leave empty if unknown — unknown is never treated as zero",
    "frequency": "Frequency",
    "gross_net": "Gross or net",
    "gross": "gross",
    "net": "net",
    "unknown": "unknown",
    "balance": "Balance",
    "target": "Target amount",
    "by_date": "By",
    "rate": "Interest (%)",
    "term": "Term (months)",
    "lender": "Lender",
    "default_currency": "Default currency",
    "from_document": "from document",
    "year": "year",
    "kind": {
      "income": "Income",
      "expense": "Expense",
      "liability": "Loan",
      "goal": "Goal",
      "asset": "Asset"
    },
    "type": {
      "salary": "Salary",
      "self_employment": "Self-employment",
      "rental": "Rental income",
      "pension": "Pension",
      "other": "Other",
      "living": "Living costs",
      "rent": "Rent",
      "income_tax": "Income tax",
      "education": "Education",
      "mortgage": "Mortgage",
      "loan": "Loan",
      "credit_card": "Credit card",
      "retirement": "Retirement",
      "home": "Home",
      "emergency": "Emergency fund",
      "cash": "Cash",
      "savings": "Savings",
      "investments": "Investments",
      "property": "Property"
    },
    "freq": {
      "monthly": "monthly",
      "annual": "annual",
      "one_off": "one-off"
    }
  },
  "fneeds": {
    "title": "Family needs (life cover)",
    "income": "Annual income to replace",
    "replacement": "Replacement (%)",
    "years": "Years of support",
    "debts": "Debts to clear",
    "final": "Final expenses",
    "assets": "Liquid assets",
    "inflation": "Inflation (%)",
    "return": "Return (%)",
    "capital": "Capital needed",
    "existing": "Less existing life cover",
    "gap": "Gap",
    "c": {
      "income": "Income replacement",
      "debts": "Debts",
      "education": "Education",
      "final": "Final expenses",
      "emergency": "Emergency fund",
      "assets": "Less liquid assets"
    },
    "not_evaluated": "Not evaluated yet — missing: {fields}. Nothing is assumed.",
    "assumptions": "Illustration only. Real rate used: {real}% a year. Assumptions are editable and shown on every printout.",
    "field": {
      "annualIncome": "annual income",
      "years": "years of support",
      "debts": "debts"
    }
  },
  "lifeEvent": {
    "title": "Life events",
    "add": "Record",
    "new": "New life event",
    "type": "What happened?",
    "create_task": "Create a follow-up task",
    "saved": "Life event recorded",
    "empty": "No life events recorded.",
    "followup_created": "follow-up created",
    "task": {
      "marriage": "Review cover after the wedding",
      "new_child": "Review family protection for the new baby",
      "new_job": "Review income protection after the job change",
      "salary_increase": "Check cover and savings after the salary increase",
      "home_purchase": "Home insurance and mortgage protection",
      "mortgage": "Protect the new mortgage",
      "new_loan": "Check protection for the new loan",
      "business_start": "Business and key-person cover",
      "retirement_planning": "Retirement planning conversation",
      "divorce": "Review beneficiaries and cover",
      "new_property": "Insure the new property",
      "other": "Follow up on the life event"
    }
  },
  "lock": {
    "title": "AVRASTRO is locked",
    "subtitle": "Your data on this device is encrypted. Enter your passphrase to continue.",
    "unlock": "Unlock",
    "unlocking": "Unlocking…",
    "recovery_key": "Recovery key",
    "use_recovery": "Use recovery key",
    "use_passphrase": "Use passphrase"
  },
  "meeting_mode": {
    "title": "Meeting mode",
    "open": "Meeting mode",
    "purpose": "Client meeting (meeting mode)",
    "age": "{age} years",
    "add_goal": "Add goal",
    "not_evaluated": "Not evaluated yet — we will complete the missing details together.",
    "disclaimer": "This summary is for discussion. It is not an offer or advice until a recommendation is agreed and documented.",
    "notes_ph": "What did we agree? What happens next?",
    "summary_title": "Meeting summary — {name}",
    "print": "Print summary",
    "finish": "Finish meeting",
    "saved": "Meeting recorded",
    "autosaved": "Saved automatically",
    "step": {
      "family": "Family",
      "income": "Income",
      "loans": "Loans",
      "insurance": "Insurance",
      "goals": "Goals",
      "analysis": "Protection",
      "discussion": "Discussion",
      "summary": "Summary"
    }
  },
  "money": {
    "mixed_currencies": "several currencies — not added together"
  },
  "quickadd": {
    "title": "Quick add",
    "pick_person": "For whom?",
    "note": "Note",
    "client": "Client",
    "lead": "Lead",
    "policy": "Policy",
    "task": "Task",
    "appointment": "Appointment",
    "claim": "Claim",
    "upload": "Document",
    "card": "Business card"
  },
  "adjustment": {
    "type": {
      "increase": "Increase",
      "decrease": "Decrease",
      "reversal": "Reversal",
      "renewal": "Renewal",
      "correction": "Correction"
    },
    "source": {
      "renewal": "from renewal",
      "extraction": "from a document"
    },
    "mode": {
      "new_instalment": "New instalment ({freq})",
      "new_annual": "New annual premium",
      "delta_instalment": "Change per instalment",
      "delta_annual": "Change per year"
    }
  },
  "needTag": {
    "life_cover": "Life cover",
    "savings": "Savings",
    "education": "Education",
    "child_protection": "Child protection",
    "retirement": "Retirement",
    "medical": "Medical",
    "accident": "Accident",
    "income_protection": "Income protection",
    "critical_illness": "Critical illness",
    "mortgage_protection": "Mortgage protection",
    "property": "Property",
    "motor": "Motor",
    "travel": "Travel",
    "liability": "Liability",
    "business": "Business"
  },
  "production": {
    "title": "Production",
    "subtitle": "Every premium change credited exactly once — new business, increases, decreases, renewals and reversals",
    "total": "Total",
    "life": "Life",
    "general": "General",
    "events": "Events",
    "previous": "previous period to date",
    "vs_previous": "vs previous period",
    "no_comparison": "no comparison (previous period was zero)",
    "reconciled": "Reconciled",
    "reconciled_hint": "ledger matches current annual premiums",
    "by_type": "By type",
    "no_contexts": "no cross-sale or campaign credits",
    "type_filter": "Filter by type",
    "all_types": "All types",
    "all_branches": "All branches",
    "type_col": "Type",
    "amount": "Annual amount",
    "effective": "effective",
    "single": "single premium",
    "empty": "No production in this period.",
    "ledger_empty": "The ledger is empty. Build it from your existing policies — nothing is changed, only credits are added.",
    "backfill": "Build from existing policies",
    "backfilled": "{count, plural, =0 {Nothing to add — the ledger is complete} one {# entry added} other {# entries added}}",
    "definition": "Production = annualised premium credited on the day it is recorded. Increases credit only the difference; cancellations within the window reverse new business; single premiums are shown separately.",
    "type": {
      "new_business": "New business",
      "increase": "Increase",
      "decrease": "Decrease",
      "renewal": "Renewal",
      "replacement": "Replacement",
      "reactivation": "Reactivation",
      "cancellation": "Cancellation",
      "reversal": "Reversal"
    },
    "period": {
      "today": "Today",
      "week": "This week",
      "month": "This month",
      "quarter": "This quarter",
      "year": "This year"
    },
    "context": {
      "upsell": "upsell",
      "cross_sale": "cross-sale",
      "campaign": "campaign"
    }
  },
  "protection": {
    "title": "Household protection map",
    "legend": "Status comes only from a needs evaluation — never guessed",
    "area_label": "Area",
    "family": "Family",
    "required": "Required",
    "covered": "Covered",
    "gap": "Gap",
    "unknown": "not evaluated",
    "basis_label": "Based on",
    "cover_no_amount": "cover exists, amount unknown",
    "cover_recorded": "cover recorded",
    "presence": "present (no amount)",
    "evaluate": "Evaluate needs",
    "principle": "A joint benefit is counted once for the family. “Protected” needs a completed needs analysis; missing information shows as “not evaluated”.",
    "topics": "Worth discussing",
    "topics_hint": "Suggestions from the records — conversation starters, not recommendations.",
    "mortgage_alerts": "Mortgage protection",
    "mortgage_alert": "Mortgage {balance}, life cover assigned {cover} — possible gap {gap}",
    "mortgage_alert_hint": "Balance as of {date} · lender {lender}. Check the current balance before any recommendation.",
    "mortgage_line": "balance {balance} · cover {cover}",
    "no_alerts": "No mortgage protection gaps found.",
    "book_title": "Protection across your book",
    "book_subtitle": "Mortgage gaps and households that need an evaluation",
    "area": {
      "life": "Life",
      "income": "Income",
      "medical": "Medical",
      "critical_illness": "Critical illness",
      "accident": "Accident",
      "mortgage": "Mortgage",
      "loans": "Loans",
      "emergency_fund": "Emergency fund",
      "retirement": "Retirement",
      "education": "Education",
      "savings": "Savings",
      "property": "Property",
      "motor": "Motor",
      "business": "Business"
    },
    "status": {
      "protected": "Protected",
      "partial": "Partial",
      "not_evaluated": "Not evaluated",
      "gap": "Gap",
      "not_needed": "Not needed"
    },
    "basis": {
      "needs_analysis": "needs analysis",
      "liabilities": "recorded loans",
      "expenses": "recorded expenses",
      "none": "no evaluation yet"
    },
    "topic": {
      "child_education": "Children’s education",
      "mortgage_protection": "Mortgage protection",
      "family_income_replacement": "Family income replacement",
      "child_medical": "Children’s medical cover",
      "family_protection": "Family protection",
      "retirement": "Retirement planning",
      "medical": "Medical cover"
    },
    "topic_hint": {
      "child_education": "Children in the family, no education plan or goal recorded.",
      "mortgage_protection": "A mortgage is recorded without credit-life cover.",
      "family_income_replacement": "Life cover exists; check it still matches the family’s needs.",
      "child_medical": "A child in the family has no medical cover recorded — worth checking together whether one is wanted.",
      "family_protection": "Children in the family and no life cover recorded — a conversation about how the family would manage, not a recommendation.",
      "retirement": "Aged 35+ with no pension plan recorded.",
      "medical": "No medical plan recorded."
    }
  },
  "renewals": {
    "title": "Renewals",
    "subtitle": "General-insurance renewals by urgency — prepare terms, then record the decision",
    "include_life": "Include life anniversaries",
    "due": "Due",
    "last": "Last premium",
    "last_hint": "annual amount for the ending period",
    "new": "Renewal premium",
    "diff": "Change",
    "awaiting": "awaiting terms",
    "terms": "Terms",
    "change": "Change vs last premium: {diff} ({pct})",
    "decide": {
      "renewed": "Renewed",
      "lapsed": "Lapsed",
      "declined": "Client declined"
    },
    "no_auto": "Nothing is renewed automatically — a renewal counts only when you record it.",
    "note": "Recording “Renewed” updates the premium from the renewal date and credits renewal production once.",
    "empty": "No renewals in this window.",
    "bucket": {
      "all": "All",
      "expired": "Expired",
      "today": "Today",
      "d7": "7 days",
      "d15": "15 days",
      "d30": "30 days"
    },
    "decided": {
      "renewed": "Renewal recorded — premium updated and renewal production credited",
      "lapsed": "Recorded as not renewed",
      "declined": "Recorded: the client declined the renewal"
    },
    "mode": {
      "queue": "By urgency",
      "general": "General renewals"
    }
  },
  "retention": {
    "title": "Retention",
    "subtitle": "Lapses, late payments, silence and missed reviews — in one place",
    "days": "{days, plural, one {# day} other {# days}}",
    "verified": "confirmed by insurer",
    "advisor_note": "your note, not confirmed",
    "kind": {
      "lapsed": "Lapsed policies",
      "late_payment": "Late payments",
      "renewal_due": "Renewals due",
      "no_contact": "No contact for a long time",
      "review_overdue": "Reviews overdue"
    }
  },
  "security": {
    "title": "Security",
    "subtitle": "Encryption on this device, automatic lock and the audit log",
    "encryption": "Encryption at rest",
    "on": "Encryption is on",
    "on_detail": "AES-256-GCM with a key protected by your passphrase (PBKDF2, {iterations} iterations). Records, snapshots and files are encrypted.",
    "off_intro": "Your data is stored on this device without a passphrase. Anyone with access to this browser profile could read it.",
    "enable": "Turn on encryption",
    "enable_hint": "Choose a long passphrase you will remember. You will also get a recovery key — keep it somewhere safe.",
    "encrypting": "Encrypting…",
    "passphrase": "Passphrase",
    "passphrase_again": "Repeat passphrase",
    "new_passphrase": "New passphrase",
    "current_or_recovery": "Current passphrase or recovery key",
    "change": "Change passphrase",
    "changed": "Passphrase changed",
    "lock_now": "Lock now",
    "autolock": "Lock automatically after",
    "never": "Never",
    "minutes": "{count, plural, one {# minute} other {# minutes}}",
    "recovery_title": "Your recovery key",
    "recovery_intro": "If you forget your passphrase, this key is the only way back in. AVRASTRO cannot recover it for you. Print it or store it in a password manager.",
    "recovery_ack": "I have stored the recovery key safely",
    "recovery_done": "Done — lock and reopen",
    "fact": {
      "keys": "Keys never leave this device and are never sent to a server.",
      "recovery": "Losing both the passphrase and the recovery key means the data on this device cannot be opened.",
      "limits": "Encryption protects stored data. While AVRASTRO is unlocked, anyone using this computer can see it — lock it when you step away."
    },
    "memory_note": "This session runs in memory only (the browser storage is unavailable), so there is nothing to encrypt on disk.",
    "desktop_note": "The desktop app keeps data in a local database; full-database encryption for desktop is on the roadmap. Use your operating system’s disk encryption meanwhile.",
    "strength": {
      "0": "Too short — use at least 10 characters",
      "1": "Acceptable — longer is better",
      "2": "Good",
      "3": "Strong"
    }
  },
  "sync": {
    "title": "Sync",
    "subtitle": "Work offline on every device; changes merge safely when you are back online",
    "unavailable": "Sync is not available in this session.",
    "now": "Sync now",
    "running": "Syncing…",
    "status": "Status",
    "state": {
      "local": "This device only",
      "paired": "Connected",
      "offline": "Offline — changes are kept"
    },
    "last": "last sync {when}",
    "never": "never synced",
    "pending": "Waiting to upload",
    "pending_hint": "saved on this device, sent at the next sync",
    "conflicts": "Conflicts",
    "conflicts_hint": "the same field changed on two devices",
    "rejected": "Not accepted",
    "rejected_hint": "the server refused these changes — kept for review",
    "error": "Last attempt failed: {error}",
    "reauth": "Sign in again",
    "pairing": "Connection",
    "pair": "Connect to a sync server",
    "pair_intro": "Connect this device to your practice’s sync server to share work between devices and colleagues. Until then, everything stays on this device.",
    "pair_hint": "Your administrator gives you the server address, the workspace ID and your sign-in.",
    "paired": "Device connected — first sync started",
    "unpair": "Disconnect",
    "server": "Server",
    "https": "https:// is required (http:// only for this computer)",
    "workspace": "Workspace",
    "workspace_id": "Workspace ID",
    "account": "Account",
    "password": "Password",
    "password_note": "Your password is sent only to your sync server and is never stored on this device.",
    "device": "Device",
    "lease": "Offline access until",
    "encryption": "Encryption on this device",
    "encrypted": "on",
    "not_encrypted": "off — turn on",
    "security_note": "Data travels over HTTPS. The server enforces your role and workspace; deleted records are kept as tombstones so they cannot come back by mistake.",
    "inbox": "Conflict inbox",
    "no_conflicts": "No conflicts. Changes to different fields merge automatically.",
    "review": "Review",
    "conflict_hint": "nothing is overwritten until you decide",
    "field": "Field",
    "local": "This device",
    "cloud": "Other device",
    "critical": "critical",
    "keep": "Keep",
    "keep_edited": "Keep the edited record",
    "keep_delete": "Keep it deleted",
    "keep_cloud": "Keep the other device’s version",
    "accept_delete": "Accept the deletion",
    "apply": "Apply",
    "resolved": "Conflict resolved",
    "retry": "Retry",
    "requeued": "Queued for the next sync",
    "discard": "Discard",
    "discarded": "Change discarded",
    "device_data": "Data on this device",
    "records": "Records",
    "files": "Files",
    "storage": "Storage used",
    "clear_device": "Remove data from this device…",
    "clear_intro": "This removes the local copy only. Data on the sync server and on other devices is not touched.",
    "clear_pending": "{count, plural, one {# change has} other {# changes have}} not been uploaded yet and would be lost. Sync first.",
    "clear_word": "REMOVE",
    "clear_type": "Type {word} to confirm",
    "pack_export": "Export sync pack",
    "pack_exported": "{count, plural, one {# change exported} other {# changes exported}}",
    "pack_import": "Import sync pack",
    "pack_invalid": "This file is not an AVRASTRO sync pack.",
    "pack_note": "No server? Move changes between devices with a file (USB stick, shared folder). The same merge and conflict rules apply.",
    "pack_from": "From device",
    "pack_ops": "Changes",
    "pack_apply": "Apply directly",
    "pack_merge": "Merge",
    "pack_skip": "Already here",
    "pack_preview_note": "A safety snapshot is taken before anything is applied.",
    "pack_imported": "Applied {applied}, merged {merged}, conflicts {conflicts}",
    "pack_mark_delivered": "Mark as delivered",
    "pack_delivered": "Pack marked as delivered",
    "badge": {
      "locked": "Read-only — sign in to sync",
      "conflict": "{count, plural, one {# conflict to resolve} other {# conflicts to resolve}}",
      "running": "Syncing…",
      "offline": "Offline — changes are saved on this device",
      "pending": "{count, plural, one {# change waiting to upload} other {# changes waiting to upload}}",
      "ok": "Up to date",
      "update": "Update needed to keep syncing"
    },
    "readonly": {
      "lease_expired": "Offline access has expired. You can read everything, but sign in again to make changes.",
      "device_revoked": "This device was disconnected by an administrator. Your data is read-only here.",
      "licence_expired": "Your subscription has ended. You can read and export everything; renew to make changes again.",
      "licence_required": "This copy of AVRASTRO needs an account. Sign in to make changes — your data is untouched."
    },
    "role": {
      "admin": "Administrator",
      "advisor": "Advisor",
      "manager": "Manager (read-only)",
      "assistant": "Assistant"
    },
    "reason": {
      "deleted_locally": "Deleted here, edited on another device",
      "deleted_remotely": "Edited here, deleted on another device",
      "edited_both": "Edited on both devices",
      "critical_field": "A critical field (premium, status, consent…) changed on both devices"
    },
    "err": {
      "invalid_credentials": "E-mail or password is not correct.",
      "revoked": "This device has been disconnected by an administrator.",
      "expired": "The session expired. Please sign in again.",
      "no_token": "Not signed in.",
      "permission": "Your role does not allow this.",
      "not_found": "Workspace not found on this server.",
      "https_required": "The server address must start with https://.",
      "network": "The server could not be reached. Check the address and your connection.",
      "device": "This device could not be registered."
    }
  },
  "taxc": {
    "title": "Tax Center",
    "subtitle": "Versioned tax rules with sources; illustrations only — never tax advice",
    "year": "Tax year",
    "unavailable": "No usable rules for {year}",
    "source": "Source: {source} · checked {date}",
    "approved_by": "approved by {who}",
    "rulesets": "Rule versions",
    "rules_note": "Rules are never guessed: a year without approved or provisional rules shows no result. Earlier calculations keep the rule version they used.",
    "built_in": "built-in",
    "approve": "Approve",
    "approved": "Rules approved",
    "ruleset_new": "New rule version",
    "ruleset_hint": "Enter the rules exactly as published by the tax authority and name the source. Draft rules are never used for calculations.",
    "ruleset_id": "Rule set ID",
    "ruleset_saved": "Rule version saved",
    "source_label": "Official source",
    "source_ph": "e.g. Tax Department circular, URL",
    "verified": "Checked on",
    "status_label": "Status",
    "bands": "Income tax bands",
    "band_add": "Add band",
    "up_to": "up to (empty = no limit)",
    "params": "Parameters",
    "pick_person": "Choose a person to calculate.",
    "gross": "Gross annual income",
    "si": "Social insurance",
    "medical": "GHS / medical contributions",
    "provident": "Provident fund",
    "pension": "Pension fund",
    "children": "Children",
    "life_policies": "{count, plural, =0 {No life policies included} one {# life policy included} other {# life policies included}}",
    "opportunity": "Life-premium allowance",
    "o": {
      "gross": "Gross income",
      "limit": "Allowance limit",
      "eligible": "Already used",
      "remaining": "Remaining allowance"
    },
    "illustration": "Illustration: using the remaining allowance could reduce tax by about {saving} (marginal rate {rate}).",
    "disclaimer": "Illustration based on the rules shown; not tax advice. Confirm with the client’s accountant.",
    "save_snapshot": "Save calculation",
    "snapshot_saved": "Calculation saved with its rule version",
    "snapshots": "Saved calculations",
    "rules_changed": "newer rules give {amount}",
    "status": {
      "approved": "Approved",
      "provisional": "Provisional",
      "draft": "Draft",
      "retired": "Retired"
    },
    "reason": {
      "no_rules_for_year": "There are no tax rules for this year. Add them from an official source — the previous year is never used instead.",
      "not_approved": "Rules for this year are still in draft. Approve them to use them.",
      "no_engine": "Tax calculations are not yet available for this country.",
      "expired": "The rules for this year have been retired.",
      "income_unknown": "Enter the gross income — it is never assumed."
    },
    "savings_title": "Tax-saving opportunities in your book",
    "savings_sub": "Latest payslip or tax calculation per client with room left for deductible premiums.",
    "savings_empty": "None yet — analyse a client’s payslip to find one.",
    "savings_col_client": "Client",
    "savings_col_room": "Room / year",
    "savings_col_saving": "Tax saving",
    "savings_col_from": "From",
    "from_payslip": "payslip",
    "from_calculator": "calculation",
    "follow_up": "Follow-up",
    "follow_up_open": "follow-up open",
    "follow_up_made": "Follow-up created",
    "own_folder": "For your own taxes as an advisor (licence, indemnity insurance, social insurance, certificates):"
  },
  "vault": {
    "title": "Documents",
    "subtitle": "Every document with its person, category and versions — read locally, checked by you",
    "upload": "Upload document",
    "choose_file": "Choose file",
    "scan": "Take photo",
    "category": "Category",
    "all_categories": "All categories",
    "restricted": "Restricted (medical or sensitive)",
    "version_of": "New version of",
    "new_document": "— a new document —",
    "store": "Store",
    "stored": "Document stored",
    "upload_note": "Files up to 20 MB are stored on this device (and on your sync server if connected). Text is read locally; nothing is sent to an AI service.",
    "too_large": "The file is larger than {mb} MB.",
    "duplicate": "This exact file is already stored as “{title}”. Choose it under “New version of” if it is an update.",
    "file_missing": "The file is not available on this device.",
    "open": "Open",
    "download": "Download",
    "versions": "{count, plural, one {# version} other {# versions}}",
    "drafts": "{count, plural, one {# document waiting for review} other {# documents waiting for review}}",
    "nothing_found": "No documents match.",
    "footer": "Opening or downloading a document is recorded in the audit log.",
    "tab_note": "Stored files, versions and values read from them",
    "review": "Review extracted values",
    "review_intro": "Accept, correct or reject each value. Nothing is written to the record until you apply.",
    "field": "Field",
    "extracted": "Read from document",
    "existing": "In AVRASTRO now",
    "destination": "Goes to",
    "page": "page {page}",
    "confidence": "Confidence",
    "alternatives": "Other values found: {list}",
    "not_found": "not found",
    "correct": "Correct value",
    "accept": "Accept",
    "rejectf": "Reject",
    "add_manual": "Add a value by hand:",
    "add": "Add",
    "target_policy": "Policy",
    "apply": "Apply accepted values",
    "applied": "Values applied with a link to the document",
    "reject_all": "Reject all",
    "rejected": "Review closed — nothing was changed",
    "never_auto": "Values from documents are never applied automatically. A premium read from a document is recorded as a correction, never as a sale.",
    "stage": {
      "idle": "Store",
      "reading": "Reading…",
      "hashing": "Checking…",
      "storing": "Storing…",
      "extracting": "Reading text…",
      "done": "Done",
      "error": "Failed"
    },
    "show": {
      "all": "All",
      "files": "With file"
    },
    "doctype": {
      "payslip": "Payslip",
      "income_statement": "Income statement",
      "tax_certificate": "Tax certificate",
      "tax_assessment": "Tax assessment",
      "loan_statement": "Loan statement",
      "mortgage_statement": "Mortgage statement",
      "policy_schedule": "Policy schedule",
      "quotation": "Quotation",
      "bank_document": "Bank document",
      "pension_statement": "Pension statement",
      "other": "Other document"
    },
    "method": {
      "pdf_text": "PDF text layer",
      "text": "Text file",
      "manual": "Entered by hand",
      "ocr_unavailable": "No text could be read"
    },
    "error": {
      "pdf_encrypted": "The PDF is password-protected.",
      "no_text_layer": "The PDF is a scan without a text layer — enter the values by hand.",
      "ocr_not_configured": "Photos are stored but not read: no OCR service is connected. Enter the values by hand.",
      "read_failed": "The file could not be read."
    },
    "decision": {
      "pending": "to review",
      "accepted": "accepted",
      "rejected": "rejected"
    },
    "fkey": {
      "name": "Name",
      "employer": "Employer",
      "period": "Period",
      "gross_monthly": "Gross monthly pay",
      "net_monthly": "Net monthly pay",
      "gross_annual": "Gross annual income",
      "net_annual": "Net annual income",
      "tax_amount": "Tax",
      "loan_amount": "Loan amount",
      "loan_balance": "Outstanding balance",
      "loan_instalment": "Instalment",
      "loan_rate": "Interest rate",
      "loan_term_months": "Term (months)",
      "lender": "Lender",
      "policy_number": "Policy number",
      "insurer": "Insurer",
      "policy_premium": "Premium",
      "premium_frequency": "Payment frequency",
      "sum_assured": "Sum assured",
      "policy_expiry": "Expiry date"
    },
    "dest": {
      "identity_check": "identity check only",
      "persons_employer": "person · employer",
      "info": "information only",
      "financial_items_income": "income",
      "financial_items_expense": "expenses",
      "financial_items_liability": "loans",
      "policies": "policy"
    }
  },
  "onboard": {
    "welcome": "Welcome to AVRASTRO",
    "welcome_sub": "Your advisor workspace — private, on this device, ready in a minute.",
    "setup": "Set up my practice",
    "setup_sub": "Market, your profile, your logo and goals — about two minutes, every step optional.",
    "import_sub": "Bring in clients, policies and tasks from an earlier VÉRO CRM.",
    "demo_sub": "Look around with fictional clients first. You can clear them later.",
    "account": "Sign in or create an account",
    "account_sub": "Sync your devices, back up to the cloud and work as a team.",
    "account_sub_server": "For sync, cloud backup and teams — you will need your provider’s server address.",
    "private": "Everything stays on this device until you choose to connect an account.",
    "progress": "Setup progress",
    "step": {
      "market": "Market",
      "profile": "Profile",
      "brand": "Brand",
      "goals": "Goals",
      "done": "Ready"
    },
    "market_title": "Where do you work?",
    "market_sub": "The market sets currency, licensing fields, name days and checklists. Language is separate — you chose it on the first screen.",
    "market_note": "You can change the market at any time in Settings.",
    "currency": "Currency",
    "time_zone": "Time zone",
    "profile_title": "How clients see you",
    "profile_sub": "Used on proposals, reviews, letters and messages. Nothing is invented — empty fields simply stay off documents.",
    "profile_note": "More details (photo, signature, regulatory text) are in System → Branding.",
    "brand_title": "Your logo on every document",
    "brand_sub": "Documents are co-branded: your agency logo leads, AVRASTRO appears discreetly. PNG, JPG, WebP or SVG — resized and trimmed automatically.",
    "no_logo": "No logo yet",
    "goals_title": "Goals and reminders",
    "goals_sub": "Targets drive the pace bars in Business; reminders create tasks — AVRASTRO never sends anything on its own.",
    "goal_premium": "New annual premium target ({currency})",
    "goal_clients": "New clients this year",
    "goal_meetings": "Meetings this year",
    "reminders": "Prepare my daily reminders on this device (follow-ups, renewals, birthdays, reviews)",
    "reminders_note": "Installs the standard automations; you can review or switch each one off in System → Automations.",
    "done_title": "All set",
    "done_sub": "Start with Today: it tells you who needs attention and what to do next.",
    "logo_ready": "Logo ready for documents",
    "reminders_on": "Daily reminders on this device",
    "start_tour": "Show me around (1 minute)",
    "go_today": "Go to Today",
    "skip": "Skip",
    "signed_in_as": "Signed in as {name} · {workspace}. Your avrastro.com profile fills the setup — change anything you like."
  },
  "tour": {
    "title": "Guided tour",
    "show": "Show the guided tour",
    "step": "{n} of {total}",
    "skip": "Skip tour",
    "finish": "Finish",
    "today": {
      "title": "Today",
      "body": "Who needs you now: priorities, follow-ups, renewals and birthdays — with the reason and the next best action."
    },
    "people": {
      "title": "People",
      "body": "Every client, family and policy, with a complete 360° view, documents and reviews."
    },
    "growth": {
      "title": "Growth",
      "body": "Prospects, pipeline, referrals and campaigns — where new business comes from."
    },
    "cases": {
      "title": "Cases",
      "body": "Applications from proposal to issued policy, with document checklists and underwriting status."
    },
    "lens": {
      "title": "Lens",
      "body": "Press Ctrl/⌘ K anywhere to find anyone or do anything by typing."
    },
    "flow": {
      "title": "Flow",
      "body": "Work through your day one item at a time, without hunting through screens."
    },
    "system": {
      "title": "System",
      "body": "Data and backups, branding, account and settings. Your data stays yours — export it any time."
    }
  },
  "outlook": {
    "title": "Outlook calendar",
    "intro": "Connect your Outlook (Microsoft 365) calendar: CRM appointments appear in Outlook and on your phone, and anything you booked in Outlook closes the same times for online booking on the website.",
    "connect": "Connect Outlook",
    "check": "Check connection",
    "opened": "Finish signing in on the Microsoft page that opened, then press «Check connection».",
    "account": "Account",
    "last": "Last sync",
    "events": "{n} appointments in Outlook",
    "sync": "Sync now",
    "synced": "Synced: {n} appointments in Outlook.",
    "err": "Sync did not finish ({e}).",
    "reconnect": "Microsoft asks you to connect again (for example the password changed or access was withdrawn). Press «Connect Outlook».",
    "disconnect": "Disconnect",
    "disconnect_confirm": "Stop the connection with Outlook? Appointments already in Outlook stay there.",
    "note": "Outlook is a copy: changes are made in the CRM and reach Outlook within minutes. You sign in on Microsoft's own page; your password never passes through AVRASTRO.",
    "mail": {
      "title": "E-mails with clients on their timeline",
      "intro": "Optional: e-mails between your Outlook and a CRM client (matched by the client's e-mail address) appear on that client's timeline — subject, date, direction and a link to open it in Outlook. Other e-mails are never kept. Microsoft asks you to allow «Read your mail».",
      "connect": "Show client e-mails",
      "on": "On — last checked {when}. Checked every 10 minutes while connected.",
      "sync": "Check now",
      "synced": "Checked: {n} new e-mails with clients.",
      "off": "Stop",
      "off_confirm": "Stop reading Outlook e-mail? E-mails already on client timelines stay there; the calendar stays connected.",
      "note": "The e-mail text is not kept unless you tick «keep the e-mail text» on a client's timeline (for that client only). Two people with the same address are not matched.",
      "keep_text": "Keep the text of this client's Outlook e-mails (from now on)",
      "sent": "Sent · Outlook",
      "received": "Received · Outlook",
      "open": "Open in Outlook",
      "in_untitled": "E-mail from the client (no subject)",
      "out_untitled": "E-mail to the client (no subject)"
    }
  },
  "account": {
    "signin_email": "Sign-in e-mail",
    "change_email": "Change e-mail",
    "email_current": "Current e-mail",
    "email_new": "New e-mail",
    "email_send_code": "Send code",
    "email_code_sent": "We sent a 6-digit code to {email}. Type it here (valid for 15 minutes).",
    "email_code": "Code from the e-mail",
    "email_confirm": "Confirm",
    "email_changed": "You now sign in with {email}.",
    "email_change_note": "Your password, data, workspaces and devices stay the same. The old address gets a notice about the change.",
    "title": "Account & subscription",
    "subtitle_out": "Optional: an account adds multi-device sync, encrypted cloud backup and teams. AVRASTRO works fully without one.",
    "subtitle_in": "Your profile, subscription, security, devices and cloud backup.",
    "unavailable": "Accounts are not available in this build.",
    "tab": {
      "signin": "Sign in",
      "register": "Create account",
      "reset": "Forgot password"
    },
    "server": "Server",
    "server_hint": "The address of your AVRASTRO account service (https).",
    "change_server": "change",
    "session_ended": "You were signed out on this device. Your data is still here — sign in again to continue syncing.",
    "why_title": "What an account adds",
    "why": {
      "sync": "Sync between computer, tablet and phone — conflicts are shown to you, never silently overwritten.",
      "backup": "Cloud backups encrypted on your device with your own backup password.",
      "team": "Agencies: seats, roles, invitations and an activity log.",
      "devices": "See and sign out your devices; optional two-step sign-in.",
      "local": "Your client data stays in the encrypted store on each device. Without an account nothing leaves it."
    },
    "privacy_note": "Synced records are protected in transit and at rest on the server; cloud backups are end-to-end encrypted.",
    "email_label": "E-mail",
    "password": "Password",
    "password_repeat": "Repeat password",
    "current_password": "Current password",
    "new_password": "New password",
    "pw_rule": "At least 10 characters; a short sentence works well.",
    "pw_ok": "Strong enough",
    "pw_mismatch": "The passwords differ",
    "password_note": "Your password is never stored on this device — only a revocable session.",
    "sign_in": "Sign in",
    "sign_out": "Sign out",
    "working": "Please wait…",
    "mfa_code": "Authenticator code",
    "mfa_code_hint": "The 6-digit code from your authenticator app, or one of your recovery codes.",
    "choose_workspace": "Your e-mail belongs to several workspaces. Choose one:",
    "switch_sync": "This device syncs with {server}. Signing in will switch sync to your AVRASTRO account. Continue?",
    "signed_in": "Signed in · {workspace}",
    "signed_out": "Signed out. Everything on this device is still here.",
    "created": "Account created · {workspace}",
    "create": "Create account",
    "trial_note": "Free {days}-day trial. No payment details needed to start.",
    "code_needed": "An activation or invitation code is required on this service.",
    "invite_only": "New accounts on this service are by invitation only.",
    "reg": {
      "you": "You",
      "practice": "Your practice",
      "prefs": "Preferences"
    },
    "first_name": "First name",
    "last_name": "Last name",
    "mobile": "Mobile",
    "branch": "Branch",
    "office_phone": "Office phone",
    "code": "Activation or invitation code",
    "code_hint": "Optional. From your agency or from AVRASTRO.",
    "accept_terms": "I accept the Terms of Service *",
    "accept_privacy": "I have read the Privacy Notice and agree to the processing of my account data (GDPR) *",
    "accept_marketing": "Send me occasional product news (optional)",
    "reg_note": "Licensing fields follow the market you choose. Your client data is not sent anywhere by creating an account.",
    "send_reset": "Send reset code",
    "reset_sent": "If the address has an account, a reset code is on its way (valid for one hour). Enter it with your new password.",
    "reset_code": "Reset code",
    "set_password": "Set new password",
    "reset_done": "Password changed. All devices were signed out — sign in with the new password.",
    "email_verified": "verified",
    "email_unverified": "not verified",
    "verify_resend": "Send confirmation e-mail",
    "verify_sent": "Confirmation e-mail sent",
    "verified": "E-mail confirmed",
    "checked": "last checked {when}",
    "billing_success": "Thank you — your subscription is being activated.",
    "subscription": "Subscription",
    "plan": "Plan",
    "status": "Status",
    "cancels": "ends at period end",
    "trial_end": "Trial ends",
    "period_end": "Paid until",
    "limits": "Limits",
    "limits_value": "{seats} seat(s) · {devices} devices each",
    "licence": "Licence on this device",
    "valid_until": "until {date}",
    "unmanaged": "This workspace is not on a subscription (self-hosted sync). No limits apply.",
    "redeem": "Redeem code",
    "code_applied": "Code applied",
    "manage_billing": "Invoices & payment",
    "price_unset": "Price on request",
    "free": "Free",
    "current_plan": "Current plan",
    "choose_plan": "Choose",
    "billing_off": "Online payment is not configured on this service; contact your provider to change plan.",
    "renew": "Renew",
    "readonly_safe": "Nothing has been deleted — you can still read and export everything.",
    "profile": "Profile",
    "profile_note": "The profile also fills your document identity where it is still empty. Logos, photo and signature are in Branding.",
    "edit_branding": "Document branding",
    "security": "Security",
    "change_password": "Change password",
    "change_password_note": "Your other devices will be signed out.",
    "password_changed": "Password changed",
    "mfa": "Two-step sign-in",
    "mfa_on": "on",
    "mfa_off": "Two-step sign-in switched off",
    "mfa_enable": "Turn on two-step sign-in",
    "mfa_disable": "Turn off",
    "mfa_steps": "Add this key to an authenticator app (e.g. Google Authenticator, Microsoft Authenticator, 1Password), then enter the 6-digit code it shows.",
    "mfa_open_app": "Open in an authenticator app on this device",
    "mfa_confirm": "Confirm and turn on",
    "mfa_recovery": "Two-step sign-in is on. Keep these recovery codes somewhere safe — each works once if you lose your phone. They are shown only now.",
    "mfa_save_codes": "Save codes",
    "mfa_code_or_recovery": "Authenticator or recovery code",
    "device_lock": "Device lock & encryption",
    "security_note": "Passwords are hashed (scrypt) on the server; sessions can be revoked per device.",
    "devices": "Devices",
    "device_unnamed": "Device",
    "this_device": "this device",
    "signed_out_device": "signed out",
    "last_seen": "last seen {when}",
    "revoke": "Sign out",
    "revoke_confirm": "Sign out “{device}”? It keeps its data read-only until someone signs in there again.",
    "device_revoked": "Device signed out",
    "devices_note": "Lost a device? Sign it out here and change your password.",
    "cloud_backup": "Cloud backup (end-to-end encrypted)",
    "cloud_backup_desc": "A full backup is encrypted on this device with a backup password before it is uploaded. The server cannot read it.",
    "cloud_backup_note": "Without the backup password nobody — including AVRASTRO — can restore it. Keep it safe. The newest 30 backups are kept.",
    "backup_password": "Backup password",
    "backup_password_hint": "At least 10 characters; can differ from your sign-in password.",
    "backup_now": "Encrypt and back up now",
    "backup_done": "Encrypted backup uploaded",
    "backup_restore": "Restore…",
    "backup_restore_next": "Enter the backup password, then Analyse: you will see a preview before anything changes.",
    "backup_delete_confirm": "Delete this cloud backup? Your data on this device is not affected.",
    "backup_role": "Cloud backups are available to administrators and advisors.",
    "backup_plan": "Cloud backup is not included in your plan.",
    "backup_stale": "Your last cloud backup is more than a week old.",
    "backup_none": "No cloud backup yet.",
    "privacy": "Privacy (GDPR)",
    "privacy_desc": "Download what the service holds about your account, export your client book, or erase your account.",
    "export": "Download my account data",
    "export_clients": "Export client data",
    "delete": "Delete account",
    "delete_intro": "This erases your account on the service. If you are the last member of a workspace, its server copy (synced records and cloud backups) is erased too. The data on this device is not touched. Agencies: hand over the administrator role first.",
    "delete_type": "Type DELETE to confirm",
    "deleted": "Account deleted. Your data on this device remains.",
    "badge": {
      "trial": "Trial · {days} d",
      "active": "Subscribed",
      "grace": "Renew · {days} d",
      "expired": "Read-only",
      "invalid": "Licence check",
      "none": "Sign in"
    },
    "readonly": {
      "licence_expired": "Your subscription has ended — AVRASTRO is read-only on this device.",
      "licence_required": "Sign in to your AVRASTRO account to make changes."
    },
    "sub_status": {
      "trialing": "Trial",
      "active": "Active",
      "past_due": "Payment due",
      "canceled": "Cancelled",
      "expired": "Expired"
    },
    "licence_state": {
      "none": "Not required",
      "trialing": "Trial",
      "active": "Valid",
      "grace": "Grace period — renew soon",
      "expired": "Expired (read-only)",
      "invalid": "Could not be verified"
    },
    "interval": {
      "month": "month",
      "year": "year",
      "trial": "trial",
      "custom": "custom"
    },
    "feature": {
      "sync": "Sync",
      "cloud_backup": "Cloud backup",
      "campaigns": "Campaigns",
      "tax_center": "Tax center",
      "team": "Team",
      "branding_agency": "Agency branding",
      "sso": "Single sign-on",
      "audit_export": "Audit export",
      "api": "API",
      "website_inbox": "Website inbox",
      "client_portal": "Client portal",
      "ai_drafts": "AI drafts",
      "automations": "Automations",
      "analytics": "Analytics",
      "group_plans": "Group plans"
    },
    "err": {
      "email_same": "That is the e-mail you already use.",
      "code_expired": "The code has expired or was mistyped too often. Ask for a new code.",
      "generic": "Something went wrong ({code}). Please try again.",
      "network": "The account service cannot be reached. Check the connection — AVRASTRO keeps working offline.",
      "https_required": "Use a secure https:// address.",
      "no_server": "Enter the server address first.",
      "key_mismatch": "The server’s licence key does not match the one this app trusts. Not signed in, for your safety.",
      "invalid_credentials": "E-mail or password is not correct.",
      "mfa_required": "Enter the code from your authenticator app.",
      "mfa_invalid": "That code is not valid. Check the time on your phone and try again.",
      "rate_limited": "Too many attempts. Please wait a few minutes.",
      "email_taken": "This e-mail already has an account — sign in instead.",
      "email_invalid": "Check the e-mail address.",
      "name_required": "First and last name are required.",
      "password_too_short": "Use at least 10 characters.",
      "password_too_common": "This password is too common.",
      "password_contains_email": "Do not use your e-mail name in the password.",
      "consent_required": "Please accept the Terms and the Privacy Notice.",
      "code_invalid": "This code is not valid or has already been used.",
      "code_required": "An activation or invitation code is required.",
      "registration_closed": "New accounts are by invitation only.",
      "invitation_other_email": "This invitation was sent to a different e-mail address.",
      "seat_limit": "All seats of the plan are taken.",
      "device_limit": "The device limit of your plan is reached. Sign out an old device in Account → Devices (from another device) or ask your administrator.",
      "licence_expired": "The subscription has ended — renew to make changes.",
      "plan_feature": "Your plan does not include this.",
      "token_invalid": "The code is invalid or has expired. Ask for a new one.",
      "revoked": "Your session has ended. Sign in again.",
      "expired": "Your session has expired. Sign in again.",
      "no_token": "Please sign in.",
      "signed_out": "Please sign in.",
      "permission": "Your role does not allow this.",
      "not_found": "Not found — it may have been removed.",
      "plaintext_refused": "Only encrypted backups can be uploaded.",
      "too_large": "Too large for the service.",
      "billing_not_configured": "Online payment is not set up on this service.",
      "plan_not_on_sale": "This plan cannot be bought online yet.",
      "no_billing_customer": "There is no billing account yet.",
      "transfer_ownership": "Make another member administrator first.",
      "cancel_subscription_first": "Cancel the running subscription first (Invoices & payment).",
      "confirm_required": "Type DELETE to confirm.",
      "last_admin": "A workspace needs at least one administrator.",
      "already_member": "You are already a member of that workspace.",
      "mfa_already_enabled": "Two-step sign-in is already on.",
      "mfa_not_pending": "Start the setup again.",
      "mfa_not_enabled": "Two-step sign-in is off.",
      "licence_expiry": "Use a valid date for the licence expiry.",
      "server_error": "The service had a problem. Please try again later.",
      "website_session_ended": "Your avrastro.com session has ended. Continue with avrastro.com to sync again — your data on this device is safe.",
      "workspace_mismatch": "This device holds the data of another workspace ({workspace}). Its data is never uploaded into a different account. Use another browser profile or computer, or export and clear this device first (Data & safety).",
      "website_web_only": "Website sign-in from this screen works in the web app. In the desktop app use the code shown here.",
      "already_linked": "This workspace is already linked to a avrastro.com account.",
      "storage_limit": "The backup storage of your plan is full. Delete older cloud backups below or add storage from the Advisor Hub.",
      "push_endpoint": "This browser's notification service is not supported.",
      "push_key": "The browser sent an incomplete notification key. Try again.",
      "push_limit": "You have reached the limit of 10 devices with notifications. Turn one off first.",
      "push_not_configured": "Notifications are not available on this server.",
      "passkey_unknown": "This passkey is not registered for an AVRASTRO account (it may have been removed).",
      "passkey_challenge": "The passkey request expired. Please try again.",
      "passkey_expired": "The passkey request expired. Please try again.",
      "passkey_signature": "The passkey could not be verified.",
      "passkey_sign_count": "This passkey looks copied to another device and was refused. Sign in with the password and add it again.",
      "passkey_origin": "This passkey belongs to another website.",
      "passkey_rp_id": "This passkey belongs to another website.",
      "passkey_user_verification": "The device did not confirm it is you (Face ID, fingerprint or device PIN).",
      "passkey_exists": "This passkey is already added.",
      "passkey_limit": "You have reached the limit of 20 passkeys. Remove one first.",
      "passkeys_not_configured": "Passkeys are not available on this server."
    },
    "licence_offline": "verified on this device, works offline",
    "website": {
      "title": "One account with {site}",
      "sub_web": "Sign in once on {site} — the CRM opens with the same account. No second password.",
      "sub_desktop": "Continue on {site} in your browser and confirm the code shown here. No password is typed into this app.",
      "continue": "Continue with {site}",
      "code_intro": "Your browser opens {site}. Sign in there, then type this code when you are asked for it:",
      "open": "Open {site}",
      "waiting": "Waiting for confirmation… The code is valid for 10 minutes. Not opened? Go to",
      "manage_plan": "Plan & billing on {site}",
      "manage_plan_note": "Upgrades, add-ons, invoices and cancellation are managed in the Advisor Hub.",
      "link_title": "Use your {site} account too",
      "link_sub": "Attach this workspace to your advisor account on {site}: open the CRM from the Advisor Hub and manage your plan there. Done once; your password keeps working.",
      "link": "Link with {site}",
      "already_linked": "This workspace is already linked to a {site} account."
    },
    "store_note": "Everything included in your workspace’s subscription appears here automatically after you sign in.",
    "invite_code": "Invitation code",
    "read_legal": "Read:"
  },
  "team": {
    "subtitle": "Seats, roles, invitations and activity of your agency.",
    "sign_in_first": "Sign in to an account to manage a team.",
    "admin_only": "Only administrators and managers can see the team.",
    "seats": "Seats used",
    "seats_hint": "Active members of the plan",
    "invitations": "Open invitations",
    "invitations_hint": "Codes not used yet",
    "members": "Members",
    "member": "Member",
    "role": "Role",
    "active": "Active",
    "disabled": "Disabled",
    "disable": "Disable",
    "enable": "Enable",
    "disable_confirm": "Disable {name}? All their devices are signed out; shared records stay.",
    "roles_note": "Administrator: everything, including team and billing. Advisor: own book. Manager: read-only overview. Assistant: no sensitive documents.",
    "invite": "Invite a colleague",
    "invite_email": "E-mail",
    "invite_email_hint": "Optional: leave empty for a code you hand over yourself.",
    "valid_days": "Valid for (days)",
    "invite_create": "Create invitation",
    "code_once": "Invitation code (shown once):",
    "code_mailed": "Also sent to {email}.",
    "open_invitation": "Open invitation",
    "until": "until {date}",
    "revoke": "Revoke",
    "activity": "Activity",
    "no_activity": "No activity yet.",
    "action": {
      "sign_in": "signed in",
      "account_created": "created the account",
      "account_joined": "joined the team",
      "account_deleted": "deleted their account",
      "profile_updated": "updated their profile",
      "password_changed": "changed their password",
      "password_reset": "reset their password",
      "mfa_enabled": "turned on two-step sign-in",
      "mfa_disabled": "turned off two-step sign-in",
      "device_revoked": "signed out a device",
      "code_redeemed": "redeemed a code",
      "invitation_created": "created an invitation",
      "invitation_revoked": "revoked an invitation",
      "member_updated": "changed a member",
      "backup_uploaded": "made a cloud backup",
      "backup_downloaded": "downloaded a cloud backup",
      "backup_deleted": "deleted a cloud backup",
      "push_refused": "sync refused (subscription)",
      "push_denied": "change refused (permission)",
      "file_upload": "uploaded a document file",
      "file_download": "opened a document file",
      "file_denied": "was refused a document file"
    },
    "activity_export": "Export activity (CSV)",
    "activity_export_locked": "Exporting the activity log for compliance is part of the Team and Enterprise plans.",
    "activity_export_unavailable": "Exporting the activity log is not included in this workspace’s subscription."
  },
  "branding": {
    "title": "Branding",
    "subtitle": "Your logo, identity and signature on every proposal, review, letter and report — co-branded with AVRASTRO by default.",
    "open": "Logos, photo & signature",
    "incomplete": "Add your name, a phone or e-mail and your licence number so documents carry a complete identity.",
    "save": "Save branding",
    "saved": "Branding saved",
    "sec": {
      "identity": "Advisor",
      "licence": "Licensing",
      "contact": "Contact",
      "logos": "Agency & logos",
      "signature": "Signature",
      "documents": "On documents"
    },
    "advisor_name": "Advisor name",
    "job_title": "Title",
    "job_title_ph": "e.g. Senior Insurance Advisor",
    "photo": "Photo",
    "country": "Market",
    "licence_number": "Licence number",
    "licence_authority": "Licensing authority",
    "authority_hint": "Suggested for the market — please check with your regulator.",
    "licence_expiry": "Licence expiry",
    "licence_short": "Licence",
    "registration": "Business registration",
    "regulatory": "Regulatory statement",
    "regulatory_hint": "Shown in the footer of client documents, e.g. “Registered insurance intermediary, licence …”.",
    "field": {
      "licenceNumber": "Licence number",
      "licenceAuthority": "Licensing authority",
      "licenceExpiry": "Licence expiry"
    },
    "agency_name": "Agency / company",
    "agency_logo": "Agency logo",
    "advisor_logo": "Your own logo (optional)",
    "advisor_logo_hint": "Shown next to the agency logo when different.",
    "agency_admin_only": "Only an administrator can change the agency profile.",
    "logo_hint": "PNG, JPG, WebP or SVG up to 10 MB. Resized, trimmed and kept in proportion automatically — wide, square or tall logos all fit.",
    "upload": "Upload",
    "replace": "Replace",
    "remove": "Remove",
    "upload_logo": "Upload logo",
    "replace_logo": "Replace logo",
    "remove_logo": "Remove logo",
    "processing": "Preparing…",
    "empty": {
      "logo": "No logo",
      "photo": "No photo",
      "signature": "No signature"
    },
    "image_error": {
      "too_large": "The image is larger than 10 MB.",
      "unsupported": "Use PNG, JPG, WebP, SVG or GIF.",
      "unreadable": "The image could not be read.",
      "too_big_after": "The image is too detailed to store; try a simpler or smaller version."
    },
    "signature": "Signature image (not an electronic signature)",
    "signature_hint": "Upload a scan (white background becomes transparent) or draw it.",
    "draw": "Draw",
    "draw_title": "Draw your signature",
    "draw_hint": "Use a mouse, pen or finger.",
    "clear": "Clear",
    "use_signature": "Use signature",
    "sign_off": "Sign-off",
    "sign_off_hint": "Used at the end of messages and letters.",
    "mode": "Branding mode",
    "mode_opt": {
      "co": "Co-branded",
      "advisor": "My brand first",
      "vero": "AVRASTRO only"
    },
    "mode_hint": {
      "co": "Your logos lead; the AVRASTRO logo appears beside the document title and in the footer.",
      "advisor": "Only your logos in the header; “Prepared with AVRASTRO” stays small in the footer.",
      "vero": "The AVRASTRO logo in the header instead of yours (your name and details stay)."
    },
    "show_photo": "Show my photo",
    "show_signature": "Sign proposals and letters",
    "show_regulatory": "Show the regulatory statement",
    "accent": "Accent colour",
    "preview": "Preview",
    "preview_note": "The real document template at A4 — exactly what prints and what PDFs contain.",
    "powered": "Prepared with AVRASTRO",
    "prepared_with": "Prepared with",
    "sample": {
      "proposal": "Proposal",
      "review": "Annual review",
      "letter": "Letter",
      "proposal_title": "Protection proposal",
      "review_title": "Annual review",
      "letter_title": "Letter",
      "client": "Ms Maria Example<br>Example Street 1, 1000 City",
      "letter_body": "Dear Ms Example,<br><br>thank you for our meeting. As agreed, I enclose the summary of your cover and the next steps.",
      "situation": "Family of four; one income; mortgage until 2041. Priority: income protection and life cover for the mortgage.",
      "next": "Next review in 12 months."
    },
    "signature_note": "An image of your handwritten signature, printed only on documents where you tick «With my signature». It is not an electronic or qualified electronic signature — for documents the client signs electronically use E-signature. Only you can see, insert, replace or delete it.",
    "signature_alt": "Signature image",
    "delete_signature": "Delete signature",
    "signature_replace_confirm": "Replace your signature image with the new one?",
    "signature_delete_confirm": "Delete your signature image? It is removed from your profile on every synced device and can no longer be inserted into documents.",
    "signature_saved": "Signature image saved",
    "signature_replaced": "Signature image replaced",
    "signature_deleted": "Signature image deleted"
  },
  "radar": {
    "title": "Opportunity radar",
    "subtitle": "{count} opportunities in your book — each with the reason and the next step.",
    "book": "book {amount}",
    "empty": "Nothing to suggest right now.",
    "more": "Show {count} more",
    "note": "Suggestions only: every action opens the normal form; nothing is sent or created on its own. People on the do-not-contact list are left out.",
    "kind": {
      "coverage_gap": "Coverage gaps",
      "life_event": "Life events",
      "renewal_window": "Renewal moments",
      "review_due": "Reviews due",
      "decision_open": "Open decisions",
      "lapsed": "Reactivation",
      "dormant": "Quiet clients",
      "referral_ask": "Ask for referrals",
      "family_uncovered": "Family uncovered",
      "tax_saving": "Tax savings",
      "premium_overdue": "Overdue premiums",
      "cross_sell": "Life ↔ general"
    },
    "why": {
      "coverage_gap": "Needs {areas} cover that is not in place.",
      "life_event": "{event} on {date} — protection usually needs a look.",
      "renewal_window": "{product} renews in {days} days — a natural moment to review everything.",
      "review_overdue": "Annual review overdue by {days} days.",
      "review_never": "Holds policies but was never reviewed.",
      "decision_open": "“{title}” is waiting for a decision for {days} days.",
      "lapsed": "{product} lapsed in the last year — worth a reactivation call.",
      "dormant": "No contact for {days} days.",
      "referral_ask": "A strong relationship (health {score}) and no introduction asked for in a year.",
      "referral_after_review": "Recently reviewed and satisfied — a good moment to ask for an introduction.",
      "family_uncovered": "{name} in the same household has no cover of their own.",
      "tax_saving": "Can still deduct about €{capacity} a year of premiums ({year}) — roughly €{saving} less tax.",
      "premium_overdue": "{product}: a premium is not collected yet ({days} days) — a call keeps the cover in force.",
      "premium_lapse_risk": "{product}: premium overdue for {days} days — risk of lapse.",
      "cs_property_no_earthquake": "{item}: no home policy linked in the CRM — a question about earthquake cover may be useful.",
      "cs_family_vehicle_no_life": "Family with a vehicle ({item}) and no life cover on record — perhaps a conversation about the family’s protection.",
      "cs_mortgage_no_protection": "{item} has a loan and no loan or life protection is on record — a short check may help.",
      "cs_business_no_liability": "{item} has employees and no liability policy is linked — a question about employer’s liability may be useful."
    },
    "action": {
      "call": "Call",
      "followup": "Follow up",
      "appointment": "Book a meeting",
      "proposal": "Needs & proposal",
      "campaign": "Campaign",
      "message": "Message draft"
    }
  },
  "growth_a": {
    "title": "Growth analytics",
    "subtitle": "{from} – {to}: where new business comes from and how it converts.",
    "period": {
      "month": "This month",
      "quarter": "Quarter",
      "year": "This year",
      "last12": "Last 12 months"
    },
    "new_contacts": "New contacts",
    "new_clients": "New clients",
    "conversion": "Conversion",
    "conversion_hint": "new contacts who became clients",
    "issue_rate": "Issue rate",
    "issue_rate_hint": "issued ÷ (issued + declined/withdrawn)",
    "avg_case": "Average case size",
    "avg_case_hint": "premium of issued applications",
    "avg_policy": "Average new policy",
    "avg_policy_hint": "annual premium",
    "days_to_issue": "Days to issue",
    "pipeline": "Pipeline value",
    "pipeline_hint": "open opportunities, expected premium",
    "weighted": "Weighted pipeline",
    "weighted_hint": "by stage: 10 · 25 · 50 · 75 %",
    "commission": "Commission",
    "commission_paid": "paid {amount}",
    "sources": "Sources of new contacts",
    "source_tip": "{contacts} contacts · {clients} clients · conversion {conversion}",
    "sources_note": "Bar: annual premium of clients won from the source (contacts when none yet). Percentage: conversion.",
    "no_contacts": "No new contacts in this period.",
    "cases": "Applications",
    "started": "Started",
    "issued": "Issued",
    "declined": "Declined / withdrawn",
    "open_cases": "Open now",
    "open_opps": "Open opportunities",
    "new_policies": "New policies",
    "referrals": "Referrals",
    "ref_given": "Received",
    "ref_converted": "Became contacts",
    "ref_business": "Business from referrals",
    "definitions": "Derived from your records for the period; nothing is sampled or estimated. Business = active annual premium today.",
    "source": {
      "referral": "Referral",
      "website": "Website",
      "unknown": "Not recorded",
      "campaign": "Campaign",
      "social": "Social media",
      "event": "Event",
      "cold_call": "Cold calls",
      "walk_in": "Walk-in",
      "legacy": "Imported",
      "friends_family": "Friends & family",
      "professional_network": "Professional network",
      "portfolio_transfer": "Portfolio transfer",
      "met_in_person": "Met in person"
    }
  },
  "req": {
    "details": "Details",
    "status": "Status",
    "waiting_on": "Waiting on",
    "requested_at": "Requested",
    "received_at": "Received",
    "expires_at": "Valid until",
    "expires_hint": "e.g. an ID card or a medical report",
    "document": "Linked document",
    "label": "Description",
    "complete": "All required documents in",
    "status_opt": {
      "required": "Required",
      "requested": "Requested",
      "received": "Received",
      "waived": "Not needed",
      "expired": "Expired"
    },
    "waiting_opt": {
      "client": "Client",
      "insurer": "Insurer",
      "advisor": "Me"
    },
    "state": {
      "missing": "Missing",
      "requested": "Requested",
      "waiting_client": "Waiting for client",
      "waiting_insurer": "Waiting for insurer",
      "received": "Received",
      "waived": "Not needed",
      "expired": "Expired"
    },
    "sum": {
      "received": "{count} received",
      "missing": "{count} missing",
      "waiting_client": "{count} waiting for client",
      "waiting_insurer": "{count} waiting for insurer",
      "expired": "{count} expired"
    }
  },
  "checklist": {
    "title": "Document checklist",
    "manage": "Checklists",
    "new": "New checklist",
    "intro": "Checklists per insurer and/or product category. When an application starts, the most specific one is suggested: insurer + category › insurer › category.",
    "name": "Name",
    "insurer_hint": "Leave empty for any insurer",
    "category_hint": "Leave empty for any product",
    "any": "Any insurer and product",
    "items": "{count} items",
    "add_item": "Add item",
    "mandatory": "Required for completion",
    "mandatory_short": "Required",
    "optional": "optional",
    "active": "Active",
    "inactive": "inactive",
    "choose": "Add a checklist…",
    "apply": "Add",
    "applied": "Checklist added (only missing items)",
    "fits": "fits",
    "none_yet": "No insurer checklists yet.",
    "suggested": "Suggested: {name}",
    "auto_named": "Automatic: {name}",
    "auto_market": "Automatic (market default)",
    "market_default": "Market default"
  },
  "referral": {
    "task_title": "Contact a referral"
  },
  "web": {
    "refresh": "Refresh",
    "loading": "Loading…",
    "connect": "Connect your account",
    "see_plans": "See plans",
    "reason": {
      "signed_out": "Connect your avrastro.com account to receive what clients send you through the website.",
      "offline": "You are offline. This page needs the internet; everything already accepted is in your CRM and works offline.",
      "plan": "Your current plan does not include this. Upgrade from the Advisor Hub."
    },
    "err": {
      "plan_feature": "Your current plan does not include this.",
      "licence_expired": "Your subscription has ended — the workspace is read-only. Renew from the Advisor Hub.",
      "portal_not_allowed": "This client has not allowed (or no longer allows) publishing to their portal.",
      "title_required": "Please add a title.",
      "not_found": "It is no longer available.",
      "ai_not_configured": "AI drafting is not set up on this server.",
      "ai_allowance_used": "This month's AI drafts are used up. Add more from the Advisor Hub or wait for next month.",
      "ai_unavailable": "The AI service did not answer. Please try again.",
      "ai_empty": "The AI service returned nothing. Please try again.",
      "input_required": "Please write the notes to draft from.",
      "network": "No connection to the AVRASTRO service. Please try again.",
      "permission": "Your role cannot do this.",
      "website_unreachable": "avrastro.com did not answer. Try again shortly; nothing has changed.",
      "website_error": "avrastro.com could not finish this. Try again, or confirm the appointment from the Advisor Hub.",
      "website_not_linked": "Your avrastro.com account is not connected to this CRM.",
      "booking_state": "This appointment has already changed on avrastro.com (confirmed, declined or cancelled). Refresh the list.",
      "action": "Not a valid action."
    },
    "inbox": {
      "title": "Website inbox",
      "subtitle": "Shares, appointment requests and messages from avrastro.com. Nothing enters your CRM until you accept it.",
      "tab": {
        "open": "To review",
        "all": "All"
      },
      "empty": "Nothing to review. New shares, bookings and messages from avrastro.com appear here.",
      "empty_all": "No items yet.",
      "kind": {
        "share": "Shared reports",
        "booking": "Appointment request",
        "lead": "Message"
      },
      "status": {
        "accepted": "Accepted",
        "declined": "Declined",
        "archived": "Archived",
        "revoked": "Withdrawn by the client",
        "expired": "Share ended"
      },
      "mode": {
        "office": "at the office",
        "online": "online",
        "phone": "by phone",
        "cafe": "at a café",
        "client_place": "at the client’s place",
        "video": "video call"
      },
      "booking": {
        "requested": "requested",
        "confirmed": "confirmed",
        "declined": "declined",
        "cancelled": "cancelled",
        "cancelled_by_client": "cancelled by the client",
        "completed": "completed"
      },
      "received": "received {when}",
      "share_line": "{n, plural, one {# report} other {# reports}} shared until {until}",
      "portal_allowed": "client portal allowed",
      "show_results": "Show the shared results",
      "matches": "Matches {name} in your CRM.",
      "accept_link": "Accept into {name}",
      "accept_new": "Accept as new prospect",
      "accept_lead": "Accept as new lead",
      "other_person": "Another person…",
      "existing_person": "Link to an existing person",
      "link": "Link",
      "decline": "Decline",
      "decline_confirm": "Decline this item? The sender is not notified by AVRASTRO; nothing is added to your CRM.",
      "declined": "Declined.",
      "accepted": "{name} is now in your CRM.",
      "open_person": "Open in CRM",
      "booking_changed": "The client changed this appointment on avrastro.com.",
      "cancel_appointment": "Cancel it in the agenda",
      "cancelled_on_site": "Cancelled on avrastro.com",
      "appointment_cancelled": "Appointment cancelled in your agenda.",
      "withdrawal_revoked": "Withdrawn by the client on avrastro.com",
      "withdrawal_expired": "Share period ended on avrastro.com",
      "withdrawals": "{n, plural, one {# withdrawal was} other {# withdrawals were}} recorded in the consent history.",
      "note_share": "Shared through avrastro.com: {purpose}",
      "task_share": "Review what {name} shared",
      "task_booking": "Appointment requested on avrastro.com{topic}",
      "via_site": "via {site}",
      "note_lead": "Message from avrastro.com{topic}",
      "task_lead": "Reply to {name}",
      "scope": "avrastro.com share {ref}: {n} report(s); profile: {fields}; client portal: {portal}; until {until}",
      "privacy": "Shared content is kept on the AVRASTRO service only while the client allows it. Accepted items become CRM records under your control. Updated",
      "task_callback": "Call back {name}{topic}",
      "callback": "Call-back request",
      "best_time": {
        "morning": "morning",
        "midday": "midday",
        "afternoon": "afternoon"
      },
      "shared_policies": "Policies from the client's folder",
      "policy_renews": "Renews",
      "policy_sum": "Sum insured",
      "policy_premium": "Premium",
      "opinion_file": "Quote for a second opinion",
      "opinion_open": "Open the file (avrastro.com)",
      "opinion_closed": "the file is no longer available",
      "opinion_until": "available until {date}"
    },
    "portal": {
      "title": "Client portal",
      "subtitle": "What you publish to clients' private page on avrastro.com. Only for clients who allowed it; you decide what they see.",
      "empty": "No client has allowed portal publishing yet. A client allows it when sharing reports with you on avrastro.com.",
      "allowed_until": "Allowed until {date}",
      "publish": "Publish",
      "publish_to": "Publish to {name}",
      "withdraw": "Withdraw",
      "withdraw_confirm": "Withdraw this item? The client will no longer see it.",
      "withdrawn": "Withdrawn",
      "read": "Read {date}",
      "unread": "Not read yet",
      "published": "Published to the client's portal.",
      "kind": {
        "summary": "Insurance summary",
        "review": "Review summary",
        "document_request": "Documents needed",
        "appointment": "Appointment",
        "note": "Note"
      },
      "kind_label": "Type",
      "title_label": "Title",
      "body_label": "Message",
      "body_hint": "Written for the client. Internal notes are never published.",
      "sections": "Lines (label · value)",
      "prefill": "Fill from the client's policies",
      "prefill_title": "Your current insurance",
      "add_line": "Add a line",
      "line_label": "Label",
      "line_value": "Value",
      "year": "year",
      "renews": "renews {date}",
      "note": "Published to the client portal: {title}",
      "publish_note": "The client sees this on their private avrastro.com page and gets no other data from your CRM. You can withdraw it at any time.",
      "privacy": "Portal items are stored encrypted on the AVRASTRO service and shown only to the signed-in client, only while they allow you."
    },
    "drafts": {
      "title": "AI drafts",
      "subtitle": "Drafts of messages, summaries, meeting notes and review agendas — you review and edit everything before use.",
      "kind": {
        "message": "Message to a client",
        "summary": "Client summary",
        "meeting": "Meeting notes → actions",
        "review": "Annual review agenda"
      },
      "kind_label": "What to draft",
      "input": "Your notes",
      "input_hint": "Facts only. Avoid identity numbers and health details unless necessary.",
      "run": "Draft",
      "working": "Drafting…",
      "usage": "{used} of {allowance} drafts this month",
      "not_configured": "AI drafting is not set up on this server yet (the owner adds an API key).",
      "privacy": "Your notes are sent to the AI provider only to write this draft; AVRASTRO does not store them or the draft on the server.",
      "result": "Draft",
      "empty": "The draft appears here.",
      "review": "Check every fact, amount and promise before sending — AI can be wrong. Nothing is sent automatically.",
      "copy": "Copy",
      "copied": "Copied.",
      "save_note": "Save as note"
    },
    "booking": {
      "who_title": "Appointment confirmed on avrastro.com",
      "confirm_title": "Confirm appointment",
      "question": "Is this an existing client or someone new? Choose, so the appointment goes into your agenda and their card opens for you to prepare.",
      "confirm_question": "Is this an existing client or someone new? When you choose, the appointment is confirmed on avrastro.com, the client receives the full confirmation and the appointment goes into your agenda.",
      "found_email": "Found in your CRM: {name} (same e-mail).",
      "found_phone": "Found in your CRM: {name} (same phone).",
      "not_found": "Nobody in your CRM has this e-mail or phone.",
      "is_match": "Yes, this is {name}",
      "existing": "An existing client — choose from the list",
      "new_prospect": "Someone new — prospective client",
      "later": "Later",
      "note": "It stays in \"Website inbox\" until you choose.",
      "confirm_note": "The client receives an e-mail with the day, time, address, map, what to bring and your contact details.",
      "done": "The appointment is in your agenda.",
      "done_confirmed": "Confirmed; the client was told and the appointment is in your agenda.",
      "task_confirmed": "Appointment (avrastro.com){topic}",
      "confirm": "Confirm appointment",
      "decline": "Decline request",
      "decline_confirm": "Decline this request? The client will get an e-mail that the time is not available and can choose another.",
      "declined": "Declined; the client was told.",
      "confirmed_hint": "Confirmed on avrastro.com — link it to a client to put it in your agenda."
    }
  },
  "groups": {
    "title": "Group plans",
    "subtitle": "Employer schemes — group medical, life, pension and accident — with their member census.",
    "new": "New group plan",
    "empty": "No group plans yet. Add an employer scheme to keep its census, premium and renewal in one place.",
    "not_found": "This group plan no longer exists.",
    "scheme": "Scheme",
    "category": "Category",
    "members": "Members",
    "annual": "Annual premium",
    "renewal": "Renewal",
    "in_days": "in {days} d",
    "overdue": "overdue",
    "cat": {
      "life": "Group life",
      "medical": "Group medical",
      "pension": "Pension / provident fund",
      "accident": "Group accident",
      "mixed": "Mixed",
      "other": "Other"
    },
    "status": {
      "quote": "Quote",
      "active": "Active",
      "renewing": "Renewing",
      "ended": "Ended"
    },
    "filter": {
      "active": "Active",
      "pending": "Joining",
      "left": "Left",
      "all": "All"
    },
    "field": {
      "displayName": "Name",
      "firstName": "First name",
      "lastName": "Last name",
      "birthDate": "Date of birth",
      "email": "E-mail",
      "phone": "Phone",
      "employeeNo": "Employee no.",
      "class": "Class",
      "joinDate": "Joined",
      "leaveDate": "Left",
      "dependants": "Dependants"
    },
    "export": "Export census",
    "import": "Import census",
    "add_member": "Add member",
    "active": "Active members",
    "pending": "Joining",
    "dependants": "Dependants",
    "avg_age": "Average age",
    "split": "Employer pays {employer} ({share}%), members {members}.",
    "changes_soon": "Next 30 days: {joining} joining, {leaving} leaving.",
    "missing_birth": "{n, plural, one {# member has} other {# members have}} no date of birth — insurers usually need it.",
    "classes": "Classes",
    "class_line": "{n, plural, one {# member} other {# members}}",
    "no_members": "No members yet.",
    "contact": "Contact person",
    "renewal_task_create": "Create the renewal follow-up",
    "renewal_task": "Group renewal: {name}",
    "renewal_task_done": "Renewal follow-up created.",
    "not_clients": "Not yet individual clients ({n})",
    "not_clients_note": "Every member is a possible advice conversation (personal cover, family, savings). Nothing is sent to them.",
    "all_clients": "Every active member is already a client.",
    "make_prospect": "Add as prospect",
    "prospect_created": "{name} added as a prospect.",
    "left_on": "left {date}",
    "mark_left": "Mark as left",
    "left": "Recorded as left — the history is kept.",
    "employer": "Employer",
    "scheme_name": "Scheme name",
    "carrier": "Insurer",
    "policy_number": "Policy no.",
    "start": "Start date",
    "premium_model": "Premium",
    "per_member": "Per member per year",
    "total": "Total per year",
    "premium_per_member": "€ per member / year",
    "total_premium": "Total € / year",
    "employer_share": "Employer share",
    "vat": "Employer VAT / TIC no.",
    "add_class": "Add a class",
    "class_name": "Class (e.g. Management)",
    "benefits": "Benefits (e.g. Plan A, worldwide)",
    "individual": "Individual client record",
    "individual_hint": "Link the member to their own CRM record (optional).",
    "import_title": "Import census — {name}",
    "import_intro": "Use the file from the employer or the insurer (CSV or Excel), or paste the rows. You will see every row's outcome before anything is saved.",
    "import_file": "Choose a file",
    "import_paste": "…or paste rows here (with a header row)",
    "import_unreadable": "This file could not be read. Save it as CSV or .xlsx and try again.",
    "import_leavers": "Members missing from this file have left",
    "import_summary": "{add} new · {update} updated · {skip} skipped",
    "import_new_classes": "new classes: {names}",
    "import_leaving": "{n} leaving",
    "import_apply": "Import {add} new, update {update}",
    "import_done": "Census imported: {add} new, {update} updated.",
    "import_again": "Choose another file",
    "import_action": {
      "add": "New",
      "update": "Update",
      "skip": "Skipped"
    },
    "problem": {
      "name_missing": "no name",
      "birthDate_invalid": "unreadable date of birth",
      "joinDate_invalid": "unreadable join date",
      "leaveDate_invalid": "unreadable leave date",
      "dependants_invalid": "dependants is not a number",
      "duplicate_in_file": "duplicate row in the file"
    },
    "locked": "Group plans are part of Professional and Team. Your existing schemes stay readable and exportable."
  },
  "save": {
    "short_saved": "Saved",
    "short_volatile": "Not saved",
    "short_error": "Save failed",
    "short_offline": "Offline",
    "auto": "Every change is saved on this device as you work.",
    "saved_at": "Saved on this device {time}",
    "volatile": "Not saved: this browser did not allow local storage, so nothing will remain after closing. Use Chrome or Edge in a normal (not private) window.",
    "error": "The last change could not be saved on this device. Export a backup and check the storage space.",
    "offline": "No internet: everything on this device keeps working; online features wait for the connection.",
    "backup_never": "No backup file made on this device yet.",
    "backup_due": "Last backup file {days} days ago."
  },
  "protect": {
    "title": "Where your data is and how it is protected",
    "personal_edition": "Personal offline edition",
    "volatile": "Not saved — running in memory only. Close nothing until you export a backup, and open AVRASTRO in Chrome or Edge in a normal window.",
    "native": "Saved in the app's own database file on this computer, as you work.",
    "browser": "Saved in this browser's storage on this computer, as you work. Another browser or another computer does not see it — move it with a backup file.",
    "persisted": "The browser keeps it permanently (it is not cleared to free space).",
    "not_persisted": "The browser may clear it if the disk gets very full — keep backup files.",
    "encrypted": "Encrypted on this device with your passphrase (AES-256-GCM). AVRASTRO asks for it at every start.",
    "not_encrypted": "Not encrypted by AVRASTRO: anyone who can use this computer account can open it. Use the computer's disk encryption and a passphrase.",
    "turn_on": "Turn on encryption",
    "snapshots": "Automatic recovery copies: one every 12 hours when something changed, the newest 7 kept on this device.",
    "last_auto": "Latest: {time}.",
    "backup_never": "No backup file made on this device yet.",
    "backup_age": "Last backup file: {days} days ago.",
    "backup_why": "A backup file is your copy outside the browser — keep one weekly on a USB stick or a cloud folder.",
    "online": "Online.",
    "offline": "Offline.",
    "network_needed": "Without internet everything here works; only sign-in, sync, the website inbox, client portal and AI drafts need a connection."
  },
  "register": {
    "title": "Client list",
    "subtitle": "Every client with since when and where they came from. Print it, export it, or fill in what is missing.",
    "who": "Who",
    "who_clients": "Clients",
    "who_with_former": "Clients and former clients",
    "who_all": "Everyone, including prospects",
    "source_all": "All sources",
    "from": "Client since: from",
    "to": "to",
    "sort": "Order",
    "sort_name": "Name",
    "sort_since": "Client since",
    "sort_source": "Source",
    "group": "Group by source",
    "contact": "Phone and e-mail",
    "portfolio": "Policies and premium",
    "count": "{count, plural, one {# client} other {# clients}}",
    "by_source": "By source",
    "by_year": "New clients per year",
    "col_no": "No.",
    "col_name": "Client",
    "col_phone": "Phone",
    "col_email": "E-mail",
    "col_since": "Client since",
    "col_source": "Source",
    "col_referred": "Referred by",
    "col_policies": "Active policies",
    "col_premium": "Annual premium",
    "col_year": "Year",
    "col_clients": "Clients",
    "col_share": "Share",
    "col_stage": "Stage",
    "print": "Print",
    "csv": "Export CSV (Excel)",
    "fill": "Fill in source and date",
    "fill_done": "Done",
    "missing": "{source} without a recorded source · {since} without a recorded client-since date",
    "note_first_policy": "¹ date of the first policy — no client-since date recorded",
    "note_added": "² date the client was added to AVRASTRO — no client-since date recorded",
    "empty": "No clients match these filters.",
    "saved": "Saved",
    "filters": "Filters: {list}",
    "total": "Total",
    "exported": "Client list exported",
    "basis": "Date basis"
  },
  "payslip": {
    "title": "Payslip → tax",
    "open": "Payslip → tax",
    "intro": "Upload one or more payslips (PDF). They are read on this computer — nothing is sent anywhere. You check every amount before anything is saved.",
    "choose": "Choose payslip PDFs",
    "stored": "Payslips already in this client’s documents",
    "read": "Read payslips",
    "reading": "Reading…",
    "add_more": "Add payslips",
    "manual": "Enter by hand",
    "person_first": "Choose the client first.",
    "period": "Period",
    "employer": "Employer",
    "unknown_period": "period not found",
    "k": {
      "gross": "Gross pay",
      "basic": "Basic salary",
      "allowances": "Allowances & extras",
      "thirteenth": "13th salary",
      "si": "Social insurance",
      "ghs": "GHS (ΓεΣΥ)",
      "provident": "Provident fund",
      "pension": "Pension fund",
      "medical": "Medical fund",
      "union": "Union / professional body",
      "tax": "Income tax withheld",
      "otherDeductions": "Other deductions",
      "deductionsTotal": "Total deductions",
      "net": "Net pay"
    },
    "from_line": "From the line: “{line}”",
    "derived": "calculated from the earnings lines",
    "not_found": "not found",
    "alternatives": "Also found: {list}",
    "check_ok": "Adds up: gross − deductions = net.",
    "check_diff": "Does not add up by {amount}. Check the amounts.",
    "check_unknown": "Net pay not found — check the amounts.",
    "warn": {
      "no_text": "This PDF is a scan (a picture): it has no text to read. Type the amounts from the payslip.",
      "no_gross": "Gross pay was not found.",
      "no_si": "Social insurance was not found.",
      "no_period": "The pay period was not found.",
      "net_mismatch": "Gross − deductions does not equal net pay.",
      "unidentified_deductions": "Some deductions in the total were not recognised; they are counted as “other deductions”."
    },
    "error": {
      "not_pdf": "Not a PDF file.",
      "password": "The PDF is password-protected. Open it, save a copy without a password and try again.",
      "damaged": "The PDF could not be read."
    },
    "year_settings": "The year",
    "salaries": "Salaries per year",
    "salaries_hint": "Choose 13 if the client receives a 13th salary.",
    "tax_year": "Tax year",
    "children": "Children",
    "household_income": "Household income (optional)",
    "life_policies": "Life policies counted",
    "no_life": "No active life policy in AVRASTRO.",
    "result": "Result",
    "annual_gross": "Annual gross",
    "contributions": "Deductible contributions now",
    "cap": "Limit (1/5 of income)",
    "capacity": "Room for deductible premiums",
    "per_month": "≈ {amount} per month",
    "tax_estimate": "Estimated income tax {year}",
    "effective": "effective rate {rate}",
    "withheld": "Withheld on the payslips (per year)",
    "withheld_diff_over": "About {amount} more is withheld than the estimate — a refund may be due after the tax return.",
    "withheld_diff_under": "About {amount} less is withheld than the estimate — tax may be due after the tax return.",
    "withheld_ok": "What is withheld matches the estimate.",
    "saving": "Using the room fully (≈ {monthly}/month in eligible premiums) would save about {saving} tax a year at the {rate} marginal rate.",
    "no_capacity": "The deductible contributions already reach the limit — no further tax saving from premiums.",
    "unavailable": "No tax rules for {year}: {reason}",
    "save": "Save to the client",
    "saved": "Payslip analysis saved",
    "follow_up": "Create a follow-up for the tax-saving proposal",
    "follow_up_title": "Tax-saving proposal: up to {amount}/year deductible premiums",
    "print": "Print",
    "share": "Send to the client",
    "store_note": "The payslips are stored in the client’s documents as restricted (assistants do not see them).",
    "doc_title": "Payslip {period}",
    "print_title": "Payslip and tax analysis",
    "disclaimer": "Estimate for an advisory conversation, based on the payslips and the tax rules shown — not tax advice. The final tax is determined by the tax return.",
    "months_used": "{count, plural, one {# payslip} other {# payslips}}",
    "annual_basis": "typical month × {n}",
    "col_file": "Payslip",
    "payslips": "Payslips",
    "ask_client": "Ask the client for payslips",
    "change": {
      "salary_increase": "Salary up {pct}% since the last payslip ({from} → {to}). Saving records a “salary increase” life event and a cover review.",
      "new_job": "New employer since the last payslip. Saving records a “new job” life event and a cover review."
    }
  },
  "share": {
    "open": "Share with the client",
    "title": "Share with {name}",
    "what": "What to send",
    "message": "Message",
    "to": "To:",
    "preview": "Preview",
    "chars": "characters",
    "privacy": "Contains personal and financial details — check the recipient before you send.",
    "nothing": "nothing to send yet",
    "how": "AVRASTRO opens your own app with the message ready; you press send. Each share is noted on the client’s timeline.",
    "copied": "Copied — paste it in any app.",
    "ics": "Calendar file",
    "subject": "Information for {name}",
    "log_subject": "Shared via {channel}",
    "intro_default": "Hello {name}, as we discussed, here is the information about your insurance:",
    "item": {
      "summary": "Short summary",
      "policies": "Policies and premiums",
      "protection": "Protection overview",
      "tax": "Tax result (payslip)",
      "documents": "Documents I still need",
      "appointment": "Next appointment",
      "renewals": "Upcoming renewals",
      "request": "Ask for documents"
    },
    "s": {
      "summary": "Summary",
      "policies": "Your policies",
      "protection": "Your protection",
      "tax": "Tax estimate {year}",
      "documents": "Please send me",
      "appointment": "Our next appointment",
      "renewals": "Coming up for renewal",
      "request": "To prepare your file, please send me"
    },
    "ch": {
      "whatsapp": "WhatsApp",
      "viber": "Viber",
      "email": "E-mail",
      "sms": "SMS",
      "system": "Share…",
      "copy": "Copy text",
      "pdf": "PDF / print"
    },
    "summary_line": "{count, plural, =0 {No active policies} one {# active policy} other {# active policies}} · total {total} a year",
    "no": "no.",
    "year": "year",
    "renews": "renews",
    "tax_income": "Annual gross income: {amount}",
    "tax_estimate": "Estimated income tax: {amount}",
    "tax_capacity": "You can still use {amount} a year (≈ {monthly}/month) of tax-deductible premiums — about {saving} less tax a year.",
    "tax_full": "Your deductible contributions already reach the yearly limit.",
    "tax_note": "This is an estimate, not tax advice; the final tax comes from your tax return.",
    "req": {
      "payslips": "Your last 3 payslips (PDF or photo)",
      "tax_return": "Your latest tax return / assessment",
      "id": "A copy of your ID card or passport",
      "policy_schedules": "Schedules of any policies you already have",
      "medical": "Any recent medical report the insurer may ask for",
      "vehicle": "Vehicle registration and driving licence",
      "property": "Property title or valuation and the loan details",
      "loan": "Loan or mortgage agreement (amount, term, bank)",
      "bank": "IBAN for the premium direct debit"
    },
    "intro_request": "Hello {name}, to check how much tax you could save, could you send me the following? A photo or PDF here is fine."
  },
  "gate": {
    "title": "Sign in to AVRASTRO CRM",
    "sub": "The CRM for insurance advisors: clients, policies, renewals and tasks, the same on your computer, tablet and phone.",
    "fact": {
      "sync": "One account keeps all your devices in sync.",
      "backup": "Encrypted cloud backups, with a password only you know.",
      "team": "Agencies with roles, invitations and an activity log."
    },
    "legal": "Legal",
    "terms_page": "Terms of use",
    "privacy_page": "Privacy",
    "reset_title": "New password",
    "session_ended": "Your session has ended. Sign in again; your data is safe.",
    "unavailable": "The account service is not available right now. Reload the page in a moment.",
    "no_account": "No account yet?",
    "have_account": "Already have an account?",
    "show": "Show",
    "hide": "Hide",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "optional": "(optional)",
    "forgot": "Forgot your password?",
    "or": "or",
    "reg_closed_title": "New sign-ups open soon",
    "reg_closed_body": "For now, a new account can only be created with an invitation from an agency that already uses AVRASTRO CRM. If you have an invitation code, enter it below.",
    "reg_code_title": "You need a code",
    "reg_code_body": "New accounts are created with an activation code from AVRASTRO or an invitation from your agency.",
    "invite_code": "Invitation code",
    "code_label": "Activation or invitation code",
    "code_set": "Code: {code}",
    "change": "Change",
    "have_code": "I have an activation or invitation code",
    "accept": "I accept the {terms} and have read the {privacy}.",
    "terms_link": "Terms of Use",
    "privacy_link": "Privacy Policy",
    "reg_after": "We will e-mail you to confirm your address. You can add the rest of your practice details from Account whenever you like.",
    "reset_intro": "Enter the e-mail address of your account. We will send you a reset code that is valid for one hour.",
    "reset_from_link": "Choose your new password. All your devices will be signed out, and you sign in again with the new password.",
    "back_signin": "Back to sign in",
    "reset_done": "Your password has changed. Sign in with your new password.",
    "preparing": "Preparing your workspace…",
    "err": {
      "network": "Could not reach AVRASTRO. Check your internet connection and try again.",
      "registration_closed": "Sign-ups are closed for now. You need a valid invitation code.",
      "workspace_mismatch": "This browser holds data of another workspace ({workspace}), which is never uploaded to a different account. Sign in with that account or use another browser profile."
    }
  },
  "insured": {
    "new": "Add item",
    "empty": "No insured items yet. Add the client's vehicles, home or business to keep values, drivers and due dates in one place.",
    "note": "Values are as told by the client. The rebuild check is indicative only — it is not advice and not a valuation.",
    "filter": {
      "active": "Active",
      "all": "All (incl. sold / archived)"
    },
    "kind": {
      "vehicle": "Vehicle",
      "property": "Property",
      "business": "Business",
      "other": "Other"
    },
    "status": {
      "active": "Active",
      "sold": "Sold",
      "archived": "Archived"
    },
    "field": {
      "kind": "Type",
      "label": "Name",
      "regNo": "Registration no.",
      "make": "Make",
      "model": "Model",
      "make_model": "Make / model",
      "year": "Year",
      "value": "Value",
      "drivers": "Drivers",
      "ncdYears": "No-claims years",
      "motDue": "MOT due",
      "roadTaxDue": "Road tax due",
      "address": "Address",
      "areaSqm": "Area (m²)",
      "yearBuilt": "Year built",
      "rebuildValue": "Rebuild value",
      "contentsValue": "Contents value",
      "mortgaged": "Mortgaged",
      "activity": "Business activity",
      "employees": "Employees",
      "policies": "Linked policies"
    },
    "label_hint": "Optional — otherwise the registration, address or activity is used.",
    "ncd_hint": "Years without a claim (no-claims discount)",
    "drivers_hint": "Names, separated by commas",
    "task_note": "A follow-up is created 14 days before the MOT and the road-tax date.",
    "mark_sold": "Mark as sold",
    "archive": "Archive",
    "reactivate": "Make active again",
    "done": {
      "sold": "Marked as sold — kept in the history",
      "archived": "Archived — kept in the history"
    },
    "due": {
      "mot": "MOT",
      "road_tax": "Road tax"
    },
    "due_line": "{what} for {label}: {date} (in {days} d)",
    "task": {
      "mot": "MOT due: {label}",
      "road_tax": "Road tax due: {label}"
    },
    "hint": {
      "missing": "Indicative: no rebuild value recorded for this property.",
      "missing_with_estimate": "Indicative: no rebuild value recorded. At {cost} per m² the area suggests about {estimate}.",
      "below": "Indicative: area × {cost} per m² ≈ {estimate}, higher than the recorded rebuild value ({rebuild}). Worth checking with the client and the insurer."
    }
  },
  "gi_renewals": {
    "intro": "General-insurance renewals as a pipeline. Follow-ups are created {days} days before expiry (Settings).",
    "create_tasks": "Create follow-ups ({count})",
    "tasks_done": "{count, plural, one {# renewal follow-up created} other {# renewal follow-ups created}}",
    "task_title": "Renewal in {days} days: {product}",
    "empty": "No general-insurance renewals in the coming weeks.",
    "note": "General insurance = policies with the general branch or a motor, home, travel, liability or business category. Nothing is renewed automatically.",
    "lost_note": "Recorded as not renewed; the policy and its history are kept.",
    "in_days": "in {days} d · {date}",
    "expired": "expired {date}",
    "stage_label": "Stage",
    "stage": {
      "new": "To start",
      "requested_quotes": "Quotes requested",
      "compared": "Compared",
      "sent_to_client": "Sent to client",
      "approved": "Approved",
      "renewed": "Renewed",
      "lost": "Lost"
    },
    "moved": {
      "requested_quotes": "Recorded: quotes requested",
      "compared": "Recorded: quotes compared",
      "sent_to_client": "Recorded: sent to the client",
      "approved": "Recorded: approved by the client",
      "renewed": "Renewal recorded — premium updated and renewal production credited",
      "lost": "Recorded as lost"
    }
  },
  "premiums": {
    "title": "Overdue premiums",
    "panel_title": "Overdue premiums (open)",
    "record": "Record overdue premium",
    "form_intro": "A premium the insurer could not collect (failed debit, unpaid instalment). A follow-up is created; nothing is sent to the client.",
    "amount": "Amount",
    "due_date": "Due date",
    "note_ph": "e.g. debit returned by the bank",
    "none": "No overdue premiums recorded for this policy.",
    "none_open": "No open overdue premiums.",
    "note": "An item open for more than {days} days shows “risk of lapse” on the policy (change it in Settings). Reminders open as drafts — nothing is sent by itself.",
    "risk_hint": "Shown when an overdue premium is open for more than {days} days",
    "lapse_risk": "Risk of lapse",
    "overdue_chip": "Premium overdue",
    "open_days": "{count, plural, one {open # day} other {open # days}}",
    "reminder": "Reminder draft",
    "mark_paid": "Paid",
    "mark_lapsed": "Lapsed",
    "recorded": "Overdue premium recorded — a follow-up was added",
    "paid_done": "Marked as paid — kept in the history",
    "lapsed_done": "Marked as lapsed — kept in the history",
    "task_title": "Overdue premium: {product} ({number})",
    "status": {
      "open": "Open",
      "paid": "Paid",
      "lapsed": "Lapsed"
    },
    "source": {
      "manual": "Entered by you",
      "import": "Insurer list"
    },
    "import": "Import insurer list",
    "import_title": "Import the insurer’s overdue list",
    "import_intro": "Choose the CSV or Excel file the insurer sent (or paste it). You choose which column is the policy number, the amount and the due date. Rows are matched only by an exact policy number; anything else is listed as unmatched, never guessed.",
    "import_file": "Choose file",
    "import_paste": "…or paste the rows here (with the header row)",
    "import_unreadable": "The file could not be read. Save it as CSV or .xlsx and try again.",
    "import_summary": "{matched} matched · {unmatched} unmatched · {duplicates} already recorded",
    "import_apply": "Record {count, plural, one {# item} other {# items}}",
    "import_done": "{count, plural, one {# overdue premium recorded} other {# overdue premiums recorded}}, each with a follow-up",
    "import_again": "Choose another file",
    "map_all": "Choose the three columns: policy number, amount and due date.",
    "field": {
      "policyNumber": "Policy number",
      "amount": "Amount",
      "dueDate": "Due date"
    },
    "duplicate": "Already recorded",
    "new_item": "New",
    "unmatched": "Unmatched rows",
    "unmatched_note": "Unmatched rows are not recorded. Check the policy number in the CRM (or add the policy) and import again.",
    "reason": {
      "no_number": "No policy number",
      "no_policy": "No policy with this number",
      "ambiguous": "Several policies have this number",
      "amount": "Amount not readable",
      "date": "Date not readable",
      "future": "Due date in the future"
    }
  },
  "schedule": {
    "title": "New policy from a schedule PDF",
    "intro": "Choose the insurer’s policy schedule. It is read on this device; check and correct every value — nothing is saved until you press Save. Identity numbers and bank details are never read.",
    "choose": "Choose PDF",
    "reading": "Reading…",
    "from_line": "From: “{line}” (p. {page})",
    "not_found": "Not found on the schedule — enter it if you know it",
    "alternatives": "also found: {list}",
    "premium_is": "The premium above is",
    "basis": {
      "instalment": "the instalment for the frequency",
      "annual": "the annual amount"
    },
    "keep_pdf": "Keep the PDF in the client’s documents, linked to the policy",
    "duplicate_warn": "A policy with this number already exists ({product}). Tick to save another one anyway.",
    "note": "Values read from a document are suggestions: the schedule and the insurer’s records prevail.",
    "save": "Save policy",
    "saved": "Policy saved from the schedule",
    "doc_title": "Policy schedule {number}",
    "vault_hint": "This looks like a policy schedule — create the policy from it and check the values first.",
    "k": {
      "insurer": "Insurer",
      "policyNumber": "Policy number",
      "insuredName": "Insured person",
      "product": "Product / class",
      "startDate": "Start date",
      "endDate": "End date",
      "renewalDate": "Renewal date",
      "premium": "Premium",
      "frequency": "Payment frequency",
      "sumInsured": "Sum insured"
    },
    "warn": {
      "no_text": "No text found (a scanned image). Enter the values by hand.",
      "no_number": "No policy number found — check the schedule.",
      "no_premium": "No premium found — enter it (it is needed to save).",
      "dates": "The end date is before the start date — check both.",
      "insurer_from_heading": "The insurer was taken from the page heading — please confirm it.",
      "holder_as_insured": "No “insured” label: the policyholder’s name is shown — change it if the insured person is someone else."
    }
  },
  "recon": {
    "title": "Commission statement reconciliation",
    "open": "Reconcile a statement",
    "intro": "Load the insurer’s commission statement (CSV or Excel, or paste it) and choose the columns. It is compared with the commission the CRM expects from your production; nothing changes until you accept a line.",
    "file": "Choose statement file",
    "paste": "…or paste the rows here (with the header row)",
    "unreadable": "The file could not be read. Save it as CSV or .xlsx and try again.",
    "map_all": "Choose the three columns: policy number, amount and period.",
    "again": "Another statement",
    "ref": "Statement reference",
    "ref_hint": "Stored with every accepted line, e.g. “Eurolife 09/2026”",
    "insurer": "Insurer (optional)",
    "insurer_hint": "Only this insurer’s policies are listed as missing",
    "field": {
      "policyNumber": "Policy number",
      "amount": "Commission amount",
      "period": "Period"
    },
    "status": {
      "matched": "Matched",
      "different": "Different amount",
      "missing": "Missing (expected, not paid)",
      "unexpected": "Unexpected (paid, not expected)"
    },
    "reason": {
      "no_policy": "no policy with this number",
      "ambiguous": "several policies have this number",
      "no_entry": "no expected commission for this period"
    },
    "problem": {
      "no_number": "No policy number",
      "amount": "Amount not readable",
      "period": "Period not readable"
    },
    "invalid": "Rows that could not be read",
    "col": {
      "expected": "Expected",
      "paid": "Paid",
      "difference": "Difference"
    },
    "summary": "Periods {periods}: expected {expected} · on the statement {paid} · difference {difference}",
    "accept": "Accept this line",
    "accept_n": "Accept {count, plural, one {# line} other {# lines}}",
    "accepted": "accepted",
    "accepted_done": "{count, plural, one {# statement line recorded} other {# statement lines recorded}}",
    "paid_date": "Paid on",
    "export": "Export CSV",
    "print": "Print",
    "note": "Accepting records the statement amount as paid on the expected line (the expected amount stays, so the difference remains visible); a line with no expected commission is recorded as a paid adjustment. Missing lines stay open."
  },
  "morning": {
    "title": "Morning e-mail «My day»",
    "intro": "Every working day the platform e-mails you the day at a glance: appointments, calls and follow-ups due or overdue, renewals in the next 30 days, birthdays and open premium arrears — with a link to the day's daily sheet.",
    "enabled": "Send me the morning e-mail on working days",
    "time": "Time",
    "time_hint": "Cyprus time (default 07:30)",
    "to": "Send to",
    "to_hint": "Empty = your account e-mail ({email})",
    "to_invalid": "That e-mail address does not look right — nothing changed.",
    "lang": "Language of the e-mail",
    "skip_holidays": "Not on Cyprus public holidays",
    "next": "Next e-mail: {date} at {time}",
    "no_next": "No working day in the next two weeks.",
    "off": "Off — nothing is sent.",
    "privacy": "The e-mail holds only counts, first names and times — no surnames, phone numbers, amounts, policies, health or financial details. The daily sheet opens in the app after you sign in. The platform writes it from the data your devices sync; a device that has not synced since yesterday shows yesterday's picture.",
    "need_account": "The morning e-mail is sent by the AVRASTRO platform: sign in to your account (System → Account) and keep sync on.",
    "test": "Send me a test now",
    "test_sent": "Test e-mail sent to {to}",
    "test_failed": "The test e-mail could not be sent ({code}). Make sure this device has synced the setting."
  },
  "nps": {
    "title": "Client feedback",
    "subtitle": "One question, 0–10. Prepared here, sent by you.",
    "ask": "Ask for feedback",
    "need_account": "The survey page is served by the AVRASTRO platform: sign in to your account first (System → Account).",
    "prepared": "Survey prepared — review the message and send it yourself",
    "prepared_chip": "Feedback asked",
    "answered_chip": "Feedback {score}/10",
    "resend": "Message",
    "withdraw": "Withdraw",
    "withdrawn": "Survey withdrawn — the link stops working",
    "empty": "No feedback asked yet. After a meeting or a closed claim, «Ask for feedback» prepares a short message with the link.",
    "status": {
      "prepared": "Asked — waiting for the answer",
      "answered": "Answered",
      "withdrawn": "Withdrawn"
    },
    "trigger": {
      "meeting": "after a meeting",
      "claim": "after a claim",
      "manual": "asked by you"
    },
    "category": {
      "promoter": "Promoter (9–10)",
      "passive": "Passive (7–8)",
      "detractor": "Detractor (0–6)"
    },
    "review": "Ask for a Google review",
    "review_again": "Google review (again)",
    "review_no_link": "Set your Google review link in Settings",
    "callback": "Call-back task",
    "callback_title": "Call back — feedback {score}/10",
    "chart_title": "Client feedback (NPS)",
    "score_12m": "NPS, last 12 months",
    "answers": "Answers",
    "response_rate": "{pct}% answered",
    "no_answers": "no answers",
    "chart_alt": "NPS per month: {list}",
    "chart_note": "NPS = % of 9–10 minus % of 0–6. Bars above the middle line are positive; months without answers show —.",
    "review_url": "Google review link",
    "review_url_hint": "From Google Business Profile → «Ask for reviews». Used as «Leave a review» in message templates (review.link) and in the draft after a 9 or 10.",
    "review_url_invalid": "The link must start with https:// — nothing changed."
  },
  "card": {
    "title": "New contact from a business card",
    "photo": "Take or choose a photo of the card",
    "photo_alt": "The business card",
    "reading": "Reading the card…",
    "read_device": "Read on this device — check every field.",
    "read_platform": "Read by the text-recognition service — check every field.",
    "read_failed": "The card could not be read. Paste or type its text below.",
    "no_ocr": "This browser cannot read text from photos. Paste or type the card's text below (on a phone: long-press the photo → «Copy text»).",
    "too_large": "The photo is larger than 5 MB — choose a smaller one.",
    "text": "Text of the card",
    "text_hint": "One item per line works best.",
    "read": "Fill in the fields",
    "review": "Check before saving",
    "empty": "Take a photo of the card or paste its text: the fields appear here for you to check.",
    "rest": "Not used: {lines}",
    "source_note": "Saved as a new lead, source «Met in person». The phone of the office, the website and the address go into the notes.",
    "privacy": "Nothing is saved until you press Save. The photo stays on this device; only when your platform has a text-recognition service turned on is it sent there to be read, and it is not kept.",
    "note_from": "From a business card ({date})",
    "field": {
      "firstName": "First name",
      "lastName": "Surname",
      "mobile": "Mobile",
      "phone": "Office phone",
      "email": "E-mail",
      "company": "Company",
      "jobTitle": "Job title",
      "website": "Website",
      "address": "Address"
    }
  },
  "kyc": {
    "title": "KYC / AML file",
    "subtitle": "Know-your-client checklist for life business",
    "saved": "KYC file saved",
    "task_title": "KYC/AML review: {name}",
    "status": {
      "complete": "Complete",
      "incomplete": "Incomplete",
      "none": "Not started"
    },
    "missing": "Missing: {list}",
    "miss": {
      "id_document": "identity document in the vault",
      "id_expired": "identity document expired",
      "beneficiaries": "beneficiaries",
      "pep": "PEP answer",
      "source_of_funds": "source of funds",
      "checked": "date of the check",
      "next_review": "next review date",
      "review_overdue": "review date passed"
    },
    "review_on": "Next review: {date} (in {days} days)",
    "review_overdue": "Review was due on {date} ({days} days ago)",
    "amlr_before": "The EU Anti-Money-Laundering Regulation (EU) 2024/1624 applies from {date} ({days} days). Until then the Cyprus AML law and the insurer's own forms apply.",
    "amlr_after": "The EU Anti-Money-Laundering Regulation (EU) 2024/1624 applies since {date}.",
    "id_document": "Identity document (in the vault)",
    "id_document_hint": "Upload the ID card or passport to the vault (category «Identity»), then choose it here. Its number stays on the document only.",
    "id_none": "— none on file —",
    "upload_id": "Upload to the vault",
    "id_expiry": "Document valid until",
    "risk": "Risk",
    "risk_level": {
      "low": "Low",
      "standard": "Standard",
      "high": "High"
    },
    "pep": "Politically exposed person (or close family / associate)?",
    "pep_hint": "A public function now or in the last 12 months, or a close family member or associate of such a person.",
    "pep_answer": {
      "no": "No",
      "yes": "Yes",
      "unknown": "Not asked yet"
    },
    "pep_note": "Which function / relationship",
    "funds": "Source of funds",
    "fund": {
      "salary": "Salary",
      "business": "Business income",
      "savings": "Savings",
      "inheritance": "Inheritance",
      "property_sale": "Sale of property",
      "investments": "Investments",
      "pension": "Pension",
      "gift": "Gift",
      "other": "Other"
    },
    "funds_note": "Details (optional)",
    "beneficiaries": "Beneficiaries",
    "ben_name": "Name",
    "ben_relationship": "Relationship",
    "ben_add": "Add beneficiary",
    "checked_at": "Checked on",
    "next_review": "Next review",
    "next_review_hint": "Empty = from the check date: high risk 1 year, standard 3 years, low 5 years.",
    "no_id_numbers": "A field looks like it holds an identity, passport, tax or bank number. Remove it — such numbers stay on the document in the vault.",
    "privacy": "Keep only what the checklist asks for. Identity numbers are never typed here; the document itself is in the encrypted vault, and access to restricted documents is logged."
  },
  "creport": {
    "title": "Claims and changes from clients",
    "subtitle": "Reported by your clients through the portal on the website",
    "empty": "No reports yet. Clients who allow the portal can report a claim or ask for a change from their page on the website.",
    "unavailable": "Reports could not be loaded (offline or the website is not linked).",
    "new": "New",
    "accept": "Accept into the CRM",
    "accepted": "Report accepted — claim / request created with a follow-up for today",
    "decline": "Decline",
    "declined": "Declined — the client sees that you will contact them",
    "declined_chip": "Declined",
    "matched": "Matched by e-mail or phone: {name}",
    "event_date": "Event date",
    "policy_ref": "Policy number given",
    "files": "{count, plural, one {# file} other {# files}}",
    "file_failed": "The file {name} could not be stored — open the report again later.",
    "docs_asked": "The client was shown",
    "task_title": "Client report: {title}",
    "insurer_note": "The official claim or change to the insurer is still made the way the insurer requires (its own form, portal or e-mail, with the original documents, within the policy's time limits). The client is told the same.",
    "kind": {
      "car_accident": "Car accident",
      "home_damage": "Home damage",
      "hospital": "Hospital stay",
      "death": "Death of a relative",
      "theft": "Theft",
      "change": "Change request"
    },
    "stage": {
      "sent": "Sent",
      "received": "Received",
      "documents_needed": "Documents needed",
      "in_progress": "In progress",
      "with_insurer": "With the insurer",
      "approved": "Approved",
      "paid": "Paid",
      "declined": "Declined by the insurer",
      "closed": "Closed"
    },
    "doc": {
      "accident_form": "Accident report form",
      "photos_damage": "Photos of the damage",
      "photos_scene": "Photos of the scene",
      "driving_licence": "Driving licence",
      "police_report": "Police report",
      "repair_estimate": "Repair estimate",
      "other_party": "Other party's details",
      "description": "Description",
      "invoices": "Invoices / receipts",
      "police_report_if_any": "Police report (if any)",
      "discharge_summary": "Discharge summary",
      "hospital_invoices": "Hospital bills",
      "medical_reports": "Medical reports",
      "claim_form_insurer": "Insurer's claim form",
      "death_certificate": "Death certificate",
      "policy_document": "Policy document",
      "beneficiary_id": "Beneficiary's ID",
      "medical_cause": "Medical certificate of cause",
      "bank_details_beneficiary": "Beneficiary's bank details",
      "list_of_items": "List of stolen items",
      "proof_of_ownership": "Proof of ownership",
      "request_details": "What should change",
      "supporting_document": "Supporting document"
    }
  },
  "passkey": {
    "title": "Passkeys (Face ID, Touch ID, fingerprint)",
    "intro": "Sign in with your face or fingerprint instead of the password. The biometric stays on your device; AVRASTRO only checks a signature. A passkey also counts as the second step.",
    "add": "Add a passkey on this device",
    "added": "Passkey added. Next time choose «Sign in with a passkey».",
    "removed": "Passkey removed.",
    "remove": "Remove",
    "remove_confirm": "Remove the passkey «{name}»? That device then signs in with the password again.",
    "unnamed": "Passkey",
    "created": "added {date}",
    "last_used": "last used {date}",
    "none": "No passkeys yet.",
    "unsupported": "Open AVRASTRO in the browser (app.avrastro.com) on your phone or computer to add one.",
    "sign_in": "Sign in with a passkey",
    "cancelled": "The passkey was not used (cancelled or not available on this device)."
  },
  "push": {
    "help": {
      "retry": "Still nothing: «Turn off» for the device, reload the page, «Turn on» again and «Send a test». The history shows whether the notice was sent.",
      "closed": "With the browser closed: Chrome / Edge show them while the browser runs in the background; on a phone they arrive with the app closed too.",
      "private": "Private windows or blocked site data: notifications do not work there.",
      "ios": "iPhone / iPad: only from the AVRASTRO icon on the Home Screen (Safari → Share → Add to Home Screen), iOS 16.4 or later.",
      "focus": "«Do Not Disturb» / «Focus» hides notifications — check it.",
      "os": "System: Mac → System Settings → Notifications → (your browser) → Allow. Windows → Settings → System → Notifications → (your browser) on.",
      "allow": "Browser: padlock next to the address → Notifications → Allow. Then reload the page.",
      "title": "No notifications? Step-by-step check"
    },
    "status": {
      "queued": "waiting (quiet hours)",
      "failed": "failed",
      "sent": "sent"
    },
    "history_empty": "No notifications sent yet.",
    "history": "Notification history",
    "time_zone": "Device time: {tz}",
    "quiet_hint": "Nothing is shown during quiet hours; anything from the website is shown as soon as they end.",
    "quiet_to": "to",
    "quiet_from": "from",
    "quiet": "Quiet hours",
    "failing": "{n} failed deliveries",
    "error": {
      "unsupported": "This browser does not support notifications. Use Chrome, Edge, Firefox or Safari.",
      "subscribe_timeout": "The browser’s notification service did not answer. Check the connection and try again in a moment.",
      "subscribe_failed": "The browser’s notification service (Google, Apple, Mozilla or Microsoft) did not accept the registration. Check the connection and that the browser may show notifications in the operating system, then try again.",
      "sw_timeout": "AVRASTRO’s background service did not start in time. Reload the page (once) and press «Turn on» again.",
      "sw_failed": "The browser did not let AVRASTRO install the background service (service worker) that notifications need. Private windows and blocked site data prevent it — open app.avrastro.com in a normal window.",
      "dismissed": "The permission prompt was closed without an answer. Press «Turn on» again and choose «Allow».",
      "denied": "The browser did not allow notifications for AVRASTRO. Allow them from the padlock next to the address (Site settings → Notifications → Allow) and try again."
    },
    "not_configured_here": "The AVRASTRO server you are signed in to does not send notifications (not set up). They work at app.avrastro.com.",
    "state": {
      "desktop": "Desktop app",
      "server": "Not available on this server",
      "blocked": "Not possible here",
      "off": "Not on for this device",
      "on": "On for this device"
    },
    "turning_on": "Turning on…",
    "on_no_test": "Notifications are on, but the test notice has not been delivered yet. Press «Send a test» in a moment.",
    "title": "Notifications on this device",
    "intro": "A notice on your phone or computer when a booking or a message arrives from the website, and before your appointments. Off until you turn it on here; each device has its own choices.",
    "on": "Turn on notifications on this device",
    "on_done": "Notifications are on. A test notice was sent to this device.",
    "off": "Turn off",
    "off_confirm": "Stop notifications on «{device}»?",
    "device": "Device",
    "denied": "The browser did not allow notifications. You can allow them in the browser's site settings and try again.",
    "test": "Send a test",
    "test_sent": "Test notice sent.",
    "test_failed": "The test notice could not be delivered. Turn notifications off and on again on that device.",
    "last_ok": "last delivered {when}",
    "minutes_before": "Remind me",
    "minutes": "{n} min before",
    "pref": {
      "renewals": "Policy renewals",
      "tasks": "Tasks / follow-ups due",
      "bookings": "Website bookings",
      "messages": "Website messages",
      "appointments": "Before appointments",
      "details": "Show details on the lock screen"
    },
    "support": {
      "insecure": "Notifications need a secure connection (https). Open AVRASTRO at https://app.avrastro.com.",
      "desktop_app": "The desktop app does not receive web notifications (Web Push). It shows its own system notifications while it is open — turn them on in Settings. For notices while it is closed, turn notifications on at app.avrastro.com in a browser or on your phone.",
      "unsupported": "This app or browser cannot receive notifications. Use AVRASTRO in Chrome, Edge, Firefox or Safari at app.avrastro.com.",
      "ios_home_screen": "On iPhone and iPad: open app.avrastro.com in Safari, Share → «Add to Home Screen», open AVRASTRO from the Home Screen, then turn notifications on here.",
      "denied": "Notifications are blocked for AVRASTRO in this browser. Allow them in the site settings, then reload."
    },
    "note": "By default the lock screen shows only «New booking request» or «Appointment in 30 minutes» — no client names. The notice travels encrypted through your browser's push service (Apple, Google, Mozilla or Microsoft)."
  },
  "esign": {
    "send": "Send for signature",
    "send_title": "Send for signature — {name}",
    "kind_label": "Document",
    "kind": {
      "needs": "Needs statement",
      "consent": "GDPR consent",
      "proposal": "Proposal summary",
      "other": "Other document"
    },
    "lang": "Language of the document",
    "title_label": "Title",
    "extra_text": "Additional text (optional)",
    "extra_hint": "Printed at the end of the document, before the signature.",
    "email": "Client's e-mail",
    "email_hint": "The link and the 6-digit confirmation code go here.",
    "days": "Link valid for",
    "days_n": "{n, plural, one {# day} other {# days}}",
    "legal": "Simple electronic signature (eIDAS, Regulation (EU) 910/2014, Art. 3(10)): the client reads the PDF, confirms with a code sent to their e-mail and signs with finger or mouse; an audit page (time, IP hash, browser, code channel, the document's SHA-256) is added. Where an insurer requires its own form or signature, that takes precedence.",
    "sent_title": "Sent for signature",
    "sent_emailed": "The link was e-mailed to {email}. You can also send it yourself (for example by WhatsApp):",
    "sent_link": "Send this link to the client:",
    "list_title": "Electronic signatures",
    "none": "Nothing sent for signature yet.",
    "status": {
      "sent": "sent",
      "opened": "opened",
      "signed": "signed",
      "cancelled": "cancelled",
      "expired": "expired"
    },
    "sent_on": "sent {date}",
    "signed_on": "signed {date}",
    "until": "valid until {date}",
    "collect": "Add to documents",
    "cancel": "Cancel",
    "collected": "{n, plural, one {A signed document was} other {# signed documents were}} added to the client's documents.",
    "err": {
      "esign_no_channel": "Add the client's e-mail: the confirmation code is sent there.",
      "esign_missing": "A title and the client's name are needed.",
      "esign_empty": "The document has no content.",
      "esign_not_configured": "Electronic signatures are not available on this server.",
      "email_invalid": "That e-mail address does not look right."
    },
    "doc": {
      "client": "Client",
      "name": "Full name",
      "needs": "Needs statement",
      "no_needs": "No needs analysis is recorded yet.",
      "analysis_date": "Needs analysis",
      "consent": "Consent to the processing of personal data (GDPR)",
      "proposal": "Proposal summary",
      "no_quotes": "No quotations are recorded yet."
    },
    "needs": {
      "declaration": "I confirm that the information above about my situation and needs is accurate and complete to the best of my knowledge, and that it was discussed with my advisor."
    },
    "proposal": {
      "declaration": "I confirm that I received and understood this summary of the proposal. It is not an insurance contract: the insurer's own documents, terms and acceptance apply."
    },
    "consent": {
      "controller": "Controller: my insurance advisor named at the top of this document, who keeps a client file in the AVRASTRO CRM.",
      "purposes": "Purposes: advice and intermediation for insurance, preparing quotations and applications, servicing and reviewing my policies, and keeping in contact about them.",
      "data": "Data: identification and contact details, family and financial information I give, and — only where needed for an application — health information, for which this is my explicit consent (GDPR Art. 9(2)(a)).",
      "recipients": "Recipients: the insurers I choose to apply to and the service providers the advisor uses for the CRM, under contract and EU data protection law.",
      "retention": "Retention: for as long as I am a client and afterwards only as long as the law requires.",
      "rights": "My rights: access, correction, erasure, restriction, portability and objection, and a complaint to the Commissioner for Personal Data Protection (Cyprus).",
      "withdraw": "I can withdraw this consent at any time by telling my advisor; this does not affect processing already done.",
      "declaration": "I have read the above and give my consent."
    }
  },
  "vcall": {
    "location": "AVRASTRO Video",
    "mode": "Meeting",
    "mode_physical": "In person",
    "mode_video": "Video call",
    "create_room": "Create an AVRASTRO Video room (a protected link for this appointment, with a waiting room)",
    "addon_needed": "AVRASTRO Video is an add-on that is not active for your subscription. You can paste your own video link in «Place».",
    "own_link": "Paste your video link (Zoom, Teams, Meet…) in «Place».",
    "guest_link": "Link for the client",
    "link_note": "Opens 15 minutes before the start ({from}); the client waits until you let them in. Not recorded.",
    "key_link": "Encryption key (confidential call)",
    "key_note": "The client’s link does not contain the key — nor do the e-mail, the calendar file or the website. Send this key link separately (SMS, phone), never in the same message.",
    "open_panel": "Video call",
    "panel_title": "Video call",
    "guest_waiting": "{name} is in the waiting room",
    "privacy_note": "The call runs in its own window. Nothing of the CRM is shared unless you choose «Shared View» or share a window yourself.",
    "open_call": "Open the call window",
    "open_here": "Open in this panel",
    "call_frame": "Video call",
    "lobby": "Waiting room",
    "lobby_empty": "Nobody is waiting.",
    "admit": "Admit",
    "deny": "Deny",
    "in_call": "In the call: {names}",
    "lock": "Lock the room",
    "unlock": "Unlock the room",
    "end_all": "End for everyone",
    "revoke": "New link (the old one stops working)",
    "shared_title": "Shared View",
    "shared_note": "The client sees only this client-safe summary of a Meeting Mode step — no commission, no private notes, no other clients.",
    "shared_step": "Meeting Mode step",
    "shared_preview": "What the client sees",
    "share_on": "Show to the client",
    "share_off": "Stop showing",
    "shared_on": "The client now sees the Shared View.",
    "shared_off": "The Shared View is hidden.",
    "chat_title": "Links in the call chat",
    "chat_esign_btn": "Send for signature",
    "chat_esign": "Document to sign",
    "chat_portal_btn": "Client portal link",
    "chat_portal": "Your documents in the client portal",
    "chat_posted": "The link was posted in the call chat.",
    "notes_title": "Notes and follow-ups",
    "notes_ph": "Notes of this meeting (private, never shown to the client)",
    "notes_private": "Saved on this client's meeting record, linked to the appointment.",
    "follow_ph": "Follow-up",
    "follow_by": "Who",
    "by_advisor": "Me",
    "by_client": "Client",
    "follow_add": "Add a follow-up",
    "notes_save": "Save notes",
    "meeting_finish": "Finish the meeting",
    "meeting_purpose": "Video consultation",
    "notes_saved": "Notes saved on the meeting record.",
    "meeting_saved": "Meeting saved; follow-ups are on the agenda.",
    "usage": "This month: {minutes} of {limit} participant-minutes (fair use)",
    "usage_warn": "over 80% — no extra charge",
    "no_recording": "AVRASTRO Video does not record, transcribe or summarise calls.",
    "ics_note": "AVRASTRO video call — opens in the browser:",
    "call_notes": "Notes from the call window",
    "call_notes_saved": "Saved on this client’s meeting record (the call window’s notes are never shown to the client).",
    "elsewhere_h": "Open the call in Safari or Chrome",
    "elsewhere_p": "This window cannot use the camera and microphone (for example a browser built into another app). Copy the host link and open it in Safari or Chrome.",
    "elsewhere_open": "Open in the browser",
    "elsewhere_once": "The host link works once, for 2 minutes. If it has expired, press «Open the call window» again.",
    "feedback_title": "The client’s rating",
    "feedback_stars": "{n} of 5 stars",
    "status": {
      "scheduled": "planned",
      "open": "open",
      "expired": "link expired",
      "ended": "ended",
      "cancelled": "cancelled"
    },
    "err": {
      "generic": "The video service answered: {code}",
      "video_not_entitled": "AVRASTRO Video is not part of your subscription (add-on).",
      "video_not_configured": "AVRASTRO Video is not set up on this server yet.",
      "video_too_early": "The call opens one hour before the appointment.",
      "video_not_open": "The call is not open (ended or expired).",
      "video_room_full": "The call is full (4 people at most).",
      "video_guest_state": "That person is no longer waiting.",
      "video_link_origin": "Only e-sign and client-portal links can be posted.",
      "network": "No connection to the AVRASTRO platform.",
      "rate_limited": "Too many attempts — please wait a minute."
    },
    "alert_waiting_title": "{names} is waiting for you in the video call",
    "alert_soon_title": "Video call in {minutes} minutes",
    "alert_join": "Join now",
    "alert_waiting_tab": "Someone is waiting",
    "alert_enable_notifications": "Notify me even in another tab: Turn on",
    "popup_blocked": "The browser blocked the new window — press «Open call window» in the panel."
  },
  "newsletter": {
    "audience": "Audience: newsletter subscribers",
    "audience_name": "Newsletter subscribers",
    "need_account": "Sign in to your AVRASTRO account (System → Account) to see the subscribers and send.",
    "unavailable": "Subscribers are not available right now ({code}).",
    "active": "Confirmed subscribers",
    "langs": "Language",
    "list": {
      "monthly": "Monthly newsletter",
      "alerts": "Change alerts"
    },
    "privacy_note": "Only people who confirmed their sign-up on avrastro.com (double opt-in). The addresses stay encrypted on the platform; here you see counts only. Every e-mail has a one-click unsubscribe link.",
    "new": {
      "monthly": "New monthly newsletter",
      "alerts": "New change alert"
    },
    "new_title": {
      "monthly": "Monthly newsletter",
      "alerts": "Change alert"
    },
    "body_start_el": "Γεια σας {name},\n\n",
    "body_start_en": "Hello {name},\n\n",
    "drafts": "Alert drafts waiting for approval",
    "drafts_hint": "Prepared because a guide on avrastro.com was updated. They are never sent automatically: open, check and send, or dismiss.",
    "open_draft": "Open to review",
    "dismiss": "Dismiss",
    "dismissed": "Draft dismissed.",
    "empty": "No newsletter yet. Start one with the buttons above.",
    "language": "Text language",
    "body": "Text",
    "body_hint": "{name} becomes the subscriber's first name (or is left out). Each subscriber gets the language they chose.",
    "footer_note": "Every e-mail automatically ends with: AVRASTRO is not an insurance company, and the personal unsubscribe link.",
    "problem": {
      "subject_el": "Greek subject missing",
      "subject_en": "English subject missing",
      "body_el": "Greek text too short",
      "body_en": "English text too short",
      "asks_for_data": "the text asks for personal data — remove it"
    },
    "send_test": "Send me a test",
    "send_list": "Send to subscribers",
    "test_first": "Send yourself a test first.",
    "confirm_send": "Send now to {n} subscribers? This cannot be undone.",
    "test_sent": "Test sent to {to}.",
    "sent": "Sent to {n} subscribers ({failed} failed).",
    "send_failed": "Sending failed ({code}).",
    "history": "Sends",
    "test": "test",
    "sent_line": "{n} sent · {failed} failed"
  },
  "whatsapp": {
    "title": "WhatsApp Business",
    "intro": "Appointment reminders, birthday wishes and renewal notices from your WhatsApp Business number, with the templates Meta approved. Only to clients who gave WhatsApp consent, only when you press «Send on WhatsApp» or turn on that one automation.",
    "need_account": "Sign in to your AVRASTRO account to connect a WhatsApp number.",
    "admin_only": "Only the office administrator can connect the WhatsApp number.",
    "connected": "Connected: {number} ({name}).",
    "webhook": "Meta webhook (callback URL): {url} · verify token: {token} · field: messages",
    "disconnect": "Disconnect the number",
    "phone_id": "Phone number ID",
    "phone_id_hint": "Meta → WhatsApp → API setup",
    "app_secret": "App secret",
    "app_secret_hint": "Meta app → Settings → Basic",
    "token": "Permanent access token",
    "token_hint": "System user token with whatsapp_business_messaging; sent once to the platform and stored there encrypted, never kept in the CRM.",
    "connect": "Connect the number",
    "connected_ok": "WhatsApp number connected.",
    "connect_failed": "Not connected ({code}). Check the token, the phone number ID and the app secret.",
    "enabled": "Use WhatsApp Business for clients with WhatsApp consent",
    "lang": "Language",
    "auto": "Send automatically",
    "bad_name": "A template name has lower-case letters, digits and _ only (as in Meta).",
    "reminder_hours": "Automatic reminder: hours before the appointment",
    "renewal_days": "Automatic renewal notice: days before the renewal",
    "privacy": "Only the template's parameters leave the CRM (first name, date, time, product name) — never amounts, policy numbers or health details. Automatic messages go out 09:00–20:00, once per client and occasion. Meta charges per conversation.",
    "send": "Send on WhatsApp",
    "send_title": "Send on WhatsApp",
    "what": "Message",
    "which_appointment": "Appointment",
    "preview": "Template {template} with: {params}",
    "send_note": "Sent from your WhatsApp Business number with the approved template; delivery is shown on the client's timeline.",
    "sent": "Sent on WhatsApp.",
    "send_failed": "WhatsApp did not accept the message — see the client's timeline.",
    "send_error": "Not sent ({code}).",
    "use": {
      "appointment_reminder": "Appointment reminder",
      "birthday": "Birthday wishes",
      "renewal_notice": "Renewal notice"
    },
    "params": {
      "appointment_reminder": "Approved template with (1) first name, (2) date, (3) time",
      "birthday": "Approved template with (1) first name",
      "renewal_notice": "Approved template with (1) first name, (2) product, (3) renewal date"
    },
    "block": {
      "off": "WhatsApp Business is off (Settings).",
      "no_template": "No approved template set for this message (Settings).",
      "no_consent": "No WhatsApp consent recorded for this client (Compliance → consent «WhatsApp»).",
      "consent_withdrawn": "The client withdrew WhatsApp consent.",
      "no_number": "No mobile number for this client.",
      "archived": "The client is archived.",
      "do_not_contact": "The client asked not to be contacted.",
      "not_found": "Choose an upcoming appointment with a time."
    },
    "consent_record": "The client agrees to WhatsApp messages — record the consent",
    "not_synced": "(The platform checks the synced data — if you changed this a moment ago, wait for sync and try again.)"
  },
  "voice": {
    "open": "Meeting summary from voice",
    "title": "Meeting summary from voice",
    "intro": "Record the meeting in the app; you get a draft summary and suggested tasks to review and edit. Nothing is saved before you press «Save». The audio is sent once for transcription and deleted right after; it is never kept in the CRM.",
    "consent_missing": "No consent to record meetings is on this client's card. Ask the client; if they agree, record it here.",
    "consent_withdrawn": "The client withdrew consent to record meetings. Do not record.",
    "consent_record": "The client agrees — record the consent",
    "consent_note": "Consent to record meetings for a written summary (audio deleted after transcription).",
    "consent_on_file": "Consent to record on file ({date}).",
    "confirm_now": "I asked the client now and they agree to this recording.",
    "record_intro": "Place the device between you. Up to {max} minutes.",
    "start": "Start recording",
    "stop": "Stop and summarise",
    "recording": "Recording",
    "privacy": "The audio goes once to the transcription service through the AVRASTRO platform and is deleted right after. Health and other sensitive details are flagged and left out unless you keep them.",
    "mic_denied": "The microphone is not available — allow it in the browser and try again.",
    "working": "Transcribing and summarising… this takes up to a minute.",
    "failed": "No summary ({code}). Nothing was saved.",
    "review_intro": "Review and edit. Only ticked lines and tasks are saved.",
    "meeting": "Save to meeting",
    "new_meeting": "A new meeting (today)",
    "summary": "Summary",
    "decisions": "Decisions",
    "tasks": "Suggested tasks",
    "keep": "Keep",
    "in_days": "in days",
    "sensitive": "Sensitive: {kinds}",
    "sensitive_hint": "Left out unless you tick it. Keep only what the insurance need requires.",
    "kind": {
      "health": "health",
      "beliefs": "beliefs",
      "origin": "origin",
      "sexual": "private life",
      "criminal": "criminal record",
      "identifier": "ID / bank number"
    },
    "review_note": "The draft comes from AI and can be wrong; it is yours once you save it.",
    "save": "Save",
    "discard": "Discard",
    "saved": "Meeting summary saved.",
    "timeline": "Meeting summary (from voice)",
    "off": "Meeting summaries from voice are not switched on for this office (the platform needs a transcription service — see the owner steps). Nothing was recorded.",
    "need_account": "Sign in to your AVRASTRO account to use meeting summaries.",
    "dictation_open": "Voice notes after the meeting",
    "mode": "What you record",
    "mode_meeting": "The meeting (with consent)",
    "mode_dictation": "My own notes",
    "dictation_intro": "After the meeting, say in your own words what was discussed. Your voice becomes meeting notes, tasks and a draft needs analysis — you check everything before it is saved. It works once the transcription service (TRANSCRIBE) is set up on the platform.",
    "dictation_confirm": "I am recording only my own voice — not the client.",
    "needs": "Needs for a draft needs analysis",
    "needs_note": "Those you keep become a draft (not final) needs analysis that you complete."
  },
  "help": {
    "title": "Help centre",
    "subtitle": "Guides for every screen, shortcuts and what is new.",
    "panel_title": "Help for this screen",
    "open": "Help",
    "this_screen": "Help for this screen",
    "open_centre": "Help centre",
    "search": "Search help…",
    "no_results": "No article found for “{q}”.",
    "no_context": "There is no article for this screen yet. Here are the basics:",
    "topics": "Help topics",
    "welcome_title": "How can we help?",
    "welcome_sub": "Start with one of these or search with a word.",
    "press_question": "Tip: press “?” on any screen for help about that screen.",
    "lesson_link": "Lesson: {title}",
    "keys": "Keys",
    "action": "Action",
    "where": "Where",
    "version": "Version {v}",
    "tab": {
      "articles": "Articles",
      "shortcuts": "Shortcuts",
      "new": "What's new",
      "ask": "Ask AVRASTRO · Help"
    },
    "group": {
      "start": "Getting started",
      "clients": "Clients & appointments",
      "sales": "Sales & compliance",
      "service": "Service & renewals",
      "growth": "Growth & production",
      "safety": "Data & safety",
      "settings": "Settings"
    }
  },
  "lessons": {
    "title": "Lessons",
    "subtitle": "{count} short lessons with steps, video and a quiz — at your own pace.",
    "progress": "{done} of {total} lessons completed",
    "continue": "Continue: {title}",
    "start": "Start: {title}",
    "minutes": "{n} min",
    "level": {
      "basic": "Basics",
      "daily": "Daily work",
      "advanced": "Advanced"
    },
    "done": "Completed",
    "quiz_score": "Quiz {correct}/{of}",
    "video_soon": "Video coming soon",
    "video_soon_sub": "Meanwhile, follow the steps below — they are the same as in the video.",
    "watch_in": "Watch in {lang}",
    "lang": {
      "el": "Greek",
      "en": "English",
      "ru": "Russian"
    },
    "of": "Lesson {n} of {total}",
    "all": "All lessons",
    "goal": "What you will learn",
    "steps": "Steps",
    "practice": "Try it: {screen}",
    "mark_done": "Mark as completed",
    "mark_undone": "Mark as not completed",
    "marked_done": "Lesson completed",
    "marked_undone": "Lesson marked as not completed",
    "read_more": "Read also",
    "nav": "Lesson navigation",
    "prev": "Previous",
    "next": "Next",
    "quiz": "Short quiz",
    "right": "Correct!",
    "wrong": "Not quite.",
    "check": "Check answers",
    "retry": "Try again"
  },
  "setup": {
    "step": {
      "profile": {
        "title": "Profile & ICCS registration",
        "sub": "Your register number, capacity and the classes you are registered for."
      },
      "office": {
        "title": "Office & availability",
        "sub": "Where and when you meet clients."
      },
      "clients": {
        "title": "Import clients",
        "sub": "Bring your clients in from Excel/CSV or from the old VÉRO."
      },
      "connect": {
        "title": "Calendar & e-mail",
        "sub": "Your appointments in Outlook and e-mails with clients on their history."
      },
      "bookings": {
        "title": "Bookings on avrastro.com",
        "sub": "Clients book online; you approve."
      },
      "modules": {
        "title": "Which tools you see",
        "sub": "Hide what you do not need — your data does not change."
      },
      "safety": {
        "title": "Backups & security",
        "sub": "A copy off the device, encryption and a safe sign-in."
      }
    },
    "title": "Set up AVRASTRO",
    "subtitle": "Seven short steps; skip any and come back whenever you like.",
    "help": "How it works",
    "steps_label": "Setup steps",
    "progress": "{percent}% done",
    "progress_aria": "Setup is {percent}% complete",
    "step_of": "Step {n} of {total}",
    "card_title": "Let's get your practice ready",
    "card_sub": "{done} of {total} steps done{skipped, plural, =0 {} other { · # skipped}}",
    "start": "Start setup",
    "continue": "Continue setup",
    "snooze": "Hide for a week",
    "snoozed": "The checklist will be back in a week — or open the Setup wizard any time.",
    "back": "Back",
    "skip": "Skip for now",
    "unskip": "Resume this step",
    "mark_done": "Done",
    "save_next": "Save and continue",
    "next": "Continue",
    "cancel": "Cancel",
    "saved": "Saved",
    "choose": "— choose —",
    "status": {
      "done": "Done",
      "skipped": "Skipped",
      "todo": "To do"
    },
    "finish": {
      "title": "Start checklist",
      "sub": "{done} of {total} steps done. The rest stay on the Now screen until you do or skip them.",
      "done_title": "You are all set!",
      "done_sub": "Setup is complete. The lessons show you the daily work step by step."
    },
    "to_today": "Go to Now",
    "reg_no": "ICCS register number",
    "reg_no_hint": "As shown in the intermediaries register of the Insurance Companies Control Service; it goes on documents for clients.",
    "capacity": "Capacity",
    "capacity_hint": "The capacity you are registered in.",
    "capacity_opt": {
      "tied_agent": "Tied insurance agent",
      "agent": "Insurance agent (several insurers)",
      "broker": "Insurance broker",
      "advisor_rep": "An intermediary's insurance advisor",
      "ancillary": "Ancillary insurance intermediary"
    },
    "lines": "Classes",
    "line": {
      "life": "Life insurance",
      "general": "General insurance",
      "life_sub": "Life, health, savings, pension — with the KYC/AML file and the tax centre.",
      "general_sub": "Motor, home, travel, business — with insured items and renewal stages."
    },
    "insurers": "Insurers you work with",
    "insurers_hint": "Separate with commas.",
    "profile_note": "These details go on your proposals, letters and profile; change them any time in Settings. AVRASTRO is not an insurer.",
    "https_hint": "A link starting with https://",
    "office_phone": "Office phone",
    "days": "Working days",
    "from": "From",
    "to": "To",
    "meeting_minutes": "Usual meeting length",
    "minutes": "{n} minutes",
    "modes": "Where you meet clients",
    "mode": {
      "office": "At the office",
      "online": "Online",
      "phone": "By phone",
      "client_place": "At the client's place",
      "cafe": "At a café"
    },
    "office_note": "The length becomes the default for new appointments; booking hours on avrastro.com are set in the Advisor Hub.",
    "clients_now": "{count, plural, =0 {You have no clients in AVRASTRO yet.} one {You have # client or prospect in AVRASTRO.} other {You have # clients and prospects in AVRASTRO.}}",
    "clients_demo": "(These are demo people — bring in your own.)",
    "clients_excel": "From Excel or CSV",
    "clients_excel_sub": "A client list, checked for duplicates before anything is saved.",
    "clients_vero": "From the old VÉRO CRM",
    "clients_vero_sub": "A backup (.json/.ICRM) with policies, tasks and documents.",
    "clients_one_sub": "One by one, with a warning for a duplicate phone or e-mail.",
    "clients_card_sub": "A photo of a business card from Quick add (“+”).",
    "connect_done": "Outlook is connected.",
    "connect_ready": "You can connect Outlook from your Account.",
    "connect_sign_in": "Connecting calendar and e-mail needs an AVRASTRO account. Without one, each appointment opens as an .ics file in your calendar.",
    "connect_outlook_sub": "CRM appointments in Outlook and on your phone; your busy times close booking times.",
    "connect_mail": "E-mails with clients",
    "connect_mail_sub": "E-mails with CRM clients appear on their history (optional).",
    "connect_ics": "Without connecting (.ics)",
    "connect_ics_sub": "From the Agenda, each appointment opens in your phone calendar.",
    "connect_note": "AVRASTRO never sends messages by itself; it opens drafts in your own apps.",
    "bookings_1": "On avrastro.com → Advisor Hub → Availability set days and hours.",
    "bookings_2": "With “Preview” you see your booking page; copy its address here.",
    "bookings_3": "Every request arrives in the Website inbox; it enters your agenda only when you confirm it.",
    "open_availability": "Open Availability on avrastro.com",
    "booking_url": "Your booking link",
    "copy": "Copy",
    "copied": "Copied",
    "copy_failed": "Could not copy — select the link and copy it.",
    "bookings_note": "Put the link in your e-mail signature, on social media or on your website.",
    "modules_both": "You are registered for life and general: all tools are shown.",
    "modules_life": "Life only: general-insurance tools (insured items, general renewal stages) are hidden.",
    "modules_general": "General only: life tools (KYC/AML, Protection, Tax Center) are hidden.",
    "change_lines": "Change classes",
    "modules_note": "Hiding only changes what you see; data stays and a hidden screen still opens from the Lens.",
    "safety_no_backup": "No backup file has been made on this device yet.",
    "safety_backup_age": "{days, plural, =0 {Last backup: today.} one {Last backup: # day ago.} other {Last backup: # days ago.}}",
    "safety_encrypted": "Data on this device is encrypted.",
    "safety_not_encrypted": "Data is not encrypted by AVRASTRO.",
    "safety_account": "Turn on two-step sign-in or a passkey for your account.",
    "practice_title": "Classes, registration and tools",
    "hidden_tools": "Hidden tools",
    "none_hidden": "None",
    "choose_tools": "Choose tools"
  },
  "cimport": {
    "field": {
      "displayName": "Full name",
      "firstName": "First name",
      "lastName": "Last name",
      "phone": "Phone",
      "email": "E-mail",
      "birthDate": "Birth date",
      "address": "Address",
      "city": "City",
      "occupation": "Occupation",
      "clientSince": "Client since",
      "notes": "Notes"
    },
    "title": "Import clients from Excel or CSV",
    "intro": "Choose an .xlsx or .csv file or paste rows with the header row. Check the column mapping and the preview — nothing is saved before you press “Import”.",
    "choose": "Choose file",
    "paste": "…or paste the rows here (with the header row)",
    "unreadable": "The file could not be read. Save it as .xlsx or CSV and try again.",
    "header_row": "The first row is headers",
    "column": "Column {n}",
    "ignore": "— ignore —",
    "kind": {
      "new": "New",
      "existing": "Already in AVRASTRO",
      "repeat": "Repeated in the file",
      "invalid": "No name"
    },
    "col": {
      "status": "Status",
      "notes": "Remarks"
    },
    "add_anyway": "Add {name} anyway",
    "match": {
      "phone": "Same phone as {name}",
      "email": "Same e-mail as {name}",
      "name": "Same name as {name}"
    },
    "problem": {
      "birth_date": "birth date ignored",
      "client_since": "“client since” ignored",
      "email": "invalid e-mail"
    },
    "more_rows": "…and {count} more rows.",
    "as": "Import as",
    "stage": {
      "client": "Clients",
      "prospect": "Prospects"
    },
    "safety": "Existing people are not changed. The whole import can be undone with Ctrl+Z.",
    "run": "{count, plural, =0 {Import} one {Import # person} other {Import # people}}",
    "done": "{count, plural, one {# person imported} other {# people imported}}",
    "card_title": "Import clients (Excel/CSV)",
    "card_sub": "A client list from another program or a spreadsheet, with a duplicate check.",
    "open": "Import clients"
  },
  "salefile": {
    "check": {
      "identity_disclosed": "Intermediary's identity & register number",
      "advice_disclosed": "Whether advice is provided",
      "complaints_info": "Complaints & out-of-court redress",
      "capacity_disclosed": "Capacity & insurers represented",
      "remuneration_disclosed": "Nature of remuneration",
      "demands_needs": "Demands and needs",
      "recommendation": "Personalised recommendation",
      "product_info": "Product information document",
      "kid": "Key information document (KID)",
      "costs_disclosed": "Costs and charges",
      "suitability": "Suitability assessment",
      "suitability_report": "Suitability statement",
      "kyc": "KYC/AML file complete",
      "privacy_notice": "Data-protection notice (GDPR)",
      "durable_medium": "On paper or a durable medium",
      "signed": "Signed proposal / application"
    },
    "check_hint": {
      "identity_disclosed": "Name, address, ICCS registration and how to check it (IDD art. 18).",
      "advice_disclosed": "Telling the client whether you advise on the products (IDD art. 18).",
      "complaints_info": "Complaints procedure and the Financial Ombudsman (IDD art. 18).",
      "capacity_disclosed": "Whether you act for the client or for insurer(s), and which (IDD art. 19).",
      "remuneration_disclosed": "A fee from the client, commission, other, or a combination (IDD art. 19).",
      "demands_needs": "Recorded in the field above; the product is consistent with them (IDD art. 20).",
      "recommendation": "Why the product best meets the needs (IDD art. 20).",
      "product_info": "IPID for general insurance (IDD art. 20(5)) or the insurer's pre-contractual information for life.",
      "kid": "For insurance-based investment products (PRIIPs regulation).",
      "costs_disclosed": "All costs and associated charges (IDD art. 29).",
      "suitability": "Knowledge & experience, financial situation incl. ability to bear losses, objectives and risk tolerance (IDD art. 30).",
      "suitability_report": "Given to the client before the contract (IDD art. 30).",
      "kyc": "From the client's KYC/AML tab.",
      "privacy_notice": "Processing notice and, where needed, consent.",
      "durable_medium": "The information was given on paper or a durable medium and the client kept a copy (IDD art. 23).",
      "signed": "The proposal form was signed by the client."
    },
    "title": "Sale files (IDD)",
    "subtitle": "Demands and needs, recommendation and client disclosures — one file per sale.",
    "how": "What is needed",
    "new": "New sale file",
    "stat": {
      "without": "Policies (12 months) without a file",
      "open": "Files in progress",
      "complete": "Complete files"
    },
    "without_title": "Policies without a file",
    "without_sub": "Active policies that started in the last 12 months.",
    "open_file": "Open a file",
    "without_empty": "Every recent policy has a sale file.",
    "open_title": "In progress",
    "open_sub": "What each file is missing.",
    "progress": "{percent}% complete",
    "missing": "Missing: {list}",
    "open_empty": "No file is waiting to be completed.",
    "done_title": "Complete files",
    "hide": "Hide",
    "view": "View",
    "done_empty": "No complete file yet.",
    "disclaimer": "An aid for your own file under Directive (EU) 2016/97 (IDD) and Cyprus Law 38(I)/2016 as amended — not legal advice. Your insurer’s rules and the Insurance Companies Control Service guidance come first. Files are never deleted.",
    "edit_title": "Sale file — {name}",
    "save": "Save file",
    "saved": "Sale file saved",
    "complete": "The file is complete",
    "client": "Client",
    "policy": "Policy",
    "no_policy": "— no policy yet —",
    "sale_date": "Sale date",
    "product": "Product",
    "insurer": "Insurer",
    "line_label": "Kind of sale",
    "line": {
      "life": "Life",
      "general": "General",
      "ibip": "Investment-based (IBIP)"
    },
    "line_hint": {
      "life": "Life, health, income protection — with the KYC/AML file.",
      "general": "Motor, home, travel, business — with the IPID.",
      "ibip": "Savings/investment (e.g. unit-linked): also suitability, costs and the KID."
    },
    "advice_label": "Advice",
    "advice": {
      "advised": "Advised",
      "non_advised": "Without advice"
    },
    "channel_label": "How",
    "channel": {
      "face_to_face": "Face to face",
      "distance": "At a distance"
    },
    "needs": "Needs analysis",
    "demands": "The client's demands and needs",
    "demands_hint": "What the client asked for and needs, in your own words (at least one sentence).",
    "recommendation": "Recommendation",
    "recommendation_hint": "Why the proposed product best meets these needs.",
    "checklist": "What the client was given, and when",
    "open_kyc": "Open KYC/AML",
    "auto_ok": "Filled in",
    "auto_todo": "Fill in the field",
    "given_on": "Date: {item}",
    "today": "Today",
    "document_for": "Document: {item}",
    "no_document": "— no document —",
    "notes": "Notes"
  },
  "nba": {
    "kind": {
      "settle_arrears": "First the overdue premium",
      "call_detractor": "Call before any offer",
      "resolve_service": "Close the open matter first",
      "request_terms": "Ask for renewal terms",
      "send_terms": "Send the comparison to the client",
      "follow_up_terms": "Call for a decision",
      "confirm_renewal": "Record the renewal",
      "explain_increase": "Explain the increase",
      "check_sum_insured": "Check the rebuild value",
      "renew_kyc": "Update the KYC file",
      "review_cover": "Book a review",
      "confirm_contact": "Give them a call",
      "prepare_renewal": "Prepare the renewal"
    },
    "why": {
      "settle_arrears": "{amount} open for {days} days — the cover is at risk before the renewal.",
      "call_detractor": "The client scored the service {score}/10 this year — listen first.",
      "resolve_service": "{count, plural, one {An open claim or request} other {# open claims or requests}} — a renewal talk lands badly while it is pending.",
      "request_terms": "Not started yet — ask the insurers for terms.",
      "send_terms": "The terms were compared — send them to the client.",
      "follow_up_terms": "The terms were sent {days} days ago with no answer.",
      "confirm_renewal": "The client approved — record “Renewed” so the premium is updated.",
      "explain_increase": "The new premium is {pct}% higher — explain it or look at alternatives.",
      "check_sum_insured": "For “{item}” the value is missing or looks low — an indicative under-insurance check.",
      "renew_kyc": "The KYC/AML file is incomplete or due — update it at the anniversary meeting.",
      "review_cover": "No review in the last 12 months — the anniversary is the moment.",
      "confirm_contact": "No recorded contact in the last 6 months.",
      "prepare_renewal": "All in order — prepare a short update for the client."
    },
    "also": {
      "settle_arrears": "overdue premium",
      "call_detractor": "low score",
      "resolve_service": "open matter",
      "request_terms": "terms",
      "send_terms": "send terms",
      "follow_up_terms": "awaiting answer",
      "confirm_renewal": "approved",
      "explain_increase": "premium increase",
      "check_sum_insured": "possible under-insurance",
      "renew_kyc": "KYC",
      "review_cover": "review",
      "confirm_contact": "no contact",
      "prepare_renewal": "renewal"
    },
    "title": "Next best action",
    "subtitle": "For each renewal of the next 60 days, the move worth making now.",
    "in_days": "renews in {days} d · {date}",
    "expired": "expired {days} d ago · {date}",
    "task_title": "{action}: {product}",
    "task_done": "Task added to today’s agenda",
    "task_exists": "In the agenda",
    "create_task": "Create task",
    "empty": "No renewals in the next 60 days.",
    "more": "Show {count} more"
  },
  "call": {
    "outcome": {
      "no_answer": "No answer",
      "busy": "Busy",
      "wrong_number": "Wrong number",
      "not_interested": "Not interested",
      "callback": "Call back later",
      "interested": "Interested",
      "meeting": "Meeting booked",
      "do_not_call": "Do not call"
    }
  },
  "calls": {
    "title": "Prospecting calls",
    "subtitle": "Call lists, a fast calling screen and your results — who answered, who wants a call back, where you booked a meeting.",
    "how": "How it works",
    "new_list": "New call list",
    "edit_list": "List settings",
    "goal_today": "Dials today",
    "goal_week": "Meetings this week",
    "streak": "{count, plural, one {# day in a row} other {# days in a row}}",
    "best": "best {count}",
    "goals_edit": "Goals",
    "goal_dials": "Dials per day",
    "goal_meetings": "Meetings per week",
    "max_attempts": "Most attempts per number",
    "max_attempts_hint": "After this many unanswered dials a number leaves the queue.",
    "no_lists": "No call list yet. Create one, paste numbers or import an Excel/CSV file.",
    "numbers": "Numbers",
    "to_call": "To call today",
    "dials": "Dials",
    "meetings": "Meetings",
    "dnc_short": "Do not call",
    "start": "Start calling",
    "import": "Import numbers",
    "open_list": "The list",
    "overdue_title": "{count, plural, one {# call-back is waiting} other {# call-backs are waiting}}",
    "overdue_sub": "You said “I’ll call you back” and the day has passed.",
    "call_now": "Call now",
    "privacy_title": "Privacy:",
    "privacy_note": "For each list record the lawful basis (consent or legitimate interest) and where the numbers came from. Anyone who asks not to be called again is marked “Do not call” and is never offered for a call again.",
    "privacy_settings": "Settings",
    "settings_title": "Prospecting calls",
    "legal_title": "Check the current rules:",
    "legal_note": "Rules on unsolicited marketing calls and on the data you keep change. AVRASTRO does not decide what is allowed: before you call a list, check the rules that apply in Cyprus today (for example the guidance of the Office of the Commissioner for Personal Data Protection) and your company’s instructions. Record where each list came from and respect every “do not call me again”.",
    "list_name": "List name",
    "list_name_hint": "e.g. “List A October”",
    "lawful_basis": "Lawful basis",
    "lawful_basis_hint": "On what basis you hold and call these numbers.",
    "basis": {
      "consent": "Consent",
      "legitimate_interest": "Legitimate interest",
      "existing_relationship": "Existing relationship",
      "unknown": "Not known"
    },
    "basis_missing": "no lawful basis recorded",
    "consent_source": "Source of the numbers / consent",
    "consent_source_hint": "e.g. “Expo 2026 visitor form”",
    "scripts": "Opening lines A / B",
    "scripts_hint": "Try two ways to open the call; “My improvement” shows which one books more meetings.",
    "variant": "Variant {v}",
    "script_title": "Short title",
    "script_opening": "What you say first",
    "script_notes": "Notes: questions, answers to objections",
    "save_and_import": "Save and import numbers",
    "import_dnc": "{count, plural, one {# number is “Do not call” and is not added} other {# numbers are “Do not call” and are not added}}",
    "legend_dnc": "Do not call",
    "session": "Calling",
    "made_session": "{count, plural, one {# dial} other {# dials}}",
    "booked_session": "{count, plural, one {# meeting} other {# meetings}}",
    "today_of": "Today {n} / {goal}",
    "left": "{count} left",
    "variant_mode": "Opening line",
    "alternate": "A/B in turn",
    "end_session": "Finish",
    "done_title": "Nobody left to call today",
    "done_sub": "In this session: {made} dials, {booked} meetings.",
    "reason": {
      "callback_due": "Call-back due",
      "followup_due": "Follow-up — interested",
      "new": "New number",
      "retry": "Another try"
    },
    "attempts": "{count, plural, one {# attempt} other {# attempts}}",
    "timer_start": "Start timer",
    "timer_stop": "End of call",
    "notes": "Notes",
    "history": "{count, plural, one {# earlier call} other {# earlier calls}}",
    "held_on": "Basis: {basis} · Source: {source}",
    "opening_line": "Opening line {v}",
    "no_script": "No opening line written for this variant yet.",
    "add_script": "Add one",
    "outcome": "Outcome",
    "when_meeting": "When is the meeting?",
    "when_callback": "When should you call back?",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "date": "Date",
    "time": "Time",
    "where": "Where",
    "duration": "Duration",
    "minutes": "{count} minutes",
    "book_meeting": "Book the meeting",
    "save_callback": "Save the call-back",
    "keys_hint": "Keys 1–8 for a quick outcome · Esc to leave",
    "skip": "Skip",
    "saved": "{name}: saved",
    "saved_callback": "{name}: the call-back is in your tasks",
    "saved_meeting": "{name}: the meeting is in your agenda",
    "task_callback": "Call back {name}",
    "task_followup": "Follow up {name} (interested)",
    "task_meeting": "Meeting with {name} (from a prospecting call)",
    "dnc_title": "“Do not call”: {name}",
    "dnc_body": "The number will no longer be offered for a call in any list, will not be added again by an import and is left out of campaigns by phone. Open call-backs are cancelled.",
    "dnc_yes": "Do not call",
    "dnc_on": "Do not call",
    "dnc_mark": "Mark “Do not call”",
    "dnc_clear": "Remove “Do not call”",
    "dnc_on_done": "Marked “Do not call”",
    "dnc_off_done": "“Do not call” removed"
  },
  "callstats": {
    "title": "My improvement",
    "subtitle": "How many calls you make, how many answer and how often you book a meeting — per day, week, month, list and opening line.",
    "pdf": "PDF",
    "list": "List",
    "all_lists": "All lists",
    "variant": "Opening line",
    "all_variants": "All opening lines",
    "period": {
      "week": "This week",
      "30d": "30 days",
      "month": "This month",
      "90d": "90 days",
      "year": "This year"
    },
    "per": {
      "day": "per day",
      "week": "per week",
      "month": "per month"
    },
    "kpi": {
      "dials": "Dials",
      "connect": "Answered",
      "conversations": "Conversations",
      "meetings": "Meetings",
      "meeting_rate": "Meeting per dial",
      "meeting_per_conv": "Meeting per conversation",
      "held_noshow": "Held / no-show",
      "show_rate": "Showed up",
      "sales": "Sales",
      "dials_per_meeting": "Dials per meeting",
      "avg_duration": "Average call length",
      "sales_premium": "Annual premium of sales"
    },
    "insights": "What your data shows",
    "insights_note": "Computed only from your own calls; when there is too little data, no conclusion is drawn.",
    "tone": {
      "good": "Good",
      "watch": "Watch",
      "info": "Info"
    },
    "insight": {
      "best_window": "Your meeting rate is higher between {window}: {rate}% of dials, against {overall}% overall.",
      "best_weekday": "Your best day is {weekday}: {rate}% meetings per dial, against {overall}% overall.",
      "variant_ratio": "Script {win} books {ratio}× more meetings than {lose} ({winRate}% against {loseRate}%).",
      "variant_only": "Only script {win} has booked meetings ({meetings}) — {lose} none so far.",
      "variant_even": "The two scripts give similar results (A {a}%, B {b}%).",
      "variant_more_data": "An A/B comparison needs at least {need} dials per script (now A {a}, B {b}).",
      "callbacks_overdue": "Many “call back later” are never followed up — {count} overdue.",
      "connect_low_window": "Only {rate}% of dials are answered; between {window} {best}% are.",
      "connect_low": "Only {rate}% of dials are answered; try other hours or days.",
      "no_shows": "{noShow} of {total} meetings were no-shows; a reminder the day before may help.",
      "meetings_unconfirmed": "{count} meetings have passed without being marked held or no-show.",
      "trend_up": "This week you book a meeting on {now}% of dials, up from {before}% in the four weeks before.",
      "trend_down": "This week your meeting rate fell to {now}% from {before}% in the four weeks before.",
      "dials_per_meeting": "On average you need {dials} dials for one meeting.",
      "streak": "You have reached your daily goal {days} days in a row.",
      "sales": "Your calls led to {sales} sales after {meetings} meetings held.",
      "no_data": "No calls in this period yet."
    },
    "funnel": "From call to sale",
    "step": {
      "dials": "Dials",
      "reached": "Answered",
      "conversations": "Conversations",
      "meetings": "Meetings booked",
      "held": "Meetings held",
      "sales": "Sales"
    },
    "trend": "Trend {per}",
    "rate_trend": "Meetings per dial (%)",
    "reached": "Answered",
    "empty": "No calls in this period.",
    "best_hours": "Best hours (meetings per dial)",
    "best_days": "Best days (meetings per dial)",
    "bar_tip": "{rate} meetings per dial · {meetings} meetings from {dials} dials · {connect} answered",
    "dials_n": "{count, plural, one {# dial} other {# dials}}",
    "bars_note": "Faded bars have fewer than 15 dials — too few to draw a conclusion yet.",
    "ab": "Opening line A / B",
    "by_list": "Per list",
    "no_list": "No list",
    "meetings_title": "Meetings from calls",
    "meetings_sub": "Mark whether each meeting was held or a no-show — that is how the show-up rate is measured.",
    "booked_on": "Booked on {date}",
    "state": {
      "held": "Held",
      "no_show": "No-show",
      "unconfirmed": "To confirm",
      "upcoming": "Upcoming",
      "cancelled": "Cancelled"
    },
    "mark_held": "Held",
    "mark_noshow": "No-show",
    "no_meetings": "No meetings booked in this period yet.",
    "definitions": "Answered: someone picked up. Conversation: call back, interested or meeting, or any answered call of 60 seconds or more. Sale: a policy of the person that started after the first dial.",
    "csv": {
      "day": "Day",
      "hour": "Hour",
      "name": "Name",
      "phone": "Phone",
      "seconds": "Seconds",
      "when": "Call-back / meeting"
    }
  },
  "gaps": {
    "title": "Protection-gap map",
    "subtitle": "Which clients have no cover recorded in each area — for information, not pressure.",
    "how": "How it is worked out",
    "empty": "No clients yet.",
    "area": {
      "life_cover": "Life cover",
      "income_protection": "Income protection",
      "beneficiaries": "Named beneficiaries",
      "health": "Health cover",
      "retirement": "Retirement savings",
      "mortgage": "Mortgage cover",
      "education": "Children’s studies"
    },
    "short": {
      "life_cover": "Life",
      "income_protection": "Income",
      "beneficiaries": "Benef.",
      "health": "Health",
      "retirement": "Retire.",
      "mortgage": "Loan",
      "education": "Studies"
    },
    "cell": {
      "ok": "recorded",
      "gap": "nothing recorded",
      "na": "not applicable"
    },
    "list_all": "{count, plural, one {# client with at least one gap} other {# clients with at least one gap}}",
    "list_area": "{area}: {count, plural, one {# client with nothing recorded} other {# clients with nothing recorded}}",
    "recorded_only": "Only what is recorded in AVRASTRO — cover held elsewhere is not known.",
    "campaign": "Information campaign",
    "client": "Client",
    "legend": "✓ recorded · ○ nothing recorded · – not applicable",
    "none": "No gaps here.",
    "disclaimer": "The map helps you organise information; it is not a recommendation. Every client decision follows a needs analysis.",
    "campaign_title": "Information: {area}",
    "wording_title": "How we write:",
    "wording_rules": "we inform and invite a check — no fear, no urgency, no products or prices. The client may simply not reply.",
    "language": "Message language",
    "channel": "Channel",
    "ch": {
      "email": "E-mail",
      "whatsapp": "WhatsApp",
      "sms": "SMS",
      "phone": "Phone",
      "letter": "Letter"
    },
    "subject": "Subject",
    "message": "Message",
    "message_hint": "The client’s first name and your name are filled in for each client.",
    "campaign_create": "Create the campaign",
    "campaign_note": "The campaign is created as a draft: the audience is frozen only with clients who consented to the channel, and no message is sent automatically.",
    "msg": {
      "life_cover": {
        "subject": "A short question about your family",
        "body": "Hello {first},\n\nI don’t see any life cover recorded in your file. You may have cover elsewhere — if so, I would simply like to note it. If you wish, we can look together, in 20 minutes, at what your family would need if your income were missing.\n\nIf you are not interested, there is nothing you need to do.\n\n{advisor}"
      },
      "income_protection": {
        "subject": "What happens to your income if you cannot work?",
        "body": "Hello {first},\n\nMany people don’t know what would happen if an illness or an accident kept them away from work for months. I have no income protection recorded in your file. If you wish, I can explain the options in a short meeting.\n\nIf you are not interested, there is nothing you need to do.\n\n{advisor}"
      },
      "beneficiaries": {
        "subject": "Are your beneficiaries up to date?",
        "body": "Hello {first},\n\nOn one of your life policies I don’t see named beneficiaries. It is a simple check worth doing, especially after changes in the family. If you wish, we can look at it together in a few minutes.\n\n{advisor}"
      },
      "health": {
        "subject": "Health cover — a short check",
        "body": "Hello {first},\n\nI don’t see a medical plan recorded in your file. If you have cover elsewhere (for example through your employer), I would like to note it; if not, I can explain what exists and how it works.\n\nIf you are not interested, there is nothing you need to do.\n\n{advisor}"
      },
      "retirement": {
        "subject": "Your retirement — a picture in a few minutes",
        "body": "Hello {first},\n\nI have no retirement savings recorded in your file. If you wish, we can look together at how much you may need and what is already there — with no commitment.\n\n{advisor}"
      }
    }
  },
  "auditpack": {
    "title": "Audit pack",
    "subtitle": "One click, for an ICCS or insurer audit: the sale files, disclosures, KYC, risk profiles and consents of a period.",
    "pdf": "PDF",
    "zip": "ZIP with documents",
    "zipping": "Preparing…",
    "zip_done": "The pack (ZIP) was saved · {count} files",
    "period": "Period",
    "preset": {
      "quarter": "Last quarter",
      "year": "This year",
      "12m": "12 months"
    },
    "from": "From",
    "to": "To",
    "files": "Sale files",
    "complete": "Complete",
    "open": "With gaps",
    "clients": "Clients",
    "kyc_incomplete": "KYC incomplete",
    "without_file": "Policies without a file",
    "files_title": "{count, plural, one {# sale file} other {# sale files}}",
    "chip_complete": "Complete",
    "missing_title": "What is missing",
    "nothing_missing": "Nothing is missing in this period’s files.",
    "contents": "The ZIP contains the pack as a page (open it and print to PDF), CSV tables and the linked documents from the vault.",
    "empty": "No sale files in this period.",
    "disclaimer": "An aid for your own file, not legal advice; whatever the ICCS or the insurer asks for comes first. Nothing in your data is changed.",
    "doc_title": "Sales compliance pack",
    "index": "Contents",
    "col": {
      "date": "Date",
      "client": "Client",
      "product": "Product",
      "kind": "Kind",
      "status": "Status",
      "item": "Item",
      "given": "Given",
      "document": "Document",
      "purpose": "Purpose",
      "granted": "Granted",
      "basis": "Lawful basis"
    },
    "kyc_title": "Know your client (KYC)",
    "kyc": {
      "none": "None",
      "incomplete": "Incomplete",
      "complete": "Complete"
    },
    "kyc_checked": "Checked",
    "kyc_next": "Next review",
    "kyc_beneficiaries": "Beneficiaries",
    "kyc_funds": "Source of funds",
    "kyc_none": "No KYC file.",
    "risk_none": "No risk profile linked.",
    "consents": "Consents",
    "documents": "Documents",
    "readme": "AVRASTRO — sales compliance pack\nPeriod: {from} – {to}\nSale files: {files}\npack.html: open it in a browser and print to PDF\n*.csv: the tables (sale files, disclosures, KYC, consents, documents)\ndocuments/: the documents linked to the files, from the vault"
  },
  "family": {
    "title": "Family map",
    "subtitle": "Spouse, children, parents, grandparents, godparents — and who pays for whom.",
    "add": "Add a relative",
    "edit": "Relative",
    "empty": "No relatives yet.",
    "rel": {
      "spouse": "Spouse",
      "partner": "Partner",
      "child": "Child",
      "parent": "Parent",
      "grandparent": "Grandparent",
      "grandchild": "Grandchild",
      "sibling": "Sibling",
      "godparent": "Godparent",
      "godchild": "Godchild",
      "other": "Other"
    },
    "client": "client",
    "baptism_on": "Baptism {date}",
    "policies": "{count, plural, one {# policy} other {# policies}}",
    "client_pays": "The client pays",
    "pays_for_client": "Pays for the client",
    "delete_confirm": "Remove “{name}” from the family map?",
    "relation": "Relation",
    "who": "Who",
    "who_name": "Just a name",
    "who_book": "A person in the book",
    "person": "Person",
    "name": "Name",
    "birth": "Date of birth",
    "baptism": "Baptism date",
    "baptism_hint": "For an anniversary reminder.",
    "pays": "Who pays",
    "pays_none": "—",
    "pays_pays_for": "The client pays for them",
    "pays_paid_by": "They pay for the client",
    "notes": "Note",
    "privacy": "Record only what you need to serve the family; no ID numbers or health details."
  },
  "radar34": {
    "title": "Life-event radar",
    "subtitle": "{count, plural, one {# event in the next 60 days} other {# events in the next 60 days}}",
    "item": {
      "milestone_birthday": "Turns {age}",
      "loan_ends": "The loan “{label}” ends",
      "policy_matures": "The policy “{label}” matures",
      "turns18": "{name} turns 18",
      "baptism": "Baptism anniversary: {name} ({years})",
      "transparency_day": "Transparency day: {years, plural, one {# year} other {# years}} together — the yearly summary",
      "risk_review": "The “{level}” profile no longer fits the time to the goal"
    },
    "today": "today",
    "in_days": "{count, plural, one {in # day} other {in # days}} · {date}",
    "task": "Task",
    "task_done": "Task created",
    "more": "+{count} more",
    "less": "Fewer"
  },
  "summary": {
    "meeting_open": "Personal meeting summary",
    "transparency_open": "Transparency summary",
    "meeting_studio": "Personal summary · {name}",
    "transparency_title": "Yearly transparency summary · {name}",
    "meeting": "Meeting",
    "no_meeting": "No meeting",
    "language": "Client’s language",
    "language_hint": "The summary is written in the language the client reads.",
    "remember_lang": "Remember",
    "lang_saved": "Client’s language saved",
    "title_label": "Title",
    "intro": "Opening",
    "closing": "Closing",
    "keep": "Include in the summary",
    "sensitive": "Sensitive",
    "sensitive_hint": "Looks like a health or other sensitive detail — it is left out unless you tick it.",
    "add_line": "Line",
    "add_step": "Next step",
    "preview": "What the client will see",
    "meeting_note": "Only what you tick reaches the client; your internal notes are never shown. The film script (JSON) can later become a short narrated video in the video pipeline.",
    "save_draft": "Save",
    "saved": "Summary saved",
    "print": "PDF",
    "portal": "To the client’s portal",
    "film": "Film script",
    "film_done": "Film script (JSON) saved",
    "published": "Published to the client’s portal",
    "portal_signed_out": "Sign in to your AVRASTRO account to publish to the portal.",
    "portal_no_link": "The client is not linked to an avrastro.com account; print the PDF or send it.",
    "portal_no_grant": "The client has not allowed posts to their portal page.",
    "portal_failed": "Publishing did not complete; try again.",
    "earlier": "{count, plural, one {# earlier summary} other {# earlier summaries}}",
    "status": {
      "draft": "draft",
      "final": "final",
      "shared": "shared"
    },
    "shared_on": "in the portal {date}",
    "meeting_title": "Our meeting of {date}",
    "meeting_intro": "Dear {name}, thank you for your time. Below you will find, in a few words, what we discussed, what we agreed and the next steps.",
    "meeting_closing": "For any question I am at your disposal.\n{advisor}",
    "discussed": "What we discussed",
    "agreed": "What we agreed",
    "next_steps": "Next steps",
    "step": "Step",
    "who": "Who",
    "when": "By",
    "who_advisor": "Your advisor",
    "who_client": "You",
    "thanks": "Thank you for your trust.",
    "film_cta": "I am here for any question",
    "not_advice": "This summary is for information and does not replace the terms of your policies.",
    "tr": {
      "title": "Yearly transparency summary {year}",
      "intro": "Dear {name}, as every year, here is a clear picture: all your policies, what you pay, who the beneficiaries are and what changed from {from} to {to}.",
      "closing": "If something no longer holds — a new family member, a change of job, a new loan — tell me and we will look at it together.\n{advisor}",
      "note": "Amounts are yearly, as recorded; your insurer’s terms and documents prevail.",
      "policies": "Your policies",
      "policy": "Policy",
      "insurer": "Insurer",
      "premium": "Premium",
      "year": "year",
      "renewal": "Renewal",
      "insured": "Insured",
      "beneficiaries": "Beneficiaries",
      "no_beneficiary": "Not named",
      "totals": "Total yearly premiums",
      "total_line": "Total: {amount} a year",
      "changes": "What changed",
      "no_changes": "No change in the period.",
      "change": {
        "new": "{date}: new policy “{label}”",
        "ended": "{date}: “{label}” — {status}",
        "premium": "{date}: “{label}” — premium from {before} to {after}",
        "claim": "{date}: claim “{label}”"
      },
      "status": {
        "lapsed": "lapsed",
        "cancelled": "cancelled",
        "matured": "matured",
        "other": "update"
      },
      "to_check": "To check together",
      "check_beneficiaries": "{count, plural, one {# life policy names no beneficiary.} other {# life policies name no beneficiary.}}",
      "advisor_note": "Advisor’s note",
      "advisor_note_hint": "Optional; one line per point.",
      "from": "Period from"
    }
  },
  "askhelp": {
    "title": "Ask AVRASTRO · Help",
    "subtitle": "Questions about how AVRASTRO works, answered from the help, the lessons and “What's new”.",
    "launcher": "Ask AVRASTRO about the app",
    "ai_badge": "AI",
    "disclosure": "Answers are written by an artificial intelligence (AI) system, only from the AVRASTRO help, and can contain mistakes; the article they point to is what counts.",
    "warning": "Do not paste client details (names, phone numbers, e-mails, ID numbers, IBANs, health). Ask about the screen or the task. Only the question is sent — never CRM data.",
    "label": "Your question about AVRASTRO",
    "placeholder": "e.g. How do I import clients from Excel?",
    "ask": "Ask",
    "thinking": "Searching the help…",
    "will_remove": "Before sending, {count, plural, one {# detail is} other {# details are}} removed (e-mails, phone numbers, numbers): “{q}”",
    "removed": "{count, plural, one {# detail was} other {# details were}} removed before sending.",
    "you": "You",
    "from_help": "From the help:",
    "open_screen": "Open: {label}",
    "kind_article": "Article",
    "kind_lesson": "Lesson",
    "kind_new": "What's new",
    "search_title": "From a search of the help",
    "off_not_signed": "Sign in to your AVRASTRO account for AI answers. Meanwhile, here is what the help says:",
    "off_not_configured": "The AI service is not set up. Here is what the help says:",
    "off_disabled": "The assistant is turned off for this workspace (Settings). Here is what the help says:",
    "off_failed": "The assistant did not answer. Here is what the help says:",
    "off_rate": "Too many questions in a short time — try again later. Here is what the help says:",
    "no_results": "Nothing in the help for “{q}”. Try another word or see the lessons.",
    "data_hint": "For questions about your data (e.g. “which clients have a renewal?”) use “Ask AVRASTRO”, which answers on this device.",
    "data_go": "Ask AVRASTRO",
    "ex1": "How do I import clients from Excel?",
    "ex2": "How do I make a backup?",
    "ex3": "What is the IDD sale file?",
    "clear": "Clear",
    "shortcut": "Ctrl+J or ⌘J",
    "settings_title": "“Ask AVRASTRO” — AI help",
    "settings_intro": "AI answers to questions about using AVRASTRO, only from the help, the lessons and “What's new”. Only the question is sent — e-mails, phone numbers, ID numbers and IBANs are removed before it leaves the device; client data is never sent.",
    "settings_enabled": "On for this workspace",
    "settings_ai_on": "The AI service is available.",
    "settings_ai_off": "The AI service is not available; the help search is shown instead.",
    "settings_need_account": "Needs you to be signed in to your AVRASTRO account.",
    "off_health": "Please do not write health details here — yours or a client's. The question was not sent. Ask in general about the screen or the task, e.g. “how do I record a claim?”."
  },
  "desktop": {
    "update": {
      "data_path": "Your data: {path}",
      "check": "Check for updates",
      "current": "Installed version: {version}",
      "intro": "AVRASTRO checks for a new signed version when it starts and when the connection comes back, and asks you before installing.",
      "card_title": "App updates",
      "not_configured": "Automatic updates are not active in this build. A later build will have them; until then install new versions manually.",
      "none": "You have the latest version.",
      "err_check": "Checking for updates failed (offline or the server is not reachable). It will be tried again automatically.",
      "err_generic": "The update did not complete (for example the connection dropped). The installed version and your data are unchanged. Try again.",
      "err_busy": "An update is already being installed.",
      "err_signature": "The update was refused: its signature is not valid. Nothing was changed. Please tell AVRASTRO support.",
      "snapshot_label": "Before updating to {version}",
      "downloading": "Downloading and checking the signature…",
      "saving": "Saving a recovery copy of your data…",
      "later": "Later",
      "retry": "Try again",
      "install": "Install and restart",
      "safe": "Your data stays on this computer as it is: the update replaces only the app. A recovery copy is also taken before installing. The app will close and open again.",
      "notes": "What’s new",
      "available": "Version {version} is available (you have {current}).",
      "title": "A new version of AVRASTRO"
    },
    "notify": {
      "renewals": "Policies up for renewal in the next 30 days: {n}",
      "overdue": "overdue: {n}",
      "due": "Tasks / follow-ups due today: {n}",
      "digest_title": "Today in AVRASTRO",
      "appt_body": "At {time} · {title}",
      "appt_title": "Appointment in {min} minutes",
      "test_failed": "The notice could not be shown. Check the system’s notification settings for AVRASTRO OS.",
      "test_sent": "Test notice shown. If you do not see it, check the system’s notification settings and «Do Not Disturb».",
      "test_body": "This computer will show AVRASTRO notifications while it is open.",
      "test_title": "Notifications work",
      "unavailable": "System notifications are not available in this version of the app. Install the latest one.",
      "denied": "The system does not allow notifications for AVRASTRO. Mac: System Settings → Notifications → AVRASTRO OS → Allow. Windows: Settings → System → Notifications → AVRASTRO OS.",
      "limits": "They work while AVRASTRO is open (also minimised). With the app closed nothing arrives on this computer — for that, turn notifications on at app.avrastro.com (browser or phone).",
      "on_state": "On",
      "turn_on": "Turn on notifications on this computer",
      "intro": "System notifications (Mac: Notification Center · Windows: notifications) for your appointments, the day’s tasks / follow-ups and renewals, from the data on this computer.",
      "title": "Notifications on this computer"
    }
  },
  "policy_delete": {
    "action": "Delete",
    "title": "Delete an incorrectly entered policy",
    "restore_title": "Restore a deleted policy",
    "word": "DELETE",
    "steps": "Steps",
    "step_password": "Password",
    "step_code": "Authenticator code",
    "step_confirm": "Confirm",
    "checking": "Checking that deletion can be secured…",
    "unavailable_title": "Deletion is not available here",
    "unavailable_offline": "This workspace has no AVRASTRO account, so a deletion cannot be confirmed and protected by the server. Sign in to an account to delete policies. You can mark the policy as cancelled — entered in error instead.",
    "unavailable_nosync": "Deletion is protected by the server through cloud sync, which is not on for this device. Turn on sync for this workspace, or mark the policy as cancelled — entered in error instead.",
    "mfa_title": "Set up an authenticator app first",
    "mfa_body": "Deleting a policy needs your password and a code from an authenticator app (2-step sign-in). Turn on 2-step sign-in for your account, then come back.",
    "mfa_setup": "Set up 2-step sign-in",
    "locked_until": "Try again after {time}.",
    "retry": "Try again",
    "intro": "For your security, confirm it is you. The policy is removed from lists, reports and statistics; it is kept on record and can be restored within {days} days.",
    "restore_intro": "Restoring a deleted policy needs the same confirmation: your password and an authenticator code.",
    "password": "Your AVRASTRO password",
    "password_hint": "The password you sign in to AVRASTRO with. Signed in through avrastro.com without a password? Use a passkey, or set a password with «Forgot password».",
    "use_passkey": "Use a passkey instead",
    "passkey_ok": "Passkey confirmed.",
    "code_intro": "Enter a new code from your authenticator app (not the one you just used to sign in).",
    "code": "Authenticator code",
    "code_hint": "6 digits. Recovery codes are not accepted here.",
    "verify": "Verify",
    "verified": "Identity confirmed. Finish within {seconds} s.",
    "identity": "The policy to delete",
    "product": "Product",
    "number": "Policy number",
    "issue": "Issue date",
    "premium": "Annual premium",
    "reason": "Reason",
    "reason_hint": "Required — e.g. «entered twice», «wrong client».",
    "type_word": "Type {word} to confirm",
    "soft_note": "Nothing is erased: the policy and everything linked to it are kept and hidden, and can be restored within {days} days.",
    "restore_reason": "Note (optional)",
    "confirm": "Delete policy",
    "restore": "Restore",
    "done": "The policy was deleted.",
    "done_pending": "The policy was deleted on this device; it will be confirmed by the server when you are online.",
    "restored": "The policy was restored.",
    "restore_until": "It can be restored until {date}.",
    "retained": "The restore period has passed; the policy stays hidden and is kept on record.",
    "deleted_on": "Deleted on {date}",
    "list_title": "{count, plural, one {# deleted policy} other {# deleted policies}}",
    "view": "View",
    "linked_none": "No other records are linked to this policy.",
    "linked_hidden": "Hidden with it (kept, back on restore):",
    "linked_kept": "Stay visible as history:",
    "error_alt": "Mark it instead as cancelled — entered in error. It stays visible with its history and is no longer counted as in force.",
    "mark_error": "Mark as entered in error",
    "marked_error": "Marked as cancelled — entered in error.",
    "entered_in_error": "Entered in error",
    "table": {
      "policy_adjustments": "Premium changes",
      "tasks": "Tasks and reminders",
      "documents": "Documents",
      "service_cases": "Service requests",
      "claims": "Claims",
      "production_events": "Production entries",
      "renewals": "Renewals",
      "commission_entries": "Commission entries",
      "premium_arrears": "Overdue premiums",
      "cases": "Applications",
      "sale_files": "Sale files"
    },
    "err": {
      "generic": "Could not complete ({code}).",
      "invalid_credentials": "The password is not correct.",
      "reauth_invalid": "The passkey could not be confirmed.",
      "passkey_cancelled": "The passkey request was cancelled.",
      "mfa_invalid": "The authenticator code is not correct or has expired.",
      "mfa_reused": "This code was already used. Wait for the next code in your app.",
      "mfa_enrolment_required": "Set up 2-step sign-in (authenticator app) first.",
      "stepup_locked": "Too many failed attempts. For your security, deletion is blocked for 15 minutes.",
      "rate_limited": "Too many attempts. Please wait a few minutes.",
      "policy_not_synced": "This policy has not reached the server yet. Wait for sync to finish and try again.",
      "policy_already_deleted": "This policy is already deleted.",
      "policy_not_deleted": "This policy is not deleted.",
      "restore_window_passed": "The restore period has passed.",
      "permission": "Your role cannot delete policies.",
      "network": "No connection to the server. Deletion needs to be online.",
      "stepup_required": "The server refused the change: confirmation missing. Nothing was deleted.",
      "stepup_invalid": "The server refused the change: invalid confirmation. Nothing was changed.",
      "stepup_expired": "The confirmation expired (5 minutes). Nothing was changed — please start again.",
      "stepup_used": "This confirmation was already used. Nothing was changed — please start again.",
      "stepup_mismatch": "The confirmation was for another policy, device or account. Nothing was changed.",
      "stepup_unavailable": "This sync server cannot secure deletions. Nothing was changed.",
      "stepup_window": "The restore period has passed. Nothing was changed.",
      "policy_delete_fields": "The server refused the deletion (check this device’s clock). Nothing was changed.",
      "policy_hard_delete": "Policies are never erased; use Delete in the policy record.",
      "policy_deleted_changed": "A deleted policy cannot be changed.",
      "refused": "The server refused the change. Nothing was changed."
    }
  },
  "sign_optin": {
    "label": "With my signature",
    "none": "Add your signature image in Branding to sign documents."
  },
  "rights": {
    "title": "{feature} is not included in your current plan",
    "body": "Your existing records stay here, read-only — nothing is hidden or deleted. Nothing is switched on or charged without you.",
    "lapsed_title": "{feature}: your subscription has ended",
    "lapsed_body": "Everything stays visible, read-only. Renew in Account to make changes again.",
    "in_plans": "Included in: {plans}",
    "in_addons": "Add-on: {addons}",
    "store": "Not included in your current subscription."
  },
  "notes": {
    "included": "Included in your plan",
    "upgrade": "Available as an upgrade: {plans}",
    "not_in_plan": "Not in your current subscription",
    "kind": {
      "security": "Security",
      "fix": "Fix"
    },
    "intro": "Security, compatibility and bug fixes reach everyone. New paid modules are marked: included in your plan, or available as an upgrade — they never switch on or charge by themselves.",
    "intro_store": "Security, compatibility and bug fixes reach everyone. Anything outside your subscription is marked — nothing switches on by itself.",
    "in_update": "In this update",
    "upgrade_hint": "Updating is free and keeps your data. Modules marked as an upgrade stay off until you choose a plan that includes them.",
    "upgrade_hint_store": "Updating is free and keeps your data. Anything outside your subscription stays off.",
    "binary_vs_rights": "Updates (security, compatibility, fixes) are for everyone, whatever your plan; they never change what you pay."
  },
  "maint": {
    "phase": {
      "upcoming": "Scheduled maintenance",
      "ongoing": "Maintenance in progress",
      "restored": "Service restored"
    },
    "window": "When: {window}",
    "your_zone": "your time ({zone})",
    "services": "Affected: {services}",
    "service": {
      "sync": "Sync between devices",
      "web_app": "Web app",
      "desktop_app": "Desktop app",
      "account": "Sign-in and account",
      "billing": "Billing",
      "website": "avrastro.com",
      "client_portal": "Client portal",
      "backups": "Cloud backups",
      "ai": "AI features",
      "notifications": "Notifications",
      "updates": "App updates"
    },
    "sync_warning": "You can keep working: changes made offline are kept on this device and sent when service returns.",
    "restored_body": "Everything is working again. Changes kept on this device are being sent now.",
    "dismiss": "Dismiss"
  },
  "sync_update": {
    "title": "Update AVRASTRO to keep syncing.",
    "body": "The server no longer accepts this version, so sync is paused to protect your data. Nothing is lost: changes on this device are kept and sent after the update.",
    "body_version": "The server no longer accepts this version, so sync is paused to protect your data. Version {version} or newer is needed. Nothing is lost: changes on this device are kept and sent after the update."
  },
  "recs": {
    "intro": "Up to three campaign ideas from your own book: the existing segments, consent, follow-up history, the calendar and market notes you stored with a source. Each one shows why it is suggested.",
    "never_sends": "Nothing is sent and nobody is contacted automatically. Approving creates the campaign with its consent-checked audience; you launch it and send each message yourself.",
    "none": "No suggestion right now: every theme either has no one with consent for it, is already running, ran in the last 90 days, or you set it aside.",
    "why": "Why this is suggested",
    "audience": "Audience",
    "eligible": "With consent for this channel",
    "in_segment": "In the segment",
    "recent": "Contacted by a campaign in the last 30 days",
    "no_eligible_channel": "Nobody in this segment has consent for this channel. Choose another channel.",
    "audience_note": "The same consent rules freeze the same audience when you approve (consent, withdrawal, channel, do-not-contact, contact details).",
    "goal_title": "Contact goal",
    "goal": "Contacts in total: {total} · about {perDay} per day · first contact spread over {days, plural, one {# working day} other {# working days}}.",
    "schedule": "Suggested schedule",
    "schedule_note": "From {start} to {end}. The dates become advisor tasks only when you launch the campaign.",
    "kpis": "How it will be measured",
    "kpi": {
      "contacts": "Contacts",
      "positive": "Positive replies (target)",
      "meetings": "Meetings (target)",
      "conversion": "Conversion to a policy (target)"
    },
    "kpi_measured": "measured from the first contacts",
    "kpi_basis_own": "Targets from your own past campaigns ({sample} contacts recorded).",
    "kpi_basis_none": "No target figures yet: your past campaigns have {sample} recorded contacts and at least {min} are needed. Nothing is assumed.",
    "market": "Market notes you stored",
    "draft": "Draft message (edit freely)",
    "title_field": "Campaign title",
    "message": "Message",
    "approve_check": "I approve: create this campaign and freeze its audience of {count} people with consent. Nothing is sent.",
    "approve": "Approve and create the campaign",
    "dismiss": "Not now (30 days)",
    "approved": "Campaign created — audience checked and frozen. Launch it when you are ready.",
    "dismissed": "Set aside for 30 days.",
    "inputs_title": "What the suggestions use — and what they never use",
    "inputs_used": "Used",
    "inputs_not_used": "Never used",
    "input": {
      "segments": "The existing smart segments of the Campaign Center (including the protection-gap segments), and only those named by a library theme.",
      "consent": "Marketing consent and its withdrawal, the consented channel, the do-not-contact list, «do not call» and whether a phone or e-mail exists.",
      "history": "Follow-up history: campaign contacts, replies, appointments and opt-outs, open campaign tasks, campaigns already running or run recently.",
      "season": "The calendar (for example the end of the tax year or the start of the school year) — dates only.",
      "market": "Market notes you stored yourself with their source and date. AVRASTRO never writes or invents market news.",
      "own_rates": "Your own past campaign results, only to set KPI targets and only with enough history."
    },
    "not_used": {
      "health": "Health conditions, medical answers and anything about a person’s health.",
      "smoker": "Smoker status.",
      "claims": "Claims.",
      "medical_documents": "Medical documents and medical requirements of applications.",
      "notes": "Notes and any free text.",
      "finances": "Income, savings or tax details beyond what an existing segment already uses."
    },
    "health_note": "The only health-related segments are the existing ones that look for a missing health policy («no medical cover recorded», «gap: health»); they never look at a condition.",
    "market_title": "Market notes (with a source)",
    "market_hint": "Add a development you read about, with its source and date, and the themes it concerns. It is quoted as you wrote it in the suggestions for 180 days.",
    "note_add": "Add a market note",
    "note_title": "What it says",
    "note_source": "Source (required)",
    "note_url": "Link (optional)",
    "note_date": "Publication date",
    "note_summary": "Short summary (optional)",
    "note_themes": "Relevant campaign themes",
    "note_save": "Save the note",
    "note_saved": "Market note saved.",
    "season": {
      "tax_year_end": "End of the tax year",
      "school_year": "New school year",
      "new_year": "Start of the year",
      "summer_travel": "Summer travel",
      "spring_home": "Spring home check"
    },
    "reason": {
      "segment": "People in the segment «{segment}»: {members} (out of {population} checked).",
      "consent": "Can be contacted on this channel under the consent rules: {eligible}; left out: {excluded}.",
      "cool_off": "Contacted by a campaign in the last {days} days: {count} — keep that in mind before contacting them again.",
      "last_run": "This theme last ran on {date} ({days} days ago).",
      "never_run": "You have not run this theme yet.",
      "season_tax_year_end": "Calendar: {month} is close to the end of the tax year.",
      "season_school_year": "Calendar: in {month} families prepare for the school year.",
      "season_new_year": "Calendar: {month} is the start of the year, a usual time for annual reviews.",
      "season_summer_travel": "Calendar: {month} is the summer travel season.",
      "season_spring_home": "Calendar: {month} is a usual time for a home check.",
      "market": "Your market note: «{title}» — {source}, {date}.",
      "incomplete": "May also fit but their data is incomplete (not included): {count}."
    }
  },
  "dayreport": {
    "title": "End-of-day report",
    "subtitle": "Filled in from what the CRM recorded today. Add your own totals only for work done outside the CRM.",
    "day": "Day",
    "recorded": "Recorded",
    "self": "My own entry",
    "self_short": "own",
    "total": "Counted",
    "metric": {
      "callsAttempted": "Calls attempted",
      "callsCompleted": "Calls completed",
      "peopleApproached": "People approached",
      "contactsCompleted": "Completed contacts",
      "positiveReplies": "Positive replies",
      "rejections": "Rejections",
      "meetingsBooked": "Meetings booked",
      "followupsCompleted": "Follow-ups completed"
    },
    "def": {
      "callsAttempted": "Every dial logged, plus call tasks completed for people with no dial logged that day.",
      "callsCompleted": "Calls that reached the person (an outcome other than no answer, busy or wrong number).",
      "peopleApproached": "Different people or prospects you contacted: calls, messages, campaign contacts, follow-ups with an outcome.",
      "contactsCompleted": "Different people with a real conversation, reply or booking.",
      "positiveReplies": "People whose last contact of the day was positive.",
      "rejections": "People whose last contact of the day was a no.",
      "meetingsBooked": "Different people with an appointment put in the agenda today.",
      "followupsCompleted": "Follow-up tasks completed today (campaign steps included)."
    },
    "below_recorded": "lower than recorded — the recorded number counts",
    "extra": "+{n} from my own entry",
    "self_hint": "Your own entry is your total for the day. The larger of the two counts — never the sum — so logging the same call later does not count it twice.",
    "goals": "Objectives",
    "goals_self": "Goals met",
    "of": "of",
    "rates": "Rates",
    "rate_def": {
      "goal_completion": "goals met ÷ goals",
      "response": "positive replies ÷ people approached",
      "appointment_conversion": "meetings booked ÷ completed contacts"
    },
    "campaigns": "Campaign outcomes",
    "campaign_line": "contacted {contacted} · replied {responded} · appointments {appointment} · opted out {opted_out} · tasks done {tasks}",
    "rating": "How was the day for you? (1–5)",
    "rating_hint": "Your own view — it is shown next to the numbers, never mixed into them.",
    "notes": "Notes",
    "feedback": "Feedback",
    "fb_show": "Show",
    "fb_hide": "Hide",
    "fb_own": "In my own words (optional)",
    "fb_own_hint": "What went well, what to try tomorrow…",
    "save": "Save the report",
    "saved": "End-of-day report saved.",
    "saved_at": "Saved {when}",
    "x_of_y": "{x} of {y} ({pct})",
    "no_denominator": "— (nothing to compare with yet)",
    "fb": {
      "quiet_day": "No activity was recorded today. If it was an office or rest day, that is fine.",
      "goals_all": "All {total} objectives reached ({met} of {total}).",
      "goals_most": "{met} of {total} objectives reached.",
      "goals_some": "{met} of {total} objectives reached. Tomorrow’s goals can be adjusted to what fits the day.",
      "goals_none": "None of the {total} objectives was reached today. Fewer or smaller goals tomorrow may fit better.",
      "small_day": "People approached: {count} — too few to read a rate into it.",
      "response_good": "{pos} of {appr} people replied positively.",
      "response_zero": "No positive reply from {appr} people today. Another time of day or a different opening line is worth a try.",
      "meetings": "Meetings booked today: {count}.",
      "followups": "Follow-ups completed: {count}.",
      "pending": "Tasks still open for today or earlier: {count} — you can move them below.",
      "low_rating": "You rated the day {rating} of 5. If you like, note what made it hard — it will show next to the monthly figures.",
      "high_rating": "You rated the day {rating} of 5."
    },
    "relationship": "Coffees / getting to know / referrals: {done} held · {planned} still planned",
    "relationship_hint": "Counted on their own: not added to appointments or to the rates."
  },
  "monthly": {
    "title": "Monthly performance",
    "subtitle": "Month by month, from the CRM records and your daily reports. Changes that happen together are not proof of an effect.",
    "month": "Month",
    "print": "Print / PDF",
    "partial": "month in progress",
    "activity_line": "active on {active} of {working} working days · daily reports saved: {reports}",
    "split": "recorded {recorded} · own {self}",
    "goals": "Objectives met / set",
    "campaigns": "Campaigns running",
    "rates": "Rates this month",
    "small_sample": "small sample (under {min}) — read with care",
    "rates_note": "Each rate shows its numerator and denominator. Goal completion = goals met ÷ goals; response = positive replies ÷ people approached; appointment conversion = meetings booked ÷ completed contacts; activity = days with activity ÷ working days.",
    "interpretation": "What the numbers show",
    "priorities": "Realistic priorities for next month",
    "no_cause": "These lines describe what happened at the same time; they do not show that one thing produced another.",
    "trend": "Activity by month (n = people approached)",
    "rate_trend": "Rates by month, % (n = people approached)",
    "chart_note": "A month with a small n can move a lot by chance.",
    "empty": "Nothing recorded in these months yet. Calls, tasks, meetings, campaign outcomes and daily reports appear here.",
    "table": "Month by month",
    "definitions": "Recorded figures are recomputed from the CRM for every day, so they always match the activity. Your own entries count only where they are higher than what was recorded that day.",
    "active_days": "Active days",
    "working_days": "Working days",
    "reports": "Daily reports",
    "avg_rating": "Average self-rating",
    "rate": {
      "goal_completion": "Goal completion",
      "response": "Response rate",
      "appointment_conversion": "Appointment conversion",
      "call_connect": "Calls with a conversation",
      "activity": "Activity level"
    },
    "line": {
      "no_data": "Nothing was recorded in {month}.",
      "activity": "Activity on {active} of {working} working days.",
      "activity_partial": "So far this month: activity on {active} of {working} working days.",
      "rate_small": "{rate}: {num} of {den} ({pct}) — fewer than {min}, too small a sample to read a change into it.",
      "rate_now": "{rate}: {num} of {den} ({pct}); the previous month has too little data to compare.",
      "rate_up": "{rate} was higher: {num} of {den} ({pct}) against {pnum} of {pden} ({ppct}) the month before (+{diff}).",
      "rate_down": "{rate} was lower: {num} of {den} ({pct}) against {pnum} of {pden} ({ppct}) the month before (−{diff}).",
      "rate_same": "{rate} stayed about the same: {num} of {den} ({pct}) against {pnum} of {pden} ({ppct}).",
      "per_day_up": "{metric}: {now} per working day against {prev} the month before ({total} against {ptotal} in total).",
      "per_day_down": "{metric}: {now} per working day against {prev} the month before ({total} against {ptotal} in total).",
      "coincided": "The higher {rate} coincided with campaigns running ({count}: {campaigns}). Happening at the same time does not show that the campaign produced it.",
      "limits": "Only what was recorded in the CRM is counted; work not logged does not appear (daily reports saved: {reports}).",
      "limits_self": "Includes your own entries on {days, plural, one {# day} other {# days}} (shown apart from the recorded figures); daily reports saved: {reports}."
    },
    "prio": {
      "fewer_goals": "Set about {perDay} objectives a day — what you reached on average ({num} of {den} this month).",
      "activity_days": "Plan contact time on {days} of the {working} working days next month (this month: {active} of {was}).",
      "response": "Try a different opening line or time of day — {num} of {den} replied positively ({pct}). «My improvement» shows your best hours.",
      "conversion": "In each positive conversation, offer two concrete meeting times — {num} of {den} completed contacts ended with a booking ({pct}).",
      "overdue": "Start the month with the overdue tasks and follow-ups ({count}).",
      "calls_target": "A realistic calls target: about {perDay} per working day (your average over the last active months ({months}) was {avg}).",
      "keep": "Keep the same rhythm — no shortfall stands out this month."
    },
    "relationship": "Coffees / getting to know",
    "relationship_hint": "coffee {coffee} · referral {referral} — not appointments"
  },
  "catalog": {
    "title": "Insurers & products",
    "hint": "Your own list: each insurer you work with → its product categories → each specific plan. New policies are chosen from it.",
    "show_inactive": "Show deactivated",
    "import": "Import from my policies",
    "import_nothing": "Nothing new to import — every insurer and product of your policies is already here.",
    "empty": "No insurers yet. Add the companies you work with, or import them from your policies.",
    "counts": "{categories, plural, one {# category} other {# categories}} · {plans, plural, one {# plan} other {# plans}}",
    "insurer_name": "Insurance company name",
    "add_insurer": "Add insurer",
    "note": "Deactivating hides an entry from new policies; policies that already have it keep it. An entry can be removed only while no policy uses it.",
    "saved": "Catalogue saved",
    "collapse": "Collapse",
    "expand": "Expand",
    "inactive": "deactivated",
    "kind": {
      "insurer": "Insurer",
      "category": "Product category",
      "plan": "Specific plan"
    },
    "policies": "{count, plural, =0 {no policies} one {# policy} other {# policies}}",
    "up": "Move {name} up",
    "down": "Move {name} down",
    "deactivate": "Deactivate",
    "reactivate": "Reactivate",
    "remove": "Remove {name}",
    "remove_hint": "Remove for good (nothing uses it)",
    "deactivated": "{name} deactivated",
    "reactivated": "{name} reactivated",
    "removed": "{name} removed",
    "category_name": "New category (e.g. Life Protection)",
    "category_name_for": "New category of {insurer}",
    "maps_to": "Policy type",
    "add_category": "Add category",
    "plan_name": "New plan (e.g. Life Plan 1)",
    "plan_name_for": "New plan in {category}",
    "add_plan": "Add plan",
    "edit_title": "Edit {kind}",
    "insurer_code": "Code (optional)",
    "plan_code": "Plan code (optional)",
    "branch_inherit": "As its category",
    "active_from": "Sold from",
    "active_to": "Sold until",
    "update_policies": "Also update {count, plural, one {the # existing policy} other {the # existing policies}} to the new name",
    "update_policies_category": "Also update the type of {count, plural, one {the # existing policy} other {the # existing policies}}",
    "history_kept": "{count, plural, one {The existing policy keeps} other {The # existing policies keep}} the name they were entered with (they stay linked to this entry).",
    "import_title": "Import insurers and products from what you already have",
    "import_confirm": "Import",
    "import_intro": "From your practice profile and your existing policies: {insurers, plural, =0 {no new insurer} one {# new insurer} other {# new insurers}}, {categories, plural, =0 {no new category} one {# new category} other {# new categories}}, {plans, plural, =0 {no new plan} one {# new plan} other {# new plans}}. Nothing is invented: only names already in your data.",
    "already": "already in the catalogue",
    "new": "new",
    "from_practice": "from your profile",
    "import_link": "Link the {count, plural, one {# existing policy} other {# existing policies}} to these entries (their text does not change)",
    "import_note": "Same names in different spelling (capitals, accents) are merged. Policies without an insurer are left out. Insurers typed in the profile step above are included once that step is saved.",
    "imported": "Imported: {insurers} insurers, {plans} plans",
    "choose": "Choose…",
    "other": "Other / not in my catalogue",
    "other_note": "Not in your catalogue: type it below. Tick «add to my catalogue» to have it next time.",
    "add_from_policy": "Add «{insurer}» and this product to my catalogue"
  },
  "studio": {
    "title": "AI Studio",
    "subtitle": "Posts, ads, stories and reels for your campaigns — every word set in your brand, every claim from your approved facts, nothing published without your approval.",
    "balance": "{total} of {allowance} credits",
    "balance_hint": "1 credit ≈ €0.01 of provider cost. The monthly allowance renews on the 1st.",
    "signed_out": "Sign in to your AVRASTRO account to use the studio (it needs the platform).",
    "not_configured_title": "The studio is not switched on yet",
    "not_configured_body": "The image and voice providers have not been connected to this platform yet.",
    "not_entitled_title": "AVRASTRO Studio is an add-on",
    "not_entitled_body": "Your subscription does not include the studio. It is available as the add-on «AVRASTRO Studio» or as a standalone plan.",
    "fonts_missing": "The brand fonts could not be loaded; the preview uses this computer’s fonts.",
    "never_posts": "The studio never posts or messages anyone by itself. Pictures are AI-generated where marked; product facts come only from your claims ledger.",
    "tab": {
      "create": "Create",
      "library": "Library",
      "reels": "Reels",
      "claims": "Claims ledger",
      "credits": "Credits"
    },
    "brief": "1. What do you want?",
    "brief_text": "Describe it in your own words",
    "brief_hint": "E.g. «a warm post for parents about planning their children’s studies». Never client names or health details.",
    "topic": "Topic",
    "audience": "Audience (a group, never a person)",
    "audience_hint": "Only the topic travels to the AI — never anyone’s records.",
    "tone": "Tone",
    "language": "Language",
    "cite_facts": "Approved facts this creative may state",
    "cite_hint": "Figures, benefits and cover only from ticked facts — anything else is blocked.",
    "page": "page",
    "until": "valid until {date}",
    "write_copy": "Write the copy ({credits} credit)",
    "removed": "{count, plural, one {# personal detail} other {# personal details}} removed before the AI",
    "ideas": "Campaign ideas",
    "template": "2. Template",
    "picture": "3. Picture",
    "variants": "{count, plural, one {# variant} other {# variants}}",
    "tier_standard": "Standard",
    "tier_premium": "Premium",
    "make_images": "Make pictures ({credits} credits)",
    "own_photo": "My own photo",
    "own_photo_licence": "own photo, rights declared by the user",
    "own_clip_licence": "own clip, rights declared by the user",
    "own_music_licence": "own music, licence declared by the user",
    "no_picture": "No picture",
    "working": "Working…",
    "picture_note": "The AI makes the picture only; every word is set by the template in your fonts. No real people’s likeness, no text inside pictures.",
    "edit": "Edit",
    "field": {
      "headline": "Headline",
      "subline": "Subline",
      "body": "Text",
      "cta": "Call to action",
      "caption": "Post text",
      "hashtags": "Hashtags",
      "script": "Voice-over",
      "ideas": "Ideas",
      "footer": "Footer",
      "labels": "Labels",
      "claims": "Cited facts",
      "title": "Title"
    },
    "contact": "Your contact line",
    "show_logo": "My logo",
    "show_mark": "AVRASTRO mark",
    "ai_label": "Label «{label}»",
    "marketing_label": "«Marketing communication» label (always on)",
    "font_template": "Template font",
    "colour_primary": "Main colour",
    "colour_accent": "Accent colour",
    "formats": "Sizes",
    "format_1x1": "Square 1:1",
    "format_4x5": "Feed 4:5",
    "format_9x16": "Story / reel 9:16",
    "format_16x9": "Wide 16:9",
    "format_banner": "Banner",
    "save_draft": "Save as draft",
    "save_changes": "Save changes",
    "saved": "Saved",
    "saved_reset": "Saved — the change needs a new approval",
    "approval_note": "Nothing can be exported, attached to a campaign or published until you approve it. Any later change needs a new approval.",
    "checks_ok": "Checks passed",
    "checks_blocked": "Fix these before review",
    "issue": {
      "number_without_claim": "{field}: «{quote}» — a figure without an approved fact",
      "risk_phrase": "{field}: «{quote}» — a promise no advisor may make",
      "medical_without_claim": "{field}: medical cover stated without an approved medical fact",
      "coverage_without_claim": "{field}: what a product covers, without an approved fact",
      "claim_expired": "A cited fact has expired or was retired",
      "claim_unknown": "A cited fact is not in the ledger",
      "footer_missing": "The note «General information, not advice.» is missing",
      "not_insurer_missing": "«AVRASTRO is not an insurer.» is missing",
      "marketing_label_missing": "The marketing label is missing",
      "ai_label_missing": "An AI-generated picture needs the AI label",
      "personal_data": "{field}: «{quote}» — personal contact details",
      "insurer_name": "{field}: «{quote}» — an insurer name (insurer branding is off)",
      "text_too_long": "{field}: too long for one of the sizes"
    },
    "review_title": "AI reviewer:",
    "review_pass": "no problems seen",
    "review_flags": "{count, plural, one {# point to look at} other {# points to look at}}",
    "review_advisory": "Advisory only: you decide and approve.",
    "for_campaign": "For the campaign «{title}»",
    "status_draft": "Draft",
    "status_in_review": "In review",
    "status_approved": "Approved",
    "status_archived": "Archived",
    "approved_by": "Approved by {who}, {date}",
    "superseded": "content changed since",
    "submit": "Send for approval",
    "approve": "Approve",
    "reject": "Ask for changes",
    "archive": "Archive",
    "restore": "Restore",
    "done_submit": "Sent for approval",
    "done_approve": "Approved",
    "done_reject": "Back to draft",
    "done_archive": "Archived",
    "done_restore": "Restored",
    "waiting_approval": "Waiting for an advisor’s approval.",
    "use": "Use it",
    "needs_approval": "Approve it first: then export, attach to a campaign or post it yourself.",
    "choose_campaign": "Choose a campaign…",
    "attach": "Attach",
    "attached": "Attached to the campaign",
    "detach": "Remove",
    "open_campaign": "Open the campaign",
    "copy_caption": "Copy the post text",
    "caption_copied": "Post text copied — post it from your own account",
    "handoff_note": "Publishing is yours: download the files and post them from your own accounts. Messages to clients still go through the Campaign Center with their marketing consent.",
    "provenance": "Provenance",
    "prov_ai": "Contains AI-generated media (labelled; marked in the exported files).",
    "prov_no_ai": "No AI-generated media.",
    "prov_kind_copy": "Copy",
    "prov_kind_review": "Review",
    "prov_kind_image": "Picture",
    "prov_kind_video": "AI footage",
    "prov_kind_voice": "Voice-over",
    "prov_kind_transcribe": "Transcription",
    "prov_kind_music": "Music",
    "c2pa_note": "Exports carry the IPTC «AI-generated» marking. C2PA Content Credentials are not signed yet (they need a certificate); the provenance is kept here.",
    "history": "History",
    "hist_create": "created",
    "hist_for_campaign": "made for a campaign",
    "hist_edit": "edited",
    "hist_edit_reset": "edited — approval reset",
    "hist_submit": "sent for approval",
    "hist_approve": "approved",
    "hist_reject": "changes asked",
    "hist_archive": "archived",
    "hist_restore": "restored",
    "hist_attach": "attached to a campaign",
    "hist_detach": "removed from a campaign",
    "hist_export": "exported",
    "hist_export_review": "exported — back to approval",
    "export_review": "The file was sent for approval: it is handed off for publishing only after the advisor or administrator checks it.",
    "export_to_review": "File to approve (this is what will be handed off for publishing)",
    "export_open": "Open the file",
    "all": "All",
    "library_empty": "No creatives yet.",
    "creative": "Creative",
    "campaign": "Campaign",
    "updated": "Updated",
    "kind_image": "Image",
    "kind_video": "Reel",
    "kind_story": "Story",
    "kind_carousel": "Carousel",
    "kind_copy": "Copy",
    "kind_presentation": "Presentation",
    "claims_title": "Claims ledger",
    "claims_intro": "Product facts you approved, each from a source document with its page and validity. A creative may state a figure, a benefit, an exclusion or a medical cover only from here.",
    "claims_empty": "No approved facts yet. Without them the studio writes general, educational copy only.",
    "retired": "retired",
    "retire": "Retire",
    "approved_on": "approved {date}",
    "claim_new": "New approved fact",
    "claim_plan": "Catalogue plan (optional)",
    "claim_product": "Product",
    "claim_statement": "The fact, as the source says it",
    "claim_statement_hint": "E.g. «Hospital cover up to €100,000 a year.» No client details.",
    "claim_source": "Source document (brochure, product sheet)",
    "claim_source_name": "Document name",
    "claim_valid_until": "Valid until",
    "claim_add": "Approve and add",
    "claim_added": "Fact added to the ledger",
    "claim_need_file": "Attach the source document first",
    "claim_note": "You approve this fact as true for the product until the date given. Facts are never deleted: they are retired.",
    "claim_field_topic": "topic",
    "claim_field_product": "product",
    "claim_field_statement": "the fact",
    "claim_field_source": "source",
    "claim_field_source_document": "source document",
    "claim_field_page": "page",
    "claim_field_valid_until": "valid-until date",
    "claim_field_valid_from": "valid-from date",
    "claim_field_personal_data": "no personal data",
    "credits_left": "Credits left",
    "credits_allowance": "This month",
    "credits_topup": "Top-ups",
    "credits_rules": "Hard limits on the server: no balance, no generation. A failed generation is refunded automatically. Unused monthly credits expire; top-ups stay until used.",
    "action_col": "Action",
    "credits_col": "Credits",
    "ledger": "Credit ledger",
    "ledger_empty": "No movements yet.",
    "led_allowance": "monthly allowance",
    "led_expire": "expired",
    "led_topup": "top-up",
    "led_charge": "used",
    "led_refund": "refund",
    "led_adjust": "adjustment",
    "action": {
      "copy": "Copy (post, captions, script)",
      "image_standard": "Picture, standard",
      "image_premium": "Picture, premium",
      "voice_30s": "Voice-over per 30 s",
      "transcribe_10min": "Transcription per 10 min",
      "reel_render": "Reel render",
      "music_ai": "AI music",
      "broll_fast": "AI b-roll shot (fast)",
      "broll_premium": "AI b-roll shot (premium)"
    },
    "confirm_title": "Use credits?",
    "confirm_body": "{action} will use about {credits} credits. Credits come back automatically if the provider fails.",
    "confirm_ok": "Use {credits} credits",
    "topic_life": "Life protection",
    "topic_medical": "Medical cover",
    "topic_child_savings": "Children’s savings",
    "topic_education": "Education",
    "topic_retirement": "Retirement",
    "topic_personal_accident": "Personal accident",
    "topic_income_protection": "Income protection",
    "topic_loan_protection": "Loan protection",
    "topic_generic": "General",
    "aud_general": "General public",
    "aud_parents_young_children": "Parents of young children",
    "aud_new_parents": "New parents",
    "aud_young_couples": "Young couples",
    "aud_young_professionals": "Young professionals",
    "aud_homeowners_mortgage": "Homeowners with a mortgage",
    "aud_self_employed": "Self-employed",
    "aud_business_owners": "Business owners",
    "aud_pre_retirees": "40–60, thinking of retirement",
    "aud_retirees": "Retirees",
    "aud_drivers_families": "Families who drive daily",
    "aud_homeowners": "Homeowners",
    "tone_warm": "Warm",
    "tone_professional": "Professional",
    "tone_energetic": "Energetic",
    "tone_calm": "Calm",
    "reels_off": "Reels are not available on this platform yet (the render worker is off).",
    "reel_clips": "Your clips",
    "reel_upload": "Upload clips",
    "ai_footage": "AI footage",
    "words": "{count, plural, one {# word} other {# words}}",
    "transcribe": "Transcribe ({credits} cr.)",
    "broll": "AI b-roll shot (premium)",
    "broll_note": "Seconds-long illustrative shots only; never realistic people presented as clients. Labelled as AI.",
    "broll_placeholder": "E.g. waves on a quiet beach at sunset",
    "broll_make": "Make the shot ({credits} credits)",
    "broll_clip": "AI shot",
    "reel_length": "Length: about {seconds} s",
    "reel_plan": "Pick the best moments",
    "reel_heuristic": "The choice is automatic and imperfect (clear, whole sentences in filmed order): check and remove parts.",
    "reel_total": "Reel length {seconds} s",
    "reel_title": "Title",
    "reel_default_title": "Reel",
    "voiceover": "Voice-over (optional)",
    "voiceover_hint": "Checked like every text: no figures without a fact, no promises.",
    "make_voice": "Make the voice-over ({credits} credits)",
    "music": "Music",
    "music_hint": "AVRASTRO’s own beds (no samples, nothing to license) or your own licensed track.",
    "music_none": "No music",
    "music_calm": "Calm",
    "music_warm": "Warm",
    "music_bright": "Bright",
    "music_own": "My own track",
    "music_upload": "Upload my licensed track",
    "transition": "Between clips",
    "transition_cut": "Cut",
    "transition_fade": "Dissolve",
    "vertical": "Vertical 9:16",
    "horizontal": "Horizontal 16:9",
    "captions": "{count, plural, one {# caption} other {# captions}}",
    "reel_render": "Make the reel ({credits} credits)",
    "rendering": "Rendering on the platform — about a minute for 30 s.",
    "reel_note": "Captions, titles and the end card are set by AVRASTRO in your fonts; the note «General information, not advice.» closes every reel.",
    "creatives": "Creatives",
    "create_for_campaign": "Create in the AI Studio",
    "no_creatives": "No creatives attached yet.",
    "choose_approved": "Choose an approved creative…",
    "only_approved": "Only approved creatives can be attached; a change after approval detaches nothing but needs a new approval before use.",
    "err": {
      "generic": "The studio could not do that ({code}).",
      "network": "No connection to the platform.",
      "plan_feature": "The studio is not part of your subscription.",
      "studio_not_configured": "The studio is not switched on on this platform.",
      "studio_credits_exhausted": "Not enough credits this month.",
      "studio_daily_cap": "Today’s safety limit is reached; try again tomorrow.",
      "studio_confirm_required": "Please confirm the credits first.",
      "studio_provider_failed": "The provider did not answer; your credits were refunded.",
      "studio_not_approved": "Only an approved creative can be used.",
      "studio_checks_failed": "The checks found something to fix (see the list).",
      "studio_sensitive": "The brief contains health details (a condition, diagnosis, medication or operation) — yours or someone else's, e.g. a client's. They are never sent to the AI. Describe the topic in general words (e.g. \"serious illness cover\"), without people.",
      "studio_audience": "The audience must be one of the listed groups.",
      "studio_type": "This file type is not accepted.",
      "too_large": "The file is too large.",
      "studio_storage_full": "The studio storage is full.",
      "licence_expired": "Your subscription has expired: existing creatives stay visible.",
      "permission": "Your role cannot do this.",
      "studio_approver_role": "Only an advisor or administrator approves.",
      "studio_hash_mismatch": "The creative changed meanwhile; reload it.",
      "studio_status": "The creative is no longer in that state; reload it.",
      "studio_claim": "The fact needs: {fields}.",
      "studio_claim_unknown": "A cited fact is not in the ledger.",
      "studio_job_failed": "The render failed; your credits were refunded.",
      "studio_job_timeout": "The render is taking too long; check the library later.",
      "campaign_not_found": "That campaign is not in this workspace.",
      "studio_reel_length": "A reel is at most 60 seconds."
    }
  },
  "phonecal": {
    "title": "Phone calendar",
    "intro": "Your appointments and plan in the iPhone or Android calendar, tied to your AVRASTRO account. Each category is a separate calendar, so you can give it its own colour on the phone.",
    "need_account": "Sign in to your AVRASTRO account (with sync): the platform serves the calendar from your synced data.",
    "account": "Account",
    "workspace": "Workspace",
    "last_fetch": "Last read by a phone",
    "never": "not yet",
    "detail": "What the events show",
    "detail_initials": "Only the type and the client's initials (e.g. «Appointment · M.G.») — recommended",
    "detail_full": "Your title, the client's name and the place",
    "detail_note": "Never notes, phone numbers, health or policy details. With full details the title shows as you wrote it — so keep sensitive details out of titles.",
    "create": "Create the calendar links",
    "created": "The links are ready",
    "saved": "Saved — the phone shows it at its next refresh",
    "subscribe": "Subscribe (iPhone)",
    "all_or_each": "Choose either «All» or the separate ones (a colour per category) — not both, or you see each event twice.",
    "what": {
      "all": "Everything in one calendar",
      "appointments": "CRM appointments",
      "plan": "Your plan: coffee / referral, preparation, learning, team, admin, travel",
      "calls": "Calls and follow-ups",
      "personal": "Breaks and personal time"
    },
    "qr_alt": "QR code for the calendar {name}",
    "qr_hint": "Scan with the iPhone camera to subscribe. On Android use the https link in Google Calendar (on a computer).",
    "qr_for": "QR for",
    "regenerate": "New link",
    "regenerate_confirm": "The current links stop working at once; you will need to add the calendars to the phone again. Continue?",
    "regenerated": "New links — the old ones no longer work",
    "revoke": "Turn off",
    "revoke_confirm": "The links stop at once; on the phone the calendars stay empty or show an error — remove them there. Continue?",
    "revoked": "Phone calendar turned off",
    "err": "Not done ({code})",
    "iphone": {
      "1": "On the iPhone, open this page and tap «Subscribe (iPhone)» — or scan the QR code with the camera.",
      "2": "Or by hand: Settings → Calendar → Accounts → Add Account → Other → Add Subscribed Calendar, and paste the link.",
      "3": "Tap «Next», name it if you like and choose a colour — one per calendar.",
      "4": "Under «Auto-refresh» choose «Every hour» (or as often as you like).",
      "5": "Repeat for each category you want (or only «All»)."
    },
    "android": {
      "1": "Google Calendar adds calendars from a link only on a computer: open calendar.google.com with the phone's Google account.",
      "2": "On the left: «Other calendars» → «+» → «From URL».",
      "3": "Paste the https link («Copy» button) and click «Add calendar».",
      "4": "In the calendar's settings choose a colour; on the phone: Google Calendar → Settings → the calendar → «Sync» on.",
      "5": "Google refreshes such calendars every few hours (up to a day) — a change does not show at once."
    },
    "note_colour": "Colour: iPhone and Google colour a whole calendar, not single events — that is why each category is its own calendar.",
    "note_refresh": "Refresh: the phone asks by itself (iPhone usually every 15 minutes to an hour, Google every few hours); not instant.",
    "note_readonly": "Read only: changes are made in the CRM, not on the phone.",
    "note_sync": "What has been synced with the platform shows (sync on), from 30 days back to 6 months ahead.",
    "note_privacy": "The link is a secret: anyone who has it sees the calendar. Do not share it; «New link» or «Turn off» stop it at once. The data stays on the AVRASTRO platform; the phone keeps a copy.",
    "note_future": "Two-way sync with Google / Outlook (changes from the phone back into the CRM) needs our own OAuth apps at Google / Microsoft — a future option."
  },
  "taxf": {
    "title": "My tax folder",
    "subtitle": "Your own documents and receipts as a self-employed advisor, per tax year — ready for your accountant.",
    "year": "Tax year",
    "private": "Private folder: only you see it. Managers, assistants and other team members do not, unless you share it.",
    "shared_by": "A colleague’s folder shared with you — read only.",
    "shared_list": "Shared with you",
    "not_client": "This is about your own business, not clients. For client tax planning:",
    "open_taxc": "Tax Center",
    "start": "Open the {year} folder",
    "start_hint": "One folder per year: collect receipts and certificates here all year and at the end send your accountant one tidy ZIP.",
    "created": "The {year} folder is open; a reminder was added to the agenda.",
    "add": "Add a document",
    "add_manual": "Without a file",
    "choose": "Choose files",
    "camera": "Take a photo",
    "drop": "Drop PDFs or photos (JPG, PNG, HEIC) here — or choose files.",
    "drop_active": "Release to add the files",
    "unsupported": "«{name}» is not a PDF, JPG, PNG or HEIC file.",
    "too_large": "«{name}» is larger than {mb} MB.",
    "reading": "Reading the document…",
    "queue": "Document {n} of {total}",
    "stored": "The document was stored in the folder.",
    "saved": "Saved.",
    "deleted": "Removed from the folder.",
    "overview": "By category",
    "all_categories": "All categories",
    "count": "{count, plural, one {# document} other {# documents}}",
    "missing_n": "{count} missing",
    "other_currencies": "and in other currencies: {list}",
    "total": "Total in EUR",
    "files_n": "{count, plural, one {# file} other {# files}}",
    "items": "Documents and receipts",
    "search": "Search (issuer, note, amount, date)",
    "empty": "No document in this year yet.",
    "no_match": "No document matches.",
    "checklist": "What I expect — checklist",
    "checklist_empty": "Add what comes regularly (e.g. social insurance every month) to see what is missing.",
    "still_missing": "Still missing",
    "nothing_missing": "Nothing you expect is missing.",
    "show_done": "Show received ones too",
    "upload_for": "Upload",
    "waive": "Not needed",
    "unwaive": "Restore",
    "notes": "Notes for the accountant",
    "notes_ph": "e.g. “The car is used ~70% for work”, “March was paid in April”.",
    "accountant": "My accountant",
    "accountant_name": "Name",
    "accountant_email": "E-mail",
    "export_zip": "ZIP for the accountant",
    "exporting": "Building the ZIP…",
    "exported": "The ZIP was created ({files} files).",
    "export_missing_files": "{count} files are not on this device and are missing from the ZIP (see index.csv).",
    "mail_draft": "Draft e-mail to the accountant",
    "mail_title": "Draft message to the accountant",
    "mail_note": "Nothing is sent automatically. Open it in your mail app, attach the ZIP and send it yourself.",
    "mail_open": "Open in mail",
    "mail_copy": "Copy the text",
    "mail_copied": "The text was copied.",
    "mark_sent": "I sent it to the accountant",
    "sent_on": "Sent to the accountant on {date}",
    "share": "Share",
    "share_title": "Share the {year} folder",
    "share_hint": "Only team members with these e-mails will be able to read the folder (not change it). Remove an e-mail to stop the access.",
    "share_emails": "Members’ e-mails (one per line)",
    "shared_with": "Shared with: {list}",
    "quick": "Quick add",
    "quick_title": "Regular documents of the year",
    "quick_hint": "Creates the expected slots in the checklist — one per month, quarter or year. Adding them again never duplicates them.",
    "quick_category": "What you expect",
    "quick_subject": "Company / body (optional)",
    "quick_subject_ph": "e.g. “Test Insurance (fictional)”",
    "quick_add": "Add to the checklist",
    "quick_added": "{count, plural, one {# slot was} other {# slots were}} added to the checklist.",
    "quick_none": "They are all there already — nothing was added.",
    "freq": {
      "monthly": "Every month (12)",
      "quarterly": "Every quarter (4)",
      "annual": "Once a year"
    },
    "cert": "Annual certificate of premiums",
    "cert_title": "Certificate of premiums — one per policy of your own",
    "cert_hint": "If you are also a client in your own CRM, pick yourself to find your life, pension and health policies. Otherwise type them by hand.",
    "cert_me": "Me as a client (optional)",
    "cert_manual": "Policies by hand (one per line)",
    "cert_manual_ph": "e.g. “Life — Test Insurance (fictional) — 12345”",
    "cert_none": "No life, pension or health policy was found for this person.",
    "categories": "Categories",
    "categories_title": "Categories of {year}",
    "categories_hint": "Rename or hide categories and add your own. They apply to this year; a new year takes them from the previous one.",
    "cat_hidden": "Hidden",
    "cat_custom": "My own category",
    "cat_new": "New category",
    "cat_group": "Group",
    "form_new": "New document",
    "form_edit": "Folder document",
    "prefilled": "Some fields were filled in from the document’s text. Check them and correct what is needed — they are stored only when you press “Save”.",
    "from_doc": "from the document",
    "no_text": "The document has no text to read (e.g. a photo or a scan) — fill in the fields.",
    "field": {
      "date": "Date",
      "amount": "Amount",
      "currency": "Currency",
      "issuer": "Issuer / vendor",
      "category": "Category",
      "subcategory": "Subcategory",
      "declare": "To declare?",
      "status": "Status",
      "notes": "Note for the accountant",
      "files": "Files",
      "expected": "Answers the expected document",
      "period": "Period"
    },
    "none": "— none —",
    "declare_hint": "Your own marking for the accountant — AVRASTRO does not judge what is deductible.",
    "declare": {
      "yes": "Yes",
      "no": "No",
      "ask": "Ask the accountant"
    },
    "status": {
      "missing": "Missing",
      "received": "Received",
      "checked": "Checked",
      "waived": "Not needed"
    },
    "mark_checked": "Mark as checked",
    "add_file": "Add a file",
    "open_file": "Open",
    "detach": "Remove the file",
    "detach_confirm": "Remove the file from the folder?",
    "delete": "Remove the document",
    "delete_confirm": "Remove this document and its files from the folder? You can undo it right after.",
    "file_missing": "The file is not on this device.",
    "read_only": "Read only",
    "reminder": "Reminder in the agenda: {date}",
    "reminder_title": "Prepare the {year} tax folder",
    "reminder_add": "Remind me in March",
    "hints": "Useful information (Cyprus)",
    "hint_mark": "to be confirmed by your accountant",
    "hints_disclaimer": "Organising documents — not tax advice. AVRASTRO does not compute tax or judge what is deductible; the information comes from public sources (checked 29 Oct 2026) and may change.",
    "sources": "Sources",
    "cat_hints": "About this category",
    "help_card": "Collect your own tax documents of the year in a private folder and send them to your accountant as one ZIP.",
    "business_card": "My {year} tax folder",
    "business_card_sub": "{items} documents · {missing} missing",
    "open": "Open",
    "group": {
      "income": "Income",
      "contributions": "Contributions",
      "insurance": "Insurance premiums",
      "business": "Business expenses",
      "personal": "Personal allowances",
      "other": "Other"
    },
    "cat": {
      "commissions": "Income — commission statements",
      "social_insurance": "Social insurance (self-employed)",
      "gesy": "GHS (GeSY) contributions",
      "provident_pension": "Provident and pension contributions",
      "life_insurance": "Life insurance premiums and certificate",
      "medical_insurance": "Medical insurance",
      "home_insurance": "Home insurance (natural disasters)",
      "professional_indemnity": "Professional indemnity insurance",
      "licence_fees": "Licence, register and professional bodies",
      "cpd_training": "CPD and training",
      "office_rent_utilities": "Office rent and utilities",
      "car_fuel": "Car and fuel",
      "phone_internet": "Phone and internet",
      "equipment": "Equipment",
      "software_subscriptions": "Software and subscriptions (the CRM too)",
      "marketing": "Marketing",
      "travel": "Travel",
      "accounting_legal": "Accounting and legal fees",
      "bank_charges": "Bank charges",
      "housing": "Rent or mortgage interest of the main home",
      "green_ev": "Energy upgrade / electric vehicle",
      "donations": "Donations",
      "other": "Other"
    },
    "sub": {
      "premium": "Premium receipt",
      "annual_certificate": "Annual certificate of premiums",
      "supervisor": "Supervisory authority",
      "professional_body": "Professional association",
      "registration": "Registration / renewal",
      "rent": "Rent",
      "electricity": "Electricity",
      "water": "Water",
      "cleaning": "Cleaning",
      "common_charges": "Common charges",
      "other": "Other",
      "fuel": "Fuel",
      "service": "Service",
      "insurance": "Insurance",
      "road_tax": "Road tax",
      "parking": "Parking",
      "mortgage_interest": "Mortgage interest"
    },
    "hint": {
      "deadline_2025": "Tax return 2025 (T.D.1): on TAXISnet, due 31 Oct 2026 (Decree 260/2026); no interest or charges if filed and paid by 30 Nov 2026 (Commissioner’s decision, 19 Oct 2026).",
      "deadline_2026": "From tax year 2026: return through Tax For All, by 31 July 2027; every tax resident aged 25 to 70 must file, whatever their income.",
      "accounts_deadline": "Those with audited/reviewed accounts have a different deadline; e.g. announcement of 26 Mar 2026: extended from 31 Mar to 30 Apr 2026.",
      "audit_threshold_2026": "From 2026 the threshold for compulsory audited accounts of individuals rises to €120,000 (from €70,000).",
      "threshold_2025": "For 2025: tax-free band €19,500.",
      "threshold_2026": "For 2026: tax-free band €22,000 (from €19,500) and new bands of 20% / 25% / 30% / 35%.",
      "family_2026": "New personal allowances from 2026 with family income limits (€100,000 with no or 1–2 children, €150,000 with 3–4, €200,000 with 5+, €40,000 single): children (€1,000 / €1,250 / €1,500), rent or mortgage interest (up to €2,000), energy upgrade/EV (up to €1,000). Condition: a return filed on time.",
      "one_fifth": "Social insurance, GHS, provident/pension funds, medical schemes and life premiums are deductible together up to 1/5 of income — the rule applies in 2025 and from 2026.",
      "self_employed_rates": "Self-employed (2025): social insurance 16.6% of insurable income; GHS 4%.",
      "life_7pct": "Life premiums: counted up to 7% of the sum insured. Keep the insurer’s annual certificate of premiums.",
      "incapacity_2026": "From 1 Jan 2026 premiums for permanent or temporary, total or partial incapacity are deductible too (same 7% limit).",
      "home_insurance_2026": "From 1 Jan 2026: home insurance premiums against natural disasters (fire, earthquake, flood) up to €500 a year, for any home in Cyprus, with no income criteria.",
      "housing_2026": "From 2026: rent or mortgage interest of the main home in Cyprus up to €2,000 per spouse/partner; rent must be paid electronically (transfer, card), state subsidies are deducted.",
      "green_2026": "From 2026: energy upgrade of the main home, solar PV/batteries, a new electric vehicle or charger up to €1,000 a year per spouse/partner; the rest carries forward up to 4 years.",
      "subscriptions": "Trade union and professional body subscriptions: deductible (2025 table); the 2026 guide does not mention them.",
      "donations": "Donations to approved charities: deductible with receipts (2025 table).",
      "business_use": "Your accountant judges what relates to your business and to what extent (e.g. a car or phone also used privately). Write the business use in the note."
    },
    "export": {
      "title": "Tax folder {year} — Summary",
      "generated": "Created: {at}",
      "disclaimer": "Organising documents — not tax advice",
      "disclaimer_more": "The advisor collected the documents in AVRASTRO. The “To declare?” column is their own marking; the accountant makes the final judgement. No tax was computed.",
      "totals": "Totals per category",
      "category": "Category",
      "count": "Count",
      "total_eur": "Total (EUR)",
      "to_declare": "To declare",
      "missing_n": "Missing",
      "all": "Total",
      "no_conversion": "Amounts in other currencies are shown apart — nothing was converted.",
      "documents": "List of documents",
      "date": "Date",
      "issuer": "Issuer",
      "amount": "Amount",
      "declare": "To declare?",
      "status": "Status",
      "files": "Files",
      "notes": "Note",
      "no_file": "no file",
      "none": "No document.",
      "missing": "Still missing",
      "nothing_missing": "Nothing expected is missing.",
      "advisor_notes": "The advisor’s notes",
      "footer": "ZIP contents: one folder per category, files named YYYY-MM-DD_category_issuer_amount, index.csv (UTF-8) and this summary.",
      "no": "No.",
      "subcategory": "Subcategory",
      "currency": "Currency",
      "period": "Period"
    },
    "mail": {
      "subject": "Tax folder {year} — {name}",
      "greeting": "Hello {name},",
      "intro": "here are the documents of tax year {year} for my return.",
      "attached": "Attached: {file} (one folder per category, index.csv and the SYNOPSI.html summary).",
      "counts": "It holds {items} documents ({files} files), total in EUR {total}.",
      "missing": "Still missing ({n}):",
      "nothing_missing": "Nothing I expected is missing.",
      "notes": "Notes:",
      "closing": "Thank you,"
    },
    "upcoming": "Upcoming",
    "show_all": "All categories"
  }
}
